"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6525],{

/***/ 97478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ MAX_AMOUNT_TRANSFER_NFT; },
/* harmony export */   "T9": function() { return /* binding */ NFT_TYPE; },
/* harmony export */   "Vd": function() { return /* binding */ CAKE_PER_YEARV2; },
/* harmony export */   "ZM": function() { return /* binding */ BOOSTED_FARM_GAS_LIMIT; },
/* harmony export */   "hJ": function() { return /* binding */ BSC_BLOCK_TIME; },
/* harmony export */   "o3": function() { return /* binding */ DEFAULT_TOKEN_DECIMAL; },
/* harmony export */   "v7": function() { return /* binding */ LIMIT_VOTING; }
/* harmony export */ });
/* unused harmony exports BASE_BSC_SCAN_URLS, CAKE_PER_BLOCK, BLOCKS_PER_DAY, BLOCKS_PER_YEAR, CAKE_PER_YEAR, CAKE_PER_BLOCKV2, BLOCKS_PER_YEARV2, BASE_URL, BASE_ADD_LIQUIDITY_URL, DEFAULT_GAS_LIMIT, AUCTION_BIDDERS_TO_FETCH, RECLAIM_AUCTIONS_TO_FETCH, AUCTION_WHITELISTED_BIDDERS_TO_FETCH, startTimeStake, IPFS_GATEWAY, AMOUNT_FULL_POOL, BASE_BSC_SCAN_URL, BASE_BSC_URL, URL, TRANDING_FEE, TRANSFER_FEE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var utils_getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27750);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1505);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70794);




var BSC_BLOCK_TIME = 3;
var _obj;
var BASE_BSC_SCAN_URLS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC, "https://bscscan.com"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, "https://testnet.bscscan.com"), _obj);
// CAKE_PER_BLOCK details
// 40 CAKE is minted per block
// 20 CAKE per block is sent to Burn pool (A farm just for burning cake)
// 10 CAKE per block goes to CAKE syrup pool
// 9 CAKE per block goes to Yield farms and lottery
// CAKE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// CAKE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
var CAKE_PER_BLOCK = 0.0001735;
var BLOCKS_PER_DAY = 60 / BSC_BLOCK_TIME * 60 * 24;
var BLOCKS_PER_YEAR = BLOCKS_PER_DAY * 365 // 10512000
;
var CAKE_PER_YEAR = CAKE_PER_BLOCK * BLOCKS_PER_YEAR;
var CAKE_PER_BLOCKV2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(0.0001735);
var BLOCKS_PER_YEARV2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(60 / BSC_BLOCK_TIME * 60 * 24 * 365) // 10512000
;
var CAKE_PER_YEARV2 = CAKE_PER_BLOCKV2.times(BLOCKS_PER_YEARV2);
var BASE_URL = "https://board.runtogether.net";
var BASE_ADD_LIQUIDITY_URL = "".concat(BASE_URL, "/add");
var DEFAULT_TOKEN_DECIMAL = (0,utils_getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_0__/* .getFullDecimalMultiplier */ .t)(18);
var DEFAULT_GAS_LIMIT = 250000;
var BOOSTED_FARM_GAS_LIMIT = 500000;
var AUCTION_BIDDERS_TO_FETCH = 500;
var RECLAIM_AUCTIONS_TO_FETCH = 500;
var AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500;
var startTimeStake = 1662469200000;
var LIMIT_VOTING = 100;
var IPFS_GATEWAY = "https://ipfs.io/ipfs";
var AMOUNT_FULL_POOL = "2500000";
var BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC];
var BASE_BSC_URL = BASE_BSC_SCAN_URLS[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC];
var URL = (/* unused pure expression or super */ null && ("https://api-dev.runtogether.net"));
var TRANDING_FEE = 3;
var TRANSFER_FEE = 5;
var MAX_AMOUNT_TRANSFER_NFT = 50;
var NFT_TYPE = {
    "DIAMOND": 4,
    "GOLD": 3,
    "SILVER": 2,
    "BRONZE": 1
};


/***/ }),

/***/ 203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xo": function() { return /* binding */ useCakeVault; },
  "uf": function() { return /* binding */ useCakeVaultPublicData; },
  "Es": function() { return /* binding */ useCakeVaultUserData; },
  "eB": function() { return /* binding */ useVaultPoolByKey; }
});

// UNUSED EXPORTS: useDeserializedPoolByVaultKey, useFetchIfo, useIfoCeiling, useIfoCredit, usePool, usePoolsPageFetch, usePoolsWithVault

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/farms/constants/index.ts
var constants = __webpack_require__(37971);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var config_constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(33533);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 32 modules
var state = __webpack_require__(106);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 6 modules
var state_pools = __webpack_require__(21557);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/pools/helpers.ts + 1 modules
var helpers = __webpack_require__(71390);
;// CONCATENATED MODULE: ./src/utils/cakePool.ts

var isStaked = function(param) {
    var userShares = param.userShares;
    return userShares && userShares.gt(0);
};
var isLocked = function(param) {
    var userShares = param.userShares, locked = param.locked;
    return isStaked({
        userShares: userShares
    }) && Boolean(locked) // && !isAfter(new Date(lockEndTime * 1000), new Date())
    ;
};
var isLockedEnd = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() >= parseInt(lockEndTime) * 1000 && Date.now() <= new Date(parseInt(lockEndTime) * 1000).getTime() + pools/* UNLOCK_FREE_DURATION */.by * 1000;
};
var isAfterBurning = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() > new Date(parseInt(lockEndTime) * 1000).getTime() + pools/* UNLOCK_FREE_DURATION */.by * 1000;
};
var VaultPosition;
(function(VaultPosition) {
    VaultPosition[VaultPosition["None"] = 0] = "None";
    VaultPosition[VaultPosition["Flexible"] = 1] = "Flexible";
    VaultPosition[VaultPosition["Locked"] = 2] = "Locked";
    VaultPosition[VaultPosition["LockedEnd"] = 3] = "LockedEnd";
    VaultPosition[VaultPosition["AfterBurning"] = 4] = "AfterBurning";
})(VaultPosition || (VaultPosition = {}));
var getVaultPosition = function(params) {
    if (isAfterBurning(params)) {
        return VaultPosition.AfterBurning;
    }
    if (isLockedEnd(params)) {
        return VaultPosition.LockedEnd;
    }
    if (isLocked(params)) {
        return VaultPosition.Locked;
    }
    if (isStaked(params)) {
        return VaultPosition.Flexible;
    }
    return VaultPosition.None;
};

;// CONCATENATED MODULE: ./src/state/pools/selectors.ts










var selectPoolsData = function(state) {
    return state.pools.data;
};
var selectPoolData = function(sousId) {
    return function(state) {
        return state.pools.data.find(function(p) {
            return p.sousId === sousId;
        });
    };
};
var selectUserDataLoaded = function(state) {
    return state.pools.userDataLoaded;
};
var selectVault = function(key) {
    return function(state) {
        return key ? state.pools[key] : state_pools/* initialPoolVaultState */.XW;
    };
};
var selectIfo = function(state) {
    return state.pools.ifo;
};
var _credit;
var selectIfoUserCredit = function(state) {
    return (_credit = state.pools.ifo.credit) !== null && _credit !== void 0 ? _credit : bigNumber/* BIG_ZERO */.HW;
};
var selectors_makePoolWithUserDataLoadingSelector = function(sousId) {
    return createSelector([
        selectPoolData(sousId),
        selectUserDataLoaded
    ], function(pool, userDataLoaded) {
        return {
            pool: transformPool(pool),
            userDataLoaded: userDataLoaded
        };
    });
};
var poolsWithUserDataLoadingSelector = (0,reselect_es/* createSelector */.P1)([
    selectPoolsData,
    selectUserDataLoaded
], function(pools, userDataLoaded) {
    return {
        pools: pools.map(helpers/* transformPool */.xK),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolByKey = function(key) {
    return (0,reselect_es/* createSelector */.P1)([
        selectVault(key)
    ], function(vault) {
        return (0,helpers/* transformVault */.LJ)(key, vault);
    });
};
var selectors_poolsWithVaultSelector = (0,reselect_es/* createSelector */.P1)([
    poolsWithUserDataLoadingSelector,
    makeVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault),
    makeVaultPoolByKey(types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault), 
], function(poolsWithUserDataLoading, deserializedLockedCakeVault, deserializedFlexibleSideCakeVault) {
    var pools = poolsWithUserDataLoading.pools, userDataLoaded = poolsWithUserDataLoading.userDataLoaded;
    var cakePool = pools.find(function(pool) {
        return !pool.isFinished && pool.sousId === 0;
    });
    var withoutCakePool = pools.filter(function(pool) {
        return pool.sousId !== 0;
    });
    var cakeAutoVault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedLockedCakeVault), {
        vaultKey: types/* VaultKey.CakeVault */.om.CakeVault,
        userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedLockedCakeVault.userData)
    });
    var lockedVaultPosition = getVaultPosition(deserializedLockedCakeVault.userData);
    var hasFlexibleSideSharesStaked = deserializedFlexibleSideCakeVault.userData.userShares.gt(0);
    var cakeAutoFlexibleSideVault = lockedVaultPosition > VaultPosition.Flexible || hasFlexibleSideSharesStaked ? [
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedFlexibleSideCakeVault), {
            vaultKey: types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault,
            userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedFlexibleSideCakeVault.userData)
        }), 
    ] : [];
    return {
        pools: [
            cakeAutoVault
        ].concat((0,_to_consumable_array/* default */.Z)(cakeAutoFlexibleSideVault), (0,_to_consumable_array/* default */.Z)(withoutCakePool)),
        userDataLoaded: userDataLoaded
    };
});
var selectors_makeVaultPoolWithKeySelector = function(vaultKey) {
    return createSelector(selectors_poolsWithVaultSelector, function(param) {
        var pools = param.pools;
        return pools.find(function(p) {
            return p.vaultKey === vaultKey;
        });
    });
};
var selectors_ifoCreditSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfoUserCredit
], function(ifoUserCredit) {
    return new bignumber/* default */.Z(ifoUserCredit);
});
var selectors_ifoCeilingSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfo
], function(ifoData) {
    return new bignumber/* default */.Z(ifoData.ceiling);
});

;// CONCATENATED MODULE: ./src/state/pools/hooks.ts















var lPoolAddresses = pools/* livePools.filter */.$$.filter(function(param) {
    var sousId = param.sousId;
    return sousId !== 0;
}).map(function(param) {
    var earningToken = param.earningToken;
    return earningToken.address;
});
// Only fetch farms for live pools
var getActiveFarms = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainId) {
        var farmsConfig;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    return [
                        2,
                        farmsConfig.filter(function(param) {
                            var token = param.token, pid = param.pid, quoteToken = param.quoteToken;
                            return pid !== 0 && (token.symbol === "BUSD" && quoteToken.symbol === "WBNB" || lPoolAddresses.find(function(poolAddress) {
                                return poolAddress === token.address;
                            }));
                        }).map(function(farm) {
                            return farm.pid;
                        })
                    ];
            }
        });
    });
    return function getActiveFarms(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var usePool = function(sousId) {
    var poolWithUserDataLoadingSelector = useMemo(function() {
        return makePoolWithUserDataLoadingSelector(sousId);
    }, [
        sousId
    ]);
    return useSelector(poolWithUserDataLoadingSelector);
};
var usePoolsWithVault = function() {
    return useSelector(poolsWithVaultSelector);
};
var usePoolsPageFetch = function() {
    var ref = useAccount(), account = ref.address;
    var dispatch = useAppDispatch();
    useFetchPublicPoolsData();
    useFastRefreshEffect(function() {
        batch(function() {
            dispatch(fetchCakeVaultPublicData());
            dispatch(fetchCakeFlexibleSideVaultPublicData());
            dispatch(fetchIfoPublicDataAsync());
            if (account) {
                dispatch(fetchPoolsUserDataAsync(account));
                dispatch(fetchCakeVaultUserData({
                    account: account
                }));
                dispatch(fetchCakeFlexibleSideVaultUserData({
                    account: account
                }));
            }
        });
    }, [
        account,
        dispatch
    ]);
    useEffect(function() {
        batch(function() {
            dispatch(fetchCakeVaultFees());
            dispatch(fetchCakeFlexibleSideVaultFees());
        });
    }, [
        dispatch
    ]);
};
var useDeserializedPoolByVaultKey = function(vaultKey) {
    var vaultPoolWithKeySelector = useMemo(function() {
        return makeVaultPoolWithKeySelector(vaultKey);
    }, [
        vaultKey
    ]);
    return useSelector(vaultPoolWithKeySelector);
};
var useCakeVaultUserData = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        if (account) {
            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                account: account
            }));
        }
    }, [
        account,
        dispatch
    ]);
};
var useCakeVaultPublicData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)());
    }, [
        dispatch
    ]);
};
var useFetchIfo = function() {
    var account = useWeb3React().account;
    var dispatch = useAppDispatch();
    useSWRImmutable("fetchIfoPublicData", /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            batch(function() {
                dispatch(fetchCakeVaultPublicData());
                dispatch(fetchIfoPublicDataAsync());
            });
            return [
                2
            ];
        });
    }), {
        refreshInterval: FAST_INTERVAL
    });
    useSWRImmutable(account && "fetchIfoUserData", /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            batch(function() {
                dispatch(fetchCakePoolUserDataAsync(account));
                dispatch(fetchCakeVaultUserData({
                    account: account
                }));
                dispatch(fetchUserIfoCreditDataAsync(account));
            });
            return [
                2
            ];
        });
    }), {
        refreshInterval: FAST_INTERVAL
    });
    useSWRImmutable("fetchCakeVaultFees", /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            dispatch(fetchCakeVaultFees());
            return [
                2
            ];
        });
    }));
};
var useCakeVault = function() {
    return useVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault);
};
var useVaultPoolByKey = function(key) {
    var vaultPoolByKey = (0,react.useMemo)(function() {
        return makeVaultPoolByKey(key);
    }, [
        key
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolByKey);
};
var useIfoCredit = function() {
    return useSelector(ifoCreditSelector);
};
var useIfoCeiling = function() {
    return useSelector(ifoCeilingSelector);
};
function useFetchPublicPoolsData() {
    throw new Error("Function not implemented.");
}


/***/ }),

/***/ 70372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ stakeFarm; },
/* harmony export */   "dU": function() { return /* binding */ unstakeFarm; },
/* harmony export */   "sA": function() { return /* binding */ harvestFarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97478);






var options = {
    gasLimit: config__WEBPACK_IMPORTED_MODULE_1__/* .BOOSTED_FARM_GAS_LIMIT */ .ZM
};
var stakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(masterChefContract, pid, amount, gasPrice) {
        var value;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            value = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(amount).times(config__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
            return [
                2,
                masterChefContract.deposit(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function stakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(masterChefContract, pid, amount, gasPrice) {
        var value;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            value = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(amount).times(config__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
            return [
                2,
                masterChefContract.withdraw(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function unstakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(masterChefContract, pid, gasPrice) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                masterChefContract.deposit(pid, "0", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function harvestFarm(masterChefContract, pid, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 56946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "sA": function() { return /* reexport */ farms/* harvestFarm */.sA; },
  "AQ": function() { return /* reexport */ farms/* stakeFarm */.AQ; },
  "dU": function() { return /* reexport */ farms/* unstakeFarm */.dU; }
});

// UNUSED EXPORTS: estimateGas, getActivePools

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 ? _arguments[4] : void 0;
                    if (!contract[methodName]) {
                        throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                    }
                    return [
                        4,
                        (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            overrides
                        ]))
                    ];
                case 1:
                    rawGasEstimation = _state.sent();
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return [
                        2,
                        gasEstimation
                    ];
            }
        });
    });
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 1000;
                    return [
                        4,
                        estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000)
                    ];
                case 1:
                    gasEstimation = _state.sent();
                    return [
                        4,
                        (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            (0,_object_spread/* default */.Z)({
                                gasLimit: gasEstimation
                            }, overrides)
                        ]))
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/calls/farms.ts
var farms = __webpack_require__(70372);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(62621);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts
/* eslint-disable import/prefer-default-export */ 









/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(block) {
        var eligiblePools, blockNumber, _tmp, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _tmp = block;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    blockNumber = _tmp;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    return [
                        4,
                        Promise.all([
                            (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                            (0,multicall/* default */.Z)(sousChefV2, endBlockCalls)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), startBlocks = ref[0], endBlocks = ref[1];
                    return [
                        2,
                        eligiblePools.reduce(function(accum, poolCheck, index) {
                            var startBlock = startBlocks[index] ? new bignumber/* default */.Z(startBlocks[index]) : null;
                            var endBlock = endBlocks[index] ? new bignumber/* default */.Z(endBlocks[index]) : null;
                            if (!startBlock || !endBlock) {
                                return accum;
                            }
                            if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                                return accum;
                            }
                            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                                poolCheck
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 69038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ GetTokenBalance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70794);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56309);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9796);







var GetTokenBalance = function(tokenAddress, account, chainId) {
    var requested = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("0"), balance = ref[0], setBalance = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getBalance = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var calls, ref, resultBalance, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            calls = [
                                {
                                    address: tokenAddress,
                                    name: "balanceOf",
                                    params: [
                                        account
                                    ]
                                }
                            ];
                            return [
                                4,
                                (0,utils_multicall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(config_abi_erc20__WEBPACK_IMPORTED_MODULE_2__/* .ERC20_ABI */ .RB, calls, chainId)
                            ];
                        case 1:
                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                1
                            ]), resultBalance = ref[0];
                            setBalance(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(resultBalance).dividedBy(1E18).toString());
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getBalance() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account !== undefined && tokenAddress) {
            getBalance();
        } else {
            setBalance("0");
        }
    }, [
        account,
        tokenAddress,
        chainId,
        requested
    ]);
    return {
        balance: balance
    };
};


/***/ }),

/***/ 45807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FarmCard_FarmCard; }
});

// UNUSED EXPORTS: Wrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Box_Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text_Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton_Skeleton = __webpack_require__(55604);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(53897);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(39917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/ExpandableSectionButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7533a86f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var ExpandableSectionButton = function(param) {
    var onClick = param.onClick, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var t = (0,src/* useTranslation */.$G)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        return onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        "aria-label": t("Hide or show expandable content"),
        role: "button",
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                color: "text",
                bold: true,
                children: expanded ? t("Hide") : t("Details")
            }),
            expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ExpandableSectionButton_ExpandableSectionButton = (ExpandableSectionButton);

;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/index.ts


// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 3 modules
var hooks = __webpack_require__(44329);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/utils/getTokenBalance.tsx
var getTokenBalance = __webpack_require__(69038);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
;// CONCATENATED MODULE: ./src/utils/getLiquidityUrlPathParts.ts
// Constructing the two forward-slash-separated parts of the 'Add Liquidity' URL
// Each part of the url represents a different side of the LP pair.

var getLiquidityUrlPathParts_getLiquidityUrlPathParts = function(param) {
    var quoteTokenAddress = param.quoteTokenAddress, tokenAddress = param.tokenAddress;
    var wBnbAddress = tokens_src/* bscTokens.wbnb.address */.ds.wbnb.address;
    var firstPart = !quoteTokenAddress || quoteTokenAddress === wBnbAddress ? "BNB" : quoteTokenAddress;
    var secondPart = !tokenAddress || tokenAddress === wBnbAddress ? "BNB" : tokenAddress;
    return "".concat(firstPart, "/").concat(secondPart);
};
/* harmony default export */ var utils_getLiquidityUrlPathParts = (getLiquidityUrlPathParts_getLiquidityUrlPathParts);

// EXTERNAL MODULE: ./src/state/info/constant.ts
var constant = __webpack_require__(56313);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var Modal_useModal = __webpack_require__(62255);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(4513);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(32437);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip_useTooltip = __webpack_require__(10759);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(94832);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button_Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(15004);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(68434);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(93233);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(31282);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./src/utils/compoundApyHelpers.ts
// 1 day, 7 days, 30 days, 1 year, 5 years
var DAYS_TO_CALCULATE_AGAINST = [
    1,
    7,
    30,
    365,
    1825
];
/**
 *
 * @param principalInUSD - amount user wants to invest in USD
 * @param apr - farm or pool apr as percentage. If its farm APR its only cake rewards APR without LP rewards APR
 * @param earningTokenPrice - price of reward token
 * @param compoundFrequency - how many compounds per 1 day, e.g. 1 = one per day, 0.142857142 - once per week
 * @param performanceFee - performance fee as percentage
 * @returns an array of token values earned as interest, with each element representing interest earned over a different period of time (DAYS_TO_CALCULATE_AGAINST)
 */ var getInterestBreakdown = function(param) {
    var principalInUSD = param.principalInUSD, apr = param.apr, earningTokenPrice = param.earningTokenPrice, _compoundFrequency = param.compoundFrequency, compoundFrequency = _compoundFrequency === void 0 ? 1 : _compoundFrequency, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee;
    // Everything here is worked out relative to a year, with the asset compounding at the compoundFrequency rate. 1 = once per day
    var timesCompounded = 365 * compoundFrequency;
    // We use decimal values rather than % in the math for both APY and the number of days being calculates as a proportion of the year
    var aprAsDecimal = apr / 100;
    // special handling for tokens like tBTC or BIFI where the daily token rewards for $1000 dollars will be less than 0.001 of that token
    // and also cause rounding errors
    var isHighValueToken = Math.round(earningTokenPrice / 1000) > 0;
    var roundingDecimalsNew = isHighValueToken ? 5 : 3;
    return DAYS_TO_CALCULATE_AGAINST.map(function(days) {
        var daysAsDecimalOfYear = days / 365;
        // Calculate the starting TOKEN balance with a dollar balance of principalInUSD.
        var principal = principalInUSD / earningTokenPrice;
        var interestEarned = principal * aprAsDecimal * (days / 365);
        if (timesCompounded !== 0) {
            // This is a translation of the typical mathematical compounding APY formula. Details here: https://www.calculatorsoup.com/calculators/financial/compound-interest-calculator.php
            var accruedAmount = principal * Math.pow(1 + aprAsDecimal / timesCompounded, timesCompounded * daysAsDecimalOfYear);
            // To get the TOKEN amount earned, deduct the amount after compounding (accruedAmount) from the starting TOKEN balance (principal)
            interestEarned = accruedAmount - principal;
            if (performanceFee) {
                var performanceFeeAsDecimal = performanceFee / 100;
                var performanceFeeAsAmount = interestEarned * performanceFeeAsDecimal;
                interestEarned -= performanceFeeAsAmount;
            }
        }
        return parseFloat(interestEarned.toFixed(roundingDecimalsNew));
    });
};
/**
 * @param interest how much USD amount you aim to make
 * @param apr APR of farm/pool
 * @param compoundingFrequency how many compounds per 1 day, e.g. 1 = one per day, 0.142857142 - once per week
 * @returns an array of principal values needed to reach target interest, with each element representing principal needed for a different period of time (DAYS_TO_CALCULATE_AGAINST)
 */ var getPrincipalForInterest = function(interest, apr, compoundingFrequency) {
    var performanceFee = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return DAYS_TO_CALCULATE_AGAINST.map(function(days) {
        var apyAsDecimal = getApy(apr, compoundingFrequency, days, performanceFee);
        // console.log('inside', interest, apyAsDecimal)
        // const apyAsBN = new BigNumber(apyAsDecimal).decimalPlaces(6, BigNumber.ROUND_DOWN).toNumber()
        return parseFloat((interest / apyAsDecimal).toFixed(2));
    });
};
/**
 * Given APR returns APY
 * @param apr APR as percentage
 * @param compoundFrequency how many compounds per day
 * @param days if other than 365 adjusts (A)PY for period less than a year
 * @param performanceFee performance fee as percentage
 * @returns APY as decimal
 */ var getApy = function(apr) {
    var compoundFrequency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 365, performanceFee = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var daysAsDecimalOfYear = days / 365;
    var aprAsDecimal = apr / 100;
    var timesCompounded = 365 * compoundFrequency;
    var apyAsDecimal = apr / 100 * daysAsDecimalOfYear;
    if (timesCompounded > 0) {
        apyAsDecimal = Math.pow(1 + aprAsDecimal / timesCompounded, timesCompounded * daysAsDecimalOfYear) - 1;
    }
    if (performanceFee) {
        var performanceFeeAsDecimal = performanceFee / 100;
        var takenAsPerformanceFee = apyAsDecimal * performanceFeeAsDecimal;
        apyAsDecimal -= takenAsPerformanceFee;
    }
    return apyAsDecimal;
};
var getRoi = function(param) {
    var amountEarned = param.amountEarned, amountInvested = param.amountInvested;
    if (amountInvested === 0) {
        return 0;
    }
    var percentage = amountEarned / amountInvested * 100;
    return percentage;
};

;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/useRoiCalculatorReducer.ts






/**
 * This hook is handling all the calculator state and calculations.
 * UI connected to it is merely representation of the data and buttons to trigger actions
 */ // Mapping from the compounding frequency button index to actual compounding frequency
// in number of compounds per day
var compoundingIndexToFrequency = {
    0: 1,
    1: 0.142857142,
    2: 0.071428571,
    3: 0.033333333
};
var TOKEN_PRECISION = 10;
var USD_PRECISION = 2;
var EditingCurrency;
(function(EditingCurrency) {
    EditingCurrency[EditingCurrency["TOKEN"] = 0] = "TOKEN";
    EditingCurrency[EditingCurrency["USD"] = 1] = "USD";
})(EditingCurrency || (EditingCurrency = {}));
var CalculatorMode;
(function(CalculatorMode) {
    CalculatorMode[CalculatorMode["ROI_BASED_ON_PRINCIPAL"] = 0] = "ROI_BASED_ON_PRINCIPAL";
    CalculatorMode[CalculatorMode["PRINCIPAL_BASED_ON_ROI"] = 1] = "PRINCIPAL_BASED_ON_ROI";
})(CalculatorMode || (CalculatorMode = {}));
var defaultState = {
    controls: {
        compounding: true,
        compoundingFrequency: 1,
        activeCompoundingIndex: 0,
        stakingDuration: 3,
        mode: CalculatorMode.ROI_BASED_ON_PRINCIPAL,
        editingCurrency: EditingCurrency.USD
    },
    data: {
        principalAsToken: "0.00",
        principalAsUSD: "",
        roiUSD: 0,
        roiTokens: 0,
        roiPercentage: 0
    }
};
var roiCalculatorReducer = function(state, action) {
    switch(action.type){
        case "setStakingDuration":
            {
                var controls = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    stakingDuration: action.payload
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    controls: controls
                });
            }
        case "toggleCompounding":
            {
                var toggledCompounding = !state.controls.compounding;
                var controls1 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    compounding: toggledCompounding
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    controls: controls1
                });
            }
        case "setCompoundingFrequency":
            {
                var _payload = action.payload, index = _payload.index, autoCompoundFrequency = _payload.autoCompoundFrequency;
                if (autoCompoundFrequency) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        controls: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                            compoundingFrequency: autoCompoundFrequency
                        })
                    });
                }
                var compoundingFrequency = compoundingIndexToFrequency[index];
                var controls2 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    compoundingFrequency: compoundingFrequency,
                    activeCompoundingIndex: index
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    controls: controls2
                });
            }
        case "setPrincipal":
            {
                var _payload1 = action.payload, principalAsUSD = _payload1.principalAsUSD, principalAsToken = _payload1.principalAsToken;
                var data = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.data), {
                    principalAsUSD: principalAsUSD,
                    principalAsToken: principalAsToken
                });
                var controls3 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    mode: CalculatorMode.ROI_BASED_ON_PRINCIPAL
                });
                return {
                    controls: controls3,
                    data: data
                };
            }
        case "setPrincipalForTargetRoi":
            {
                var _payload2 = action.payload, principalAsUSD1 = _payload2.principalAsUSD, principalAsToken1 = _payload2.principalAsToken, roiPercentage = _payload2.roiPercentage;
                var data1 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.data), {
                    principalAsUSD: principalAsUSD1,
                    principalAsToken: principalAsToken1,
                    roiPercentage: roiPercentage
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    data: data1
                });
            }
        case "setCalculatorMode":
            {
                var mode = action.payload;
                var controls4 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    mode: mode
                });
                if (mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI) {
                    var roiUSD = parseFloat(state.data.roiUSD.toFixed(USD_PRECISION));
                    var data2 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.data), {
                        roiUSD: roiUSD
                    });
                    return {
                        controls: controls4,
                        data: data2
                    };
                }
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    controls: controls4
                });
            }
        case "setRoi":
            {
                var data3 = (0,src_object_spread/* default */.Z)({}, state.data, action.payload);
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    data: data3
                });
            }
        case "setTargetRoi":
            {
                var _payload3 = action.payload, roiUSD1 = _payload3.roiUSD, roiTokens = _payload3.roiTokens;
                var data4 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.data), {
                    roiUSD: roiUSD1,
                    roiTokens: roiTokens
                });
                var controls5 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    mode: CalculatorMode.PRINCIPAL_BASED_ON_ROI
                });
                return {
                    controls: controls5,
                    data: data4
                };
            }
        case "toggleEditingCurrency":
            {
                var currencyAfterChange = state.controls.editingCurrency === EditingCurrency.USD ? EditingCurrency.TOKEN : EditingCurrency.USD;
                var controls6 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.controls), {
                    editingCurrency: currencyAfterChange
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    controls: controls6
                });
            }
        default:
            return state;
    }
};
var useRoiCalculatorReducer = function(param, initialState) {
    var stakingTokenPrice = param.stakingTokenPrice, earningTokenPrice = param.earningTokenPrice, autoCompoundFrequency = param.autoCompoundFrequency;
    var ref = (0,react.useReducer)(roiCalculatorReducer, merge_default()(defaultState, initialState)), state = ref[0], dispatch = ref[1];
    // If pool is auto-compounding set state's compounding frequency to this pool's auto-compound frequency
    (0,react.useEffect)(function() {
        if (autoCompoundFrequency > 0) {
            dispatch({
                type: "setCompoundingFrequency",
                payload: {
                    autoCompoundFrequency: autoCompoundFrequency
                }
            });
        }
    }, [
        autoCompoundFrequency
    ]);
    // Handler for compounding frequency buttons
    var setCompoundingFrequency = function(index) {
        dispatch({
            type: "setCompoundingFrequency",
            payload: {
                index: index
            }
        });
    };
    // Handler for principal input when in USD mode
    var setPrincipalFromUSDValue = function(amount) {
        var principalAsTokenBN = new bignumber/* default */.Z(amount).div(stakingTokenPrice);
        var principalAsToken = principalAsTokenBN.gt(0) ? principalAsTokenBN.toFixed(TOKEN_PRECISION) : "0.00";
        dispatch({
            type: "setPrincipal",
            payload: {
                principalAsUSD: amount,
                principalAsToken: principalAsToken
            }
        });
    };
    // Handler for principal input when in Token mode
    var setPrincipalFromTokenValue = (0,react.useCallback)(function(amount) {
        var principalAsUsdBN = new bignumber/* default */.Z(amount).times(stakingTokenPrice);
        var principalAsUsdString = principalAsUsdBN.gt(0) ? principalAsUsdBN.toFixed(USD_PRECISION) : "0.00";
        dispatch({
            type: "setPrincipal",
            payload: {
                principalAsUSD: principalAsUsdString,
                principalAsToken: amount
            }
        });
    }, [
        stakingTokenPrice
    ]);
    // Handler for staking duration buttons
    var setStakingDuration = function(stakingDurationIndex) {
        dispatch({
            type: "setStakingDuration",
            payload: stakingDurationIndex
        });
    };
    // Handler for compounding checkbox
    var toggleCompounding = function() {
        dispatch({
            type: "toggleCompounding"
        });
    };
    // Handler for principal input mode switch
    var toggleEditingCurrency = function() {
        dispatch({
            type: "toggleEditingCurrency"
        });
    };
    var setCalculatorMode = function(modeToSet) {
        dispatch({
            type: "setCalculatorMode",
            payload: modeToSet
        });
    };
    // Handler for ROI input
    var setTargetRoi = function(amount) {
        var targetRoiAsTokens = new bignumber/* default */.Z(amount).div(earningTokenPrice);
        dispatch({
            type: "setTargetRoi",
            payload: {
                roiUSD: +amount,
                roiTokens: targetRoiAsTokens.isNaN() ? 0 : targetRoiAsTokens.toNumber()
            }
        });
    };
    return {
        state: state,
        setPrincipalFromUSDValue: setPrincipalFromUSDValue,
        setPrincipalFromTokenValue: setPrincipalFromTokenValue,
        setStakingDuration: setStakingDuration,
        toggleCompounding: toggleCompounding,
        toggleEditingCurrency: toggleEditingCurrency,
        setCompoundingFrequency: setCompoundingFrequency,
        setCalculatorMode: setCalculatorMode,
        setTargetRoi: setTargetRoi,
        dispatch: dispatch
    };
};
/* harmony default export */ var RoiCalculatorModal_useRoiCalculatorReducer = (useRoiCalculatorReducer);
function DefaultCompoundStrategy(param) {
    var state = param.state, apr = param.apr, earningTokenPrice = param.earningTokenPrice, stakingTokenPrice = param.stakingTokenPrice, performanceFee = param.performanceFee, dispatch = param.dispatch;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, roiUSD = _data.roiUSD;
    var _controls = state.controls, compounding = _controls.compounding, compoundingFrequency = _controls.compoundingFrequency, stakingDuration = _controls.stakingDuration, mode = _controls.mode;
    // Calculates and sets ROI whenever related values change
    (0,react.useEffect)(function() {
        if (mode === CalculatorMode.ROI_BASED_ON_PRINCIPAL) {
            var principalInUSDAsNumber = parseFloat(principalAsUSD);
            var compoundFrequency = compounding ? compoundingFrequency : 0;
            var interestBreakdown = getInterestBreakdown({
                principalInUSD: principalInUSDAsNumber,
                apr: apr,
                earningTokenPrice: earningTokenPrice,
                compoundFrequency: compoundFrequency,
                performanceFee: performanceFee
            });
            var hasInterest = !Number.isNaN(interestBreakdown[stakingDuration]);
            var roiTokens = hasInterest ? interestBreakdown[stakingDuration] : 0;
            var roiAsUSD = hasInterest ? roiTokens * earningTokenPrice : 0;
            var roiPercentage = hasInterest ? getRoi({
                amountEarned: roiAsUSD,
                amountInvested: principalInUSDAsNumber
            }) : 0;
            dispatch({
                type: "setRoi",
                payload: {
                    roiUSD: roiAsUSD,
                    roiTokens: roiTokens,
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        principalAsUSD,
        apr,
        stakingDuration,
        earningTokenPrice,
        performanceFee,
        compounding,
        compoundingFrequency,
        mode,
        dispatch, 
    ]);
    // Calculates and sets principal based on expected ROI value
    (0,react.useEffect)(function() {
        if (mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI) {
            var principalForExpectedRoi = getPrincipalForInterest(roiUSD, apr, compounding ? compoundingFrequency : 0, performanceFee);
            var principalUSD = !Number.isNaN(principalForExpectedRoi[stakingDuration]) ? principalForExpectedRoi[stakingDuration] : 0;
            var principalToken = new bignumber/* default */.Z(principalUSD).div(stakingTokenPrice);
            var roiPercentage = getRoi({
                amountEarned: roiUSD,
                amountInvested: principalUSD
            });
            dispatch({
                type: "setPrincipalForTargetRoi",
                payload: {
                    principalAsUSD: principalUSD.toFixed(USD_PRECISION),
                    principalAsToken: principalToken.toFixed(TOKEN_PRECISION),
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        stakingDuration,
        apr,
        compounding,
        compoundingFrequency,
        mode,
        roiUSD,
        stakingTokenPrice,
        performanceFee,
        dispatch, 
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/AnimatedArrow.tsx

function AnimatedArrow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: scale(1);\n    stroke-width: 0;\n  }\n  50% {\n    transform: scale(1.3);\n    stroke-width: 2;\n  }\n  100% {\n    transform: scale(1);\n    stroke-width: 0;\n  }\n"
    ]);
    AnimatedArrow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > svg {\n    animation: 0.2s ",
        " linear;\n    stroke: ",
        ";\n    stroke-width: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(AnimatedArrow_templateObject());
var ArrowContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-dcec5476-0"
})(_templateObject1(), rotate, function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.primary3D);
});
var AnimatedArrow = function(param) {
    var calculatorState = param.calculatorState;
    var ref = (0,react.useState)("roiArrow-0"), key = ref[0], setKey = ref[1];
    var mode = calculatorState.controls.mode;
    // Trigger animation on state change
    (0,react.useEffect)(function() {
        setKey(function(prevKey) {
            var prevId = parseInt(prevKey.split("-")[1], 10);
            return "roiArrow-".concat(prevId + 1);
        });
    }, [
        calculatorState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowContainer, {
        justifyContent: "center",
        my: "24px",
        children: mode === CalculatorMode.ROI_BASED_ON_PRINCIPAL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
            width: "24px",
            height: "24px",
            color: "textSubtle"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
            width: "24px",
            height: "24px",
            color: "textSubtle"
        })
    }, key);
};
/* harmony default export */ var RoiCalculatorModal_AnimatedArrow = (AnimatedArrow);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx
var ExpandableButton = __webpack_require__(50598);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box_Box = __webpack_require__(6538);
;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/RoiCalculatorFooter.tsx

function RoiCalculatorFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: transparent;\n"
    ]);
    RoiCalculatorFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoiCalculatorFooter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin-top: 16px;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n    color: ",
        ";\n  }\n  li::marker {\n    font-size: 12px;\n  }\n"
    ]);
    RoiCalculatorFooter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Footer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-bcecf47b-0"
})(RoiCalculatorFooter_templateObject());
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-bcecf47b-1"
})(RoiCalculatorFooter_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var RoiCalculatorFooter = function(param) {
    var isFarm = param.isFarm, performanceFee = param.performanceFee;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
        p: "16px",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableLabel */.L, {
                expanded: isExpanded,
                onClick: function() {
                    return setIsExpanded(function(prev) {
                        return !prev;
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    color: "text",
                    bold: true,
                    children: isExpanded ? t("Hide") : t("Details")
                })
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                px: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "12px",
                                textAlign: "center",
                                color: "text",
                                display: "inline",
                                lineHeight: 1.1,
                                children: t("Calculated based on current rates.")
                            })
                        }),
                        isFarm && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "12px",
                                textAlign: "center",
                                color: "text",
                                display: "inline",
                                children: t("LP rewards: 0.17% trading fees, distributed proportionally among LP token holders.")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "12px",
                                textAlign: "center",
                                color: "text",
                                display: "inline",
                                lineHeight: 1.1,
                                children: t("All figures are estimates provided for your convenience only, and by no means represent guaranteed returns.")
                            })
                        }),
                        performanceFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                mt: "14px",
                                fontSize: "12px",
                                textAlign: "center",
                                color: "text",
                                display: "inline",
                                children: t("All estimated rates take into account this pool’s %fee%% performance fee", {
                                    fee: performanceFee
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var RoiCalculatorModal_RoiCalculatorFooter = (RoiCalculatorFooter);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(66354);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(22099);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PencilFarms.tsx
var PencilFarms = __webpack_require__(77431);
;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/RoiCard.tsx

function RoiCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  padding: 1px;\n  width: 100%;\n  border-radius: 0px;\n"
    ]);
    RoiCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoiCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 120px;\n  padding: 24px;\n  border-radius:0px;\n  background: transparent;\n  border: 1px solid ",
        ";\n"
    ]);
    RoiCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  & > input {\n    padding-left: 28px;\n    max-width: 70%;\n  }\n  &:before {\n    position: absolute;\n    content: '$';\n    color: ",
        ";\n    left: 16px;\n    top: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: ",
        ";\n  border: transparent;\n  font-size: 22px;\n  box-shadow:none;\n\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 82%;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow-x: auto;\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var MILLION = 1000000;
var TRILLION = 1000000000000;
var RoiCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-8045c322-0"
})(RoiCard_templateObject());
var RoiCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-8045c322-1"
})(RoiCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var RoiInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-8045c322-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CustomRoiInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-8045c322-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var RoiDisplayContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-8045c322-4"
})(_templateObject4());
var RoiDollarAmount = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-8045c322-5"
})(_templateObject5(), function(param) {
    var fadeOut = param.fadeOut, theme = param.theme;
    return fadeOut && "\n      &:after {\n        background: linear-gradient(\n          to right,\n          ".concat(theme.colors.background, "00,\n          ").concat(theme.colors.background, "E6\n        );\n        content: '';\n        height: 100%;\n        pointer-events: none;\n        position: absolute;\n        right: 0;\n        top: 0;\n        width: 40px;\n      }\n  ");
});
var RoiCard = function(param) {
    var earningTokenSymbol = param.earningTokenSymbol, calculatorState = param.calculatorState, setTargetRoi = param.setTargetRoi, setCalculatorMode = param.setCalculatorMode;
    var ref = (0,react.useState)(""), expectedRoi = ref[0], setExpectedRoi = ref[1];
    var inputRef = (0,react.useRef)(null);
    var _data = calculatorState.data, roiUSD = _data.roiUSD, roiTokens = _data.roiTokens, roiPercentage = _data.roiPercentage;
    var mode = calculatorState.controls.mode;
    var t = (0,src/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        if (mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        mode
    ]);
    var onEnterEditing = function() {
        setCalculatorMode(CalculatorMode.PRINCIPAL_BASED_ON_ROI);
        setExpectedRoi(roiUSD.toLocaleString("en", {
            minimumFractionDigits: roiUSD > MILLION ? 0 : 2,
            maximumFractionDigits: roiUSD > MILLION ? 0 : 2
        }));
    };
    var onExitRoiEditing = function() {
        setCalculatorMode(CalculatorMode.ROI_BASED_ON_PRINCIPAL);
    };
    var handleExpectedRoiChange = function(event) {
        if (event.currentTarget.validity.valid) {
            var roiAsString = event.target.value.replace(/,/g, ".");
            setTargetRoi(roiAsString);
            setExpectedRoi(roiAsString);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCardWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoiCardInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    fontSize: "12px",
                    color: "text",
                    bold: true,
                    textTransform: "uppercase",
                    children: t("ROI at current rates")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                    justifyContent: "space-between",
                    mt: "4px",
                    height: "36px",
                    children: mode === CalculatorMode.PRINCIPAL_BASED_ON_ROI ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiInputContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRoiInput, {
                                    ref: inputRef,
                                    type: "text",
                                    inputMode: "decimal",
                                    pattern: "^[0-9]+[.,]?[0-9]*$",
                                    scale: "sm",
                                    value: expectedRoi,
                                    placeholder: "0.0",
                                    onChange: handleExpectedRoiChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                scale: "sm",
                                variant: "text",
                                onClick: onExitRoiEditing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                    color: "text"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiDisplayContainer, {
                                onClick: onEnterEditing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiDollarAmount, {
                                    fontSize: "24px",
                                    bold: true,
                                    fadeOut: roiUSD > TRILLION,
                                    color: "text",
                                    children: roiUSD.toLocaleString("en", {
                                        minimumFractionDigits: roiUSD > MILLION ? 0 : 2,
                                        maximumFractionDigits: roiUSD > MILLION ? 0 : 2
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                scale: "sm",
                                variant: "text",
                                onClick: onEnterEditing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilFarms/* default */.Z, {
                                    color: "text"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                    fontSize: "12px",
                    color: "text",
                    children: [
                        "~ ",
                        roiTokens,
                        " ",
                        earningTokenSymbol,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                            fontSize: "12px",
                            color: "text",
                            ml: "3px",
                            display: "inline-block",
                            maxWidth: "100%",
                            style: {
                                lineBreak: "anywhere"
                            },
                            children: [
                                "(",
                                roiPercentage.toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }),
                                "%)"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RoiCalculatorModal_RoiCard = (RoiCard);

;// CONCATENATED MODULE: ./src/components/RoiCalculatorModal/index.tsx

function RoiCalculatorModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* & > :nth-child(2) {\n    padding: 0;\n  }\n\n  ",
        " {\n    width: 480px;\n  } */\n  padding: 0px;\n  @media screen and (max-width:600px) {\n      padding-top:15px;\n  }\n"
    ]);
    RoiCalculatorModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoiCalculatorModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  max-height: 500px;\n  overflow-y: auto;\n  width: 500px;\n  ",
        " {\n    max-height: none;\n  }\n  @media screen and (max-width: 600px) {\n      width: 100%;\n  }\n"
    ]);
    RoiCalculatorModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoiCalculatorModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  & > button {\n    width: 100%;\n  }\n  opacity: ",
        ";\n"
    ]);
    RoiCalculatorModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-fdd16614-0"
})(RoiCalculatorModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ScrollableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fdd16614-1"
})(RoiCalculatorModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FullWidthButtonMenu = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenu/* default */.Z).withConfig({
    componentId: "sc-fdd16614-2"
})(RoiCalculatorModal_templateObject2(), function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
});
var RoiCalculatorModal = function(param) {
    var onDismiss = param.onDismiss, onBack = param.onBack, earningTokenPrice = param.earningTokenPrice, apr = param.apr, apy = param.apy, displayApr = param.displayApr, linkLabel = param.linkLabel, linkHref = param.linkHref, stakingTokenBalance = param.stakingTokenBalance, stakingTokenSymbol = param.stakingTokenSymbol, stakingTokenPrice = param.stakingTokenPrice, multiplier = param.multiplier, initialValue = param.initialValue, _earningTokenSymbol = param.earningTokenSymbol, earningTokenSymbol = _earningTokenSymbol === void 0 ? "Pi" : _earningTokenSymbol, _autoCompoundFrequency = param.autoCompoundFrequency, autoCompoundFrequency = _autoCompoundFrequency === void 0 ? 0 : _autoCompoundFrequency, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, _isFarm = param.isFarm, isFarm = _isFarm === void 0 ? false : _isFarm, initialState = param.initialState, strategy = param.strategy, header = param.header, children = param.children, bCakeCalculatorSlot = param.bCakeCalculatorSlot;
    var renderCurenccySymbol = function renderCurenccySymbol() {
        if (chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS) {
            return " VNDC";
        }
        return " USD";
    };
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var balanceInputRef = (0,react.useRef)(null);
    var ref = RoiCalculatorModal_useRoiCalculatorReducer({
        stakingTokenPrice: stakingTokenPrice,
        earningTokenPrice: earningTokenPrice,
        autoCompoundFrequency: autoCompoundFrequency
    }, initialState), state = ref.state, setPrincipalFromUSDValue = ref.setPrincipalFromUSDValue, setPrincipalFromTokenValue = ref.setPrincipalFromTokenValue, setStakingDuration = ref.setStakingDuration, toggleCompounding = ref.toggleCompounding, toggleEditingCurrency = ref.toggleEditingCurrency, setCompoundingFrequency = ref.setCompoundingFrequency, setCalculatorMode = ref.setCalculatorMode, setTargetRoi = ref.setTargetRoi, dispatch = ref.dispatch;
    var _controls = state.controls, compounding = _controls.compounding, activeCompoundingIndex = _controls.activeCompoundingIndex, stakingDuration = _controls.stakingDuration, editingCurrency = _controls.editingCurrency;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, principalAsToken = _data.principalAsToken;
    // Auto-focus input on opening modal
    (0,react.useEffect)(function() {
        if (balanceInputRef.current) {
            balanceInputRef.current.focus();
        }
    }, []);
    // If user comes to calculator from staking modal - initialize with whatever they put in there
    (0,react.useEffect)(function() {
        if (initialValue) {
            setPrincipalFromTokenValue(initialValue);
        }
    }, [
        initialValue,
        setPrincipalFromTokenValue
    ]);
    var ref1 = (0,useTooltip_useTooltip/* default */.Z)(isFarm ? t("“My Balance” here includes both LP Tokens in your wallet, and LP Tokens already staked in this farm.") : t("“My Balance” here includes both %assetSymbol% in your wallet, and %assetSymbol% already staked in this pool.", {
        assetSymbol: stakingTokenSymbol
    }), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var onBalanceFocus = function() {
        setCalculatorMode(CalculatorMode.ROI_BASED_ON_PRINCIPAL);
    };
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var editingUnit = editingCurrency === EditingCurrency.TOKEN ? stakingTokenSymbol : renderCurenccySymbol();
    var editingValue = editingCurrency === EditingCurrency.TOKEN ? principalAsToken : principalAsUSD;
    var conversionUnit = editingCurrency === EditingCurrency.TOKEN ? renderCurenccySymbol() : stakingTokenSymbol;
    var conversionValue = editingCurrency === EditingCurrency.TOKEN ? principalAsUSD : principalAsToken;
    var onUserInput = editingCurrency === EditingCurrency.TOKEN ? setPrincipalFromTokenValue : setPrincipalFromUSDValue;
    var DURATION = (0,react.useMemo)(function() {
        return [
            t("1D"),
            t("7D"),
            t("30D"),
            t("1Y")
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        title: t("ROI Calculator"),
        onDismiss: onBack || onDismiss,
        // onBack={onBack ?? null}
        headerBackground: "gradientCardHeader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
                children: [
                    strategy ? strategy(state, dispatch) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCompoundStrategy, {
                        apr: apy !== null && apy !== void 0 ? apy : apr,
                        dispatch: dispatch,
                        state: state,
                        earningTokenPrice: earningTokenPrice,
                        performanceFee: performanceFee,
                        stakingTokenPrice: stakingTokenPrice
                    }),
                    header,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        flexDirection: "column",
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: t("%asset% staked", {
                                    asset: stakingTokenSymbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                                inputProps: {
                                    scale: "sm"
                                },
                                currencyValue: "".concat(conversionValue, " ").concat(conversionUnit),
                                innerRef: balanceInputRef,
                                placeholder: "0.00",
                                value: editingValue,
                                unit: editingUnit,
                                onUserInput: onUserInput,
                                switchEditingUnits: toggleEditingCurrency,
                                onFocus: onBalanceFocus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mt: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "primary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("100");
                                        },
                                        children: "100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "primary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("1000");
                                        },
                                        children: "1000"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        disabled: !Number.isFinite(stakingTokenPrice) || !stakingTokenBalance.isFinite() || stakingTokenBalance.lte(0) || !account,
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "128px",
                                        variant: "primary",
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        onClick: function() {
                                            return setPrincipalFromUSDValue((0,formatBalance/* getBalanceNumber */.mW)(stakingTokenBalance.times(stakingTokenPrice)).toString());
                                        },
                                        children: t("My Balance")
                                    })
                                ]
                            }),
                            children || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        mt: "24px",
                                        color: "text",
                                        bold: true,
                                        fontSize: "12px",
                                        textTransform: "uppercase",
                                        children: t("Staked for")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthButtonMenu, {
                                        activeIndex: stakingDuration,
                                        onItemClick: setStakingDuration,
                                        scale: "sm",
                                        children: DURATION.map(function(duration) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                variant: "secondary",
                                                children: duration
                                            }, duration);
                                        })
                                    })
                                ]
                            }),
                            autoCompoundFrequency === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        mt: "24px",
                                        color: "text",
                                        bold: true,
                                        fontSize: "12px",
                                        textTransform: "uppercase",
                                        children: t("Compounding every")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                                flex: "1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    scale: "sm",
                                                    checked: compounding,
                                                    onChange: toggleCompounding
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                                flex: "6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthButtonMenu, {
                                                    disabled: !compounding,
                                                    activeIndex: activeCompoundingIndex,
                                                    onItemClick: setCompoundingFrequency,
                                                    scale: "sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("1D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("7D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("14D")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                                            children: t("30D")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_AnimatedArrow, {
                        calculatorState: state
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_RoiCard, {
                            earningTokenSymbol: earningTokenSymbol,
                            calculatorState: state,
                            setTargetRoi: setTargetRoi,
                            setCalculatorMode: setCalculatorMode
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal_RoiCalculatorFooter, {
                isFarm: isFarm,
                apr: apr,
                apy: apy,
                displayApr: displayApr,
                autoCompoundFrequency: autoCompoundFrequency,
                multiplier: multiplier,
                linkLabel: linkLabel,
                linkHref: linkHref,
                performanceFee: performanceFee
            })
        ]
    });
};
/* harmony default export */ var components_RoiCalculatorModal = (RoiCalculatorModal);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/ApyButton.tsx


function ApyButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    ApyButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ApyLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-79a94f1-0"
})(ApyButton_templateObject());
var ApyButton = function(param) {
    var variant = param.variant, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, cakePrice = param.cakePrice, apr = param.apr, multiplier = param.multiplier, displayApr = param.displayApr, addLiquidityUrl = param.addLiquidityUrl, pibTokenPrice = param.pibTokenPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var ref = (0,hooks/* useFarmUser */.Dx)(pid), tokenBalance = ref.tokenBalance, stakedBalance = ref.stakedBalance;
    var renderStakingTokenPrice = pid === 0 ? pibTokenPrice.toNumber() : lpPrice.toNumber();
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoiCalculatorModal, {
        linkLabel: t("Get %symbol%", {
            symbol: lpLabel
        }),
        stakingTokenBalance: stakedBalance.plus(tokenBalance),
        stakingTokenSymbol: lpSymbol,
        stakingTokenPrice: renderStakingTokenPrice,
        earningTokenPrice: cakePrice.toNumber(),
        apr: apr,
        multiplier: multiplier,
        displayApr: displayApr,
        linkHref: addLiquidityUrl,
        isFarm: true
    })), 1), onPresentApyModal = ref1[0];
    var handleClickButton = function(event) {
        event.stopPropagation();
        onPresentApyModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApyLabelContainer, {
        alignItems: "right",
        onClick: handleClickButton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                children: [
                    displayApr,
                    "%"
                ]
            }),
            variant === "text-and-button" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                ml: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                    width: "18px"
                })
            })
        ]
    });
};
/* harmony default export */ var FarmCard_ApyButton = (ApyButton);

// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var components_ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(14841);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(7654);
// EXTERNAL MODULE: ./node_modules/lodash/replace.js
var replace = __webpack_require__(13880);
// EXTERNAL MODULE: ./node_modules/lodash/toString.js
var lodash_toString = __webpack_require__(79833);
;// CONCATENATED MODULE: ./src/components/Balance.tsx












var Balance_Balance = function(_param) {
    var value = _param.value, _color = _param.color, color = _color === void 0 ? "text" : _color, _decimals = _param.decimals, decimals = _decimals === void 0 ? 3 : _decimals, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, unit = _param.unit, prefix = _param.prefix, onClick = _param.onClick, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "value",
        "color",
        "decimals",
        "isDisabled",
        "unit",
        "prefix",
        "onClick"
    ]);
    var prefixProp = (0,react.useMemo)(function() {
        return prefix ? {
            prefix: prefix
        } : {};
    }, [
        prefix
    ]);
    var suffixProp = (0,react.useMemo)(function() {
        return unit ? {
            suffix: unit
        } : {};
    }, [
        unit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        start: 0,
        preserveValue: true,
        delay: 0,
        end: value
    }, prefixProp, suffixProp), {
        decimals: decimals,
        duration: 1,
        separator: ",",
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                color: isDisabled ? "textDisabled" : color,
                onClick: onClick
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: countUpRef
                })
            }));
        }
    }));
};
var BalanceWithLoading = function(_param) {
    var value = _param.value, fontSize = _param.fontSize, props = _object_without_properties(_param, [
        "value",
        "fontSize"
    ]);
    var isValueUndefinedOrNull = useMemo(function() {
        return isUndefinedOrNull(value);
    }, [
        value
    ]);
    var finalValue = useMemo(function() {
        if (isValueUndefinedOrNull) return null;
        var trimmedValue = _replace(_toString(value), /,/g, "");
        return _isNaN(trimmedValue) || _isNaN(_toNumber(trimmedValue)) ? 0 : _toNumber(trimmedValue);
    }, [
        value,
        isValueUndefinedOrNull
    ]);
    if (isValueUndefinedOrNull) {
        return /*#__PURE__*/ _jsx(Skeleton, {});
    }
    return /*#__PURE__*/ _jsx(Balance_Balance, _object_spread_props(_object_spread({}, props), {
        value: finalValue,
        fontSize: fontSize
    }));
};
/* harmony default export */ var components_Balance = (Balance_Balance);

// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var ToastsContext_useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(70486);
;// CONCATENATED MODULE: ./src/hooks/useCatchTxError.tsx









// -32000 is insufficient funds for gas * price + value
var isGasEstimationError = function(err) {
    var ref;
    return (err === null || err === void 0 ? void 0 : (ref = err.data) === null || ref === void 0 ? void 0 : ref.code) === -32000;
};
function useCatchTxError_useCatchTxError() {
    var provider = (0,hooks_useActiveWeb3React/* default */.Z)().provider;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,ToastsContext_useToast/* useToast */.p)(), toastError = ref.toastError, toastSuccess = ref.toastSuccess;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), txResponseLoading = ref2[0], setTxResponseLoading = ref2[1];
    var handleNormalError = (0,react.useCallback)(function(error, tx) {
        (0,sentry/* logError */.H)(error);
        if (tx) {
            toastError(t("Error"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                txHash: tx.hash,
                children: t("Please try again. Confirm the transaction and make sure you are paying enough gas!")
            }));
        } else {
            toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
        }
    }, [
        t,
        toastError
    ]);
    var fetchWithCatchTxError = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(callTx) {
            var tx, receipt, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tx = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        setLoading(true);
                        return [
                            4,
                            callTx()
                        ];
                    case 2:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _state.sent();
                        toastSuccess("".concat(t("Transaction submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: tx.hash
                        }));
                        return [
                            4,
                            tx.wait()
                        ];
                    case 3:
                        receipt = _state.sent();
                        return [
                            2,
                            receipt
                        ];
                    case 4:
                        error = _state.sent();
                        if (!(0,sentry/* isUserRejected */.Z)(error)) {
                            if (!tx) {
                                handleNormalError(error);
                            } else {
                                provider.call(tx, tx.blockNumber).then(function() {
                                    handleNormalError(error, tx);
                                }).catch(function(err) {
                                    if (isGasEstimationError(err)) {
                                        handleNormalError(error, tx);
                                    } else {
                                        var ref;
                                        (0,sentry/* logError */.H)(err);
                                        var recursiveErr = err;
                                        var reason;
                                        // for MetaMask
                                        if (recursiveErr === null || recursiveErr === void 0 ? void 0 : (ref = recursiveErr.data) === null || ref === void 0 ? void 0 : ref.message) {
                                            var ref1;
                                            reason = recursiveErr === null || recursiveErr === void 0 ? void 0 : (ref1 = recursiveErr.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                                        } else {
                                            // for other wallets
                                            // Reference
                                            // https://github.com/Uniswap/interface/blob/ac962fb00d457bc2c4f59432d7d6d7741443dfea/src/hooks/useSwapCallback.tsx#L216-L222
                                            while(recursiveErr){
                                                var ref2;
                                                var _reason, ref3;
                                                reason = (ref3 = (_reason = recursiveErr.reason) !== null && _reason !== void 0 ? _reason : recursiveErr.message) !== null && ref3 !== void 0 ? ref3 : reason;
                                                var _error;
                                                recursiveErr = (_error = recursiveErr.error) !== null && _error !== void 0 ? _error : (ref2 = recursiveErr.data) === null || ref2 === void 0 ? void 0 : ref2.originalError;
                                            }
                                        }
                                        var REVERT_STR = "execution reverted: ";
                                        var indexInfo = reason === null || reason === void 0 ? void 0 : reason.indexOf(REVERT_STR);
                                        var isRevertedError = indexInfo >= 0;
                                        if (isRevertedError) reason = reason.substring(indexInfo + REVERT_STR.length);
                                        toastError(t("Failed"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                            txHash: tx.hash,
                                            children: isRevertedError ? t("Transaction failed with error: %reason%", {
                                                reason: reason
                                            }) : t("Transaction failed. For detailed error message:")
                                        }));
                                    }
                                });
                            }
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleNormalError,
        toastError,
        provider,
        toastSuccess,
        t
    ]);
    var fetchTxResponse = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(callTx) {
            var tx, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tx = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setTxResponseLoading(true);
                        return [
                            4,
                            callTx()
                        ];
                    case 2:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _state.sent();
                        toastSuccess("".concat(t("Transaction submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: tx.hash
                        }));
                        return [
                            2,
                            tx
                        ];
                    case 3:
                        error = _state.sent();
                        if (!(0,sentry/* isUserRejected */.Z)(error)) {
                            if (!tx) {
                                handleNormalError(error);
                            } else {
                                provider.call(tx, tx.blockNumber).then(function() {
                                    handleNormalError(error, tx);
                                }).catch(function(err) {
                                    if (isGasEstimationError(err)) {
                                        handleNormalError(error, tx);
                                    } else {
                                        var ref;
                                        (0,sentry/* logError */.H)(err);
                                        var recursiveErr = err;
                                        var reason;
                                        // for MetaMask
                                        if (recursiveErr === null || recursiveErr === void 0 ? void 0 : (ref = recursiveErr.data) === null || ref === void 0 ? void 0 : ref.message) {
                                            var ref1;
                                            reason = recursiveErr === null || recursiveErr === void 0 ? void 0 : (ref1 = recursiveErr.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                                        } else {
                                            // for other wallets
                                            // Reference
                                            // https://github.com/Uniswap/interface/blob/ac962fb00d457bc2c4f59432d7d6d7741443dfea/src/hooks/useSwapCallback.tsx#L216-L222
                                            while(recursiveErr){
                                                var ref2;
                                                var _reason, ref3;
                                                reason = (ref3 = (_reason = recursiveErr.reason) !== null && _reason !== void 0 ? _reason : recursiveErr.message) !== null && ref3 !== void 0 ? ref3 : reason;
                                                var _error;
                                                recursiveErr = (_error = recursiveErr.error) !== null && _error !== void 0 ? _error : (ref2 = recursiveErr.data) === null || ref2 === void 0 ? void 0 : ref2.originalError;
                                            }
                                        }
                                        var REVERT_STR = "execution reverted: ";
                                        var indexInfo = reason === null || reason === void 0 ? void 0 : reason.indexOf(REVERT_STR);
                                        var isRevertedError = indexInfo >= 0;
                                        if (isRevertedError) reason = reason.substring(indexInfo + REVERT_STR.length);
                                        toastError(t("Failed"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                            txHash: tx.hash,
                                            children: isRevertedError ? t("Transaction failed with error: %reason%", {
                                                reason: reason
                                            }) : t("Transaction failed. For detailed error message:")
                                        }));
                                    }
                                });
                            }
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTxResponseLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleNormalError,
        toastError,
        provider,
        toastSuccess,
        t
    ]);
    return {
        fetchWithCatchTxError: fetchWithCatchTxError,
        fetchTxResponse: fetchTxResponse,
        loading: loading,
        txResponseLoading: txResponseLoading
    };
}

// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(80070);
// EXTERNAL MODULE: ./src/state/index.ts + 32 modules
var state = __webpack_require__(106);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var farms = __webpack_require__(87604);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(56946);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useHarvestFarm.ts






var useHarvestFarm = function(farmPid) {
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var handleHarvest = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,calls/* harvestFarm */.sA)(masterChefContract, farmPid, gasPrice)
            ];
        });
    }), [
        farmPid,
        masterChefContract,
        gasPrice
    ]);
    return {
        onReward: handleHarvest
    };
};
/* harmony default export */ var hooks_useHarvestFarm = (useHarvestFarm);

// EXTERNAL MODULE: ./src/utils/calls/farms.ts
var calls_farms = __webpack_require__(70372);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var hooks_useBCakeProxyContractAddress = __webpack_require__(80922);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/hooks/useCallWithGasPrice.ts







// eslint-disable-next-line lodash/import-scope

/**
 * Perform a contract call with a gas price returned from useGasPrice
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ function useCallWithGasPrice() {
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var callWithGasPrice = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        contractMethod = (0,lodash.get)(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                                hasManualGasPriceOverride ? (0,src_object_spread/* default */.Z)({}, overrides) : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, overrides), {
                                    gasPrice: gasPrice
                                })
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}

;// CONCATENATED MODULE: ./src/views/Farms/hooks/useApproveFarm.ts






var useApproveFarm = function(lpContract, chainId) {
    var masterChefAddress = (0,addressHelpers/* getMasterChefAddress */.Oc)(chainId);
    var callWithGasPrice = useCallWithGasPrice().callWithGasPrice;
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                callWithGasPrice(lpContract, "approve", [
                    masterChefAddress,
                    bignumbers/* MaxUint256 */.Bz
                ])
            ];
        });
    }), [
        lpContract,
        masterChefAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};
/* harmony default export */ var hooks_useApproveFarm = (useApproveFarm);
var useApproveBoostProxyFarm = function(lpContract, proxyAddress) {
    var callWithGasPrice = useCallWithGasPrice().callWithGasPrice;
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                proxyAddress && callWithGasPrice(lpContract, "approve", [
                    proxyAddress,
                    bignumbers/* MaxUint256 */.Bz
                ])
            ];
        });
    }), [
        lpContract,
        proxyAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};

// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 13 modules
var contractHelpers = __webpack_require__(49101);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyCAKEBalance.ts






var useProxyCAKEBalance = function() {
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var proxyAddress = (0,hooks_useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId).proxyAddress;
    var cakeContract = (0,contractHelpers/* getCakeContract */.XT)();
    var ref1 = (0,useSWRContract/* useSWRContract */.Av)([
        cakeContract,
        "balanceOf",
        [
            proxyAddress
        ]
    ]), data = ref1.data, mutate = ref1.mutate;
    return {
        refreshProxyCakeBalance: mutate,
        proxyCakeBalance: data ? (0,formatBalance/* getBalanceNumber */.mW)(new bignumber/* default */.Z(data.toString())) : 0
    };
};
/* harmony default export */ var hooks_useProxyCAKEBalance = (useProxyCAKEBalance);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyStakedActions.ts










function useProxyStakedActions(pid, lpContract) {
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var proxyAddress = (0,hooks_useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId).proxyAddress;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var ref1 = hooks_useProxyCAKEBalance(), proxyCakeBalance = ref1.proxyCakeBalance, refreshProxyCakeBalance = ref1.refreshProxyCakeBalance;
    var onDone = (0,react.useCallback)(function() {
        refreshProxyCakeBalance();
        dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                pid
            ],
            chainId: chainId,
            proxyAddress: proxyAddress
        }));
    }, [
        account,
        proxyAddress,
        chainId,
        pid,
        dispatch,
        refreshProxyCakeBalance
    ]);
    var onApprove = useApproveBoostProxyFarm(lpContract, proxyAddress).onApprove;
    var onStake = (0,react.useCallback)(function(value) {
        return (0,calls_farms/* stakeFarm */.AQ)(bCakeProxy, pid, value, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    var onUnstake = (0,react.useCallback)(function(value) {
        return (0,calls_farms/* unstakeFarm */.dU)(bCakeProxy, pid, value, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    var onReward = (0,react.useCallback)(function() {
        return (0,calls_farms/* harvestFarm */.sA)(bCakeProxy, pid, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    return {
        onStake: onStake,
        onUnstake: onUnstake,
        onReward: onReward,
        onApprove: onApprove,
        onDone: onDone,
        proxyCakeBalance: proxyCakeBalance
    };
}

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 90px;\n  ",
        " {\n    min-height: 124.5px;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 90px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  flex-grow: 1;\n  flex-basis: 0;\n  margin-bottom: 16px;\n\n  ",
        " {\n    padding: 16px;\n    margin-left: 12px;\n    margin-right: 12px;\n    min-height: 124.5px;\n    margin-bottom: 12px;\n  }\n  ",
        " {\n    margin-right: 0;\n    margin-bottom: 0;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  flex-grow: 1;\n  flex-basis: 0;\n  margin-bottom: 16px;\n\n  ",
        " {\n    padding: 16px;\n    margin-left: 12px;\n    margin-right: 12px;\n    margin-bottom: 12px;\n  }\n\n  ",
        " {\n    margin-right: 0;\n    margin-bottom: 0;\n    /* max-height: 130px; */\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 8px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ActionContainerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189b06c2-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var styles_ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189b06c2-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var ActionContainer2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189b06c2-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var styles_ActionTitles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189b06c2-3"
})(styles_templateObject3());
var styles_ActionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189b06c2-4"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/HarvestAction.tsx
























var ProxyHarvestActionContainer = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var lpAddress = props.lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = useProxyStakedActions(props.pid, lpContract), onReward = ref.onReward, onDone = ref.onDone, proxyCakeBalance = ref.proxyCakeBalance;
    return children((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onReward: onReward,
        proxyCakeBalance: proxyCakeBalance,
        onDone: onDone
    }));
};
var HarvestActionContainer = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var onReward = hooks_useHarvestFarm(props.pid).onReward;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onDone = (0,react.useCallback)(function() {
        return dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                props.pid
            ],
            chainId: chainId
        }));
    }, [
        account,
        dispatch,
        chainId,
        props.pid
    ]);
    return children((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onDone: onDone,
        onReward: onReward
    }));
};
var HarvestAction = function(param) {
    var onReward = param.onReward, onDone = param.onDone, userData = param.userData, userDataReady = param.userDataReady, proxyCakeBalance = param.proxyCakeBalance;
    var renderCurenccySymbol = function renderCurenccySymbol() {
        if (chainId === ChainId.ONUS) {
            return " VNDC";
        }
        return " USD";
    };
    var t = useTranslation().t;
    var toastSuccess = useToast().toastSuccess;
    var ref = useCatchTxError(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var earningsBigNumber = new BigNumber(userData.earnings);
    // const cakePrice = usePriceRunBusd()
    var cakePrice = useTokenPriceWPi();
    var earnings = BIG_ZERO;
    var earningsBusd = 0;
    var displayBalance = userDataReady ? earnings.toFixed(5, BigNumber.ROUND_DOWN) : /*#__PURE__*/ _jsx(Skeleton, {
        width: 60
    });
    // If user didn't connect wallet default balance will be 0
    if (!earningsBigNumber.isZero()) {
        earnings = getBalanceAmount(earningsBigNumber);
        earningsBusd = earnings.multipliedBy(cakePrice).toNumber();
        displayBalance = earnings.toFixed(5, BigNumber.ROUND_DOWN);
    }
    var toolTipBalance = !userDataReady ? /*#__PURE__*/ _jsx(Skeleton, {
        width: 60
    }) : earnings.isGreaterThan(new BigNumber(0.00001)) ? earnings.toFixed(5, BigNumber.ROUND_DOWN) : "< 0.00001";
    var ref1 = useTooltip("".concat(toolTipBalance, " ").concat(t("CAKE has been harvested to the farm booster contract and will be automatically sent to your wallet upon the next harvest.")), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var chainId = useActiveWeb3React().chainId;
    return /*#__PURE__*/ _jsxs(ActionContainer, {
        children: [
            /*#__PURE__*/ _jsxs(ActionTitles, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        bold: true,
                        pr: "4px",
                        children: "Pi"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        bold: true,
                        children: t("earned")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ActionContent, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            proxyCakeBalance ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(TooltipText, {
                                        ref: targetRef,
                                        decorationColor: "secondary",
                                        children: /*#__PURE__*/ _jsx(Heading, {
                                            children: displayBalance
                                        })
                                    }),
                                    tooltipVisible && tooltip
                                ]
                            }) : /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                children: displayBalance
                            }),
                            earningsBusd > 0 && /*#__PURE__*/ _jsx(Balance, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: earningsBusd,
                                unit: renderCurenccySymbol(),
                                prefix: "~"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: earnings.eq(0) || pendingTx || !userDataReady,
                        onClick: /*#__PURE__*/ _async_to_generator(function() {
                            var receipt;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            fetchWithCatchTxError(function() {
                                                return onReward();
                                            })
                                        ];
                                    case 1:
                                        receipt = _state.sent();
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            toastSuccess("".concat(t("Harvest successfully"), "!"), /*#__PURE__*/ _jsx(ToastDescriptionWithTx, {
                                                txHash: receipt.transactionHash
                                            }));
                                            onDone === null || onDone === void 0 ? void 0 : onDone();
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        ml: "4px",
                        endIcon: pendingTx ? /*#__PURE__*/ _jsx(AutoRenewIcon, {
                            spin: true,
                            color: "textDisabled",
                            opacity: "0.5"
                        }) : null,
                        children: pendingTx ? t("Harvesting") : t("Harvest")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Actions_HarvestAction = ((/* unused pure expression or super */ null && (HarvestAction)));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useStakeFarms.ts






var useStakeFarms = function(pid) {
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var handleStake = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    (0,calls/* stakeFarm */.AQ)(masterChefContract, pid, amount, gasPrice)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    return {
        onStake: handleStake
    };
};
/* harmony default export */ var hooks_useStakeFarms = (useStakeFarms);

;// CONCATENATED MODULE: ./src/views/Farms/hooks/useUnstakeFarms.ts






var useUnstakeFarms = function(pid) {
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var handleUnstake = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    (0,calls/* unstakeFarm */.dU)(masterChefContract, pid, amount, gasPrice)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    return {
        onUnstake: handleUnstake
    };
};
/* harmony default export */ var hooks_useUnstakeFarms = (useUnstakeFarms);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/ModalV2.tsx
var ModalV2 = __webpack_require__(82456);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67405);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Error = __webpack_require__(11658);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
;// CONCATENATED MODULE: ./src/components/Modal/Spacer.tsx

function Spacer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    Spacer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Spacer = function(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size;
    var spacing = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni).spacing;
    var s;
    switch(size){
        case "lg":
            s = spacing[6];
            break;
        case "sm":
            s = spacing[2];
            break;
        case "md":
        default:
            s = spacing[4];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpacer, {
        size: s
    });
};
var StyledSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fdefb931-0"
})(Spacer_templateObject(), function(props) {
    return props.size;
}, function(props) {
    return props.size;
});
/* harmony default export */ var Modal_Spacer = (Spacer);

;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.tsx

function ModalActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        "00;\n  display: flex;\n  margin: 0;\n  padding: ",
        " 0;\n"
    ]);
    ModalActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalActions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    ModalActions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ModalActions = function(param) {
    var children = param.children;
    var l = react.Children.toArray(children).length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalActions, {
        children: react.Children.map(children, function(child, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalAction, {
                        children: child
                    }),
                    i < l - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Spacer, {})
                ]
            });
        })
    });
};
var StyledModalActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f6d3289-0"
})(ModalActions_templateObject(), function(props) {
    return props.theme.colors.primaryDark;
}, function(props) {
    return props.theme.spacing[4];
});
var StyledModalAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f6d3289-1"
})(ModalActions_templateObject1());
/* harmony default export */ var Modal_ModalActions = (ModalActions);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
;// CONCATENATED MODULE: ./src/components/Modal/ModalInput.tsx

function ModalInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  border-radius: 0px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  padding: 12px 16px 12px 0;\n  width: 100%;\n"
    ]);
    ModalInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  width: 60px;\n  margin: 0 8px;\n  padding: 0 8px;\n  border: none;\n\n  ",
        " {\n    width: 80px;\n  }\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    ModalInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalInput_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -22px;\n  a {\n    display: inline;\n  }\n"
    ]);
    ModalInput_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalInput_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    padding-left:12px;\n    padding-right:8px;\n    @media screen and (max-width:600px) {\n      width: 100%;\n    }\n"
    ]);
    ModalInput_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalInput_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     > input {\n            background:transparent !important;\n            border:none;\n            box-shadow:none;\n            color:",
        ";\n            font-size:16px;\n            width: 100%;\n            font-size:16px;\n        }\n"
    ]);
    ModalInput_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalInput_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:focus-visible {\n        outline: none;\n    }\n    ::placeholder { \n        color:",
        ";\n        opacity: 1; \n    }\n"
    ]);
    ModalInput_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items:center;\n    @media screen and (max-width:600px) {\n      width: 100%;\n      flex-direction:row;\n      padding-left: 12px;\n      gap:10px;\n      margin-top:6px;\n    }\n\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     @media screen and (max-width:600px) {\n      width:100px;\n     }\n\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}







var StyledTokenInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa23c6f0-0"
})(ModalInput_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-1"
})(ModalInput_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-2"
})(ModalInput_templateObject2());
var ModalInput = function(param) {
    var max = param.max, symbol = param.symbol, onChange = param.onChange, onSelectMax = param.onSelectMax, value = param.value, addLiquidityUrl = param.addLiquidityUrl, inputTitle = param.inputTitle, _decimals = param.decimals, decimals = _decimals === void 0 ? 18 : _decimals;
    var t = (0,src/* useTranslation */.$G)().t;
    var isBalanceZero = max === "0" || !max;
    var displayBalance = function(balance) {
        if (isBalanceZero) {
            return "0";
        }
        var balanceUnits = (0,lib_esm.parseUnits)(balance, decimals);
        return (0,formatBalance/* formatBigNumber */.dp)(balanceUnits, decimals, decimals);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTokenInput, {
                isWarning: isBalanceZero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        justifyContent: "space-between",
                        pl: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: inputTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Balance: %balance%", {
                                    balance: displayBalance(max)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        alignItems: "flex-end",
                        justifyContent: "space-around",
                        mt: "8px",
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceInput, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsBox, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, {
                                        value: value,
                                        decimalScale: 18,
                                        thousandSeparator: !false,
                                        placeholder: "0.00",
                                        // eslint-disable-next-line no-return-assign, no-param-reassign
                                        onValueChange: function(values) {
                                            // eslint-disable-next-line @typescript-eslint/no-shadow
                                            var value = values.value;
                                            // eslint-disable-next-line @typescript-eslint/no-shadow
                                            onChange(value);
                                        },
                                        maxLength: 35
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsContainerButton, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                        scale: "sm",
                                        onClick: onSelectMax,
                                        mr: "8px",
                                        children: t("Max")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "16px",
                                        children: symbol
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isBalanceZero && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledErrorMessage, {
                fontSize: "14px",
                color: "failure",
                children: t("No tokens to stake")
            })
        ]
    });
};
/* harmony default export */ var Modal_ModalInput = (ModalInput);
var StyledBalanceInput = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-3"
})(ModalInput_templateObject3());
var CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box_Box/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-4"
})(ModalInput_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-5"
})(ModalInput_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsContainerButton = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-6"
})(_templateObject6());
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    componentId: "sc-aa23c6f0-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/components/Modal/index.ts



// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(57714);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(17664);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(49008);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(80959);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUserBoosterStatus.ts
var hooks_useUserBoosterStatus = __webpack_require__(5862);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUserLockedCakeStatus.ts
var hooks_useUserLockedCakeStatus = __webpack_require__(36668);
;// CONCATENATED MODULE: ./src/views/Farms/images/boosterCardImage.png
/* harmony default export */ var images_boosterCardImage = ({"src":"/_next/static/media/boosterCardImage.c6eac1af.png","height":368,"width":190,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAPFBMVEVMaXGy0XCgfkmqhlCE5XDowEnRpWJ64m/RoW24iVvPxrzp37/my6+o0nCaf1h15Gu4kEaSbjjKmVmneyrlg2UsAAAAEHRSTlMAcdWvMkXkWD16GxhKqlSYcquYEgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAClJREFUeJwFwQkCgBAAALAluVKo///VRszIA8dDS1/R51/dYb3UE+WyARAjANdglRAhAAAAAElFTkSuQmCC","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/CreateProxyButton.tsx












var MAX_GAS_LIMIT = 2500000;
var CreateProxyButton_CreateProxyButton = function(_param) {
    var onDone = _param.onDone, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "onDone"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var farmBoosterProxyFactoryContract = (0,useContract/* useBCakeFarmBoosterProxyFactoryContract */.lZ)();
    var ref = (0,react.useState)(false), isCreateProxyLoading = ref[0], setIsCreateProxyLoading = ref[1];
    var toastSuccess = (0,ToastsContext_useToast/* useToast */.p)().toastSuccess;
    var ref1 = useCatchTxError_useCatchTxError(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, loading = ref1.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            var receipt, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsCreateProxyLoading(true);
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return farmBoosterProxyFactoryContract.createFarmBoosterProxy({
                                    gasLimit: MAX_GAS_LIMIT
                                });
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsCreateProxyLoading(false);
                        onDone === null || onDone === void 0 ? void 0 : onDone();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }),
        isLoading: isCreateProxyLoading || loading,
        endIcon: isCreateProxyLoading || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : undefined,
        children: isCreateProxyLoading || loading ? t("Confirming...") : t("Enable")
    }));
};
/* harmony default export */ var components_CreateProxyButton = (/*#__PURE__*/(0,react.memo)(CreateProxyButton_CreateProxyButton));

;// CONCATENATED MODULE: ./src/views/Farms/components/BCakeBoosterCard.tsx


function BCakeBoosterCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  margin-top: 10px;\n  ",
        " {\n    width: 296px;\n    margin-left: 50px;\n  }\n  ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    BCakeBoosterCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BCakeBoosterCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -50px;\n  transform: translateY(-50%) scale(75%);\n  right: 10px;\n  ",
        " {\n    right: auto;\n    top: 50%;\n    left: -70px;\n    transform: translateY(-50%);\n  }\n  z-index: 2;\n"
    ]);
    BCakeBoosterCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BCakeBoosterCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: none;\n"
    ]);
    BCakeBoosterCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BCakeBoosterCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: none;\n  position: relative;\n  padding: 8px 24px 16px;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: calc(100% - 48px);\n    top: 0px;\n    left: 24px;\n    background-color: ",
        ";\n  }\n"
    ]);
    BCakeBoosterCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var CardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71a91acc-0"
})(BCakeBoosterCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71a91acc-1"
})(BCakeBoosterCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-71a91acc-2"
})(BCakeBoosterCard_templateObject2());
var StyledCardFooter = (0,styled_components_browser_esm/* default */.ZP)(CardFooter/* default */.Z).withConfig({
    componentId: "sc-71a91acc-3"
})(BCakeBoosterCard_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var useBCakeTooltipContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var tooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                mb: "20px",
                children: t("Yield Boosters allow you to boost your farming yields by locking CAKE in the fixed-term staking CAKE pool. The more CAKE you lock, and the longer you lock them, the higher the boost you will receive.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                children: [
                    t("To learn more, check out the"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        target: "_blank",
                        href: "https://medium.com/pancakeswap/introducing-bcake-farm-yield-boosters-b27b7a6f0f84",
                        children: t("Medium Article")
                    })
                ]
            })
        ]
    });
    return tooltipContent;
};
var BCakeBoosterCard = function() {
    var t = useTranslation().t;
    var theme = useTheme();
    var isMobile = useMatchBreakpoints().isMobile;
    var tooltipContent = useBCakeTooltipContent();
    var ref = useTooltip(tooltipContent, _object_spread({
        placement: "bottom-start"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ _jsxs(CardWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ImageWrapper, {
                children: /*#__PURE__*/ _jsx(Image, {
                    src: boosterCardImage,
                    alt: "boosterCardImage",
                    width: 99,
                    height: 191,
                    placeholder: "blur"
                })
            }),
            /*#__PURE__*/ _jsxs(Card, {
                p: "0px",
                style: {
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ _jsxs(StyledCardBody, {
                        style: {
                            padding: "15px 24px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(RocketIcon, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: 22,
                                bold: true,
                                color: "text",
                                marginBottom: "-12px",
                                display: "inline-block",
                                ml: "7px",
                                children: t("Yield Booster")
                            }),
                            tooltipVisible && tooltip,
                            /*#__PURE__*/ _jsx(Box, {
                                ref: targetRef,
                                style: {
                                    float: "right",
                                    position: "relative",
                                    top: "6px"
                                },
                                children: /*#__PURE__*/ _jsx(HelpIcon, {
                                    color: theme.colors.textSubtle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(StyledCardFooter, {
                        children: /*#__PURE__*/ _jsx(CardContent, {})
                    })
                ]
            })
        ]
    });
};
var CardContent = function() {
    var t = useTranslation().t;
    var ref = useActiveWeb3React(), account = ref.account, chainId = ref.chainId;
    var ref1 = useBCakeProxyContractAddress(account, chainId), proxyCreated = ref1.proxyCreated, refreshProxyAddress = ref1.refreshProxyAddress;
    var ref2 = useUserBoosterStatus(account), maxBoostCounts = ref2.maxBoostCounts, remainingCounts = ref2.remainingCounts;
    var ref3 = useUserLockedCakeStatus(), locked = ref3.locked, lockedEnd = ref3.lockedEnd;
    var theme = useTheme();
    if (!account) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Connect wallet to view booster")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term CAKE staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(ConnectWalletButton, {
                width: "100%",
                style: {
                    backgroundColor: theme.colors.textSubtle
                }
            })
        ]
    });
    if (!locked) return /*#__PURE__*/ _jsxs(Box, {
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("No CAKE locked")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term CAKE staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                href: "/pools",
                passHref: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    as: "a",
                    width: "100%",
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    },
                    children: t("Go to Pool")
                })
            })
        ]
    });
    if (lockedEnd === "0" || new Date() > new Date(parseInt(lockedEnd) * 1000)) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Locked staking is ended")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term CAKE staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                href: "/pools",
                passHref: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    as: "a",
                    width: "100%",
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    },
                    children: t("Go to Pool")
                })
            })
        ]
    });
    if (!proxyCreated) {
        return /*#__PURE__*/ _jsxs(Box, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    color: "textSubtle",
                    fontSize: 12,
                    bold: true,
                    children: t("Available Yield Booster")
                }),
                /*#__PURE__*/ _jsx(Text, {
                    color: "textSubtle",
                    fontSize: 12,
                    mb: "16px",
                    children: t("A one-time setup is required for enabling farm yield boosters.")
                }),
                /*#__PURE__*/ _jsx(CreateProxyButton, {
                    onDone: refreshProxyAddress,
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    }
                })
            ]
        });
    }
    if (remainingCounts > 0) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "5px",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: t("Available Yield Booster")
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        color: "secondary",
                        fontSize: 16,
                        bold: true,
                        textTransform: "uppercase",
                        children: [
                            remainingCounts,
                            "/",
                            maxBoostCounts
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                children: t("You will be able to activate the yield booster on an additional %num% farm(s).", {
                    num: remainingCounts
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: t("Available Yield Booster")
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: "0"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                children: t("To activate yield boosters on additional farms, unset yield boosters on some currently boosted farms.")
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDuration/index.js + 12 modules
var formatDuration = __webpack_require__(81388);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInWeeks/index.js + 1 modules
var differenceInWeeks = __webpack_require__(28584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 3 modules
var differenceInDays = __webpack_require__(98000);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js + 1 modules
var addSeconds = __webpack_require__(23302);
;// CONCATENATED MODULE: ./src/views/Pools/components/utils/formatSecondsToWeeks.ts




var secondsToWeeks = function(seconds) {
    var now = new Date();
    var addedDate = (0,addSeconds/* default */.Z)(now, seconds);
    return (0,differenceInWeeks/* default */.Z)(new Date(addedDate), now, {
        roundingMethod: "round"
    });
};
var secondsToDays = function(seconds) {
    var now = new Date();
    var addedDate = (0,addSeconds/* default */.Z)(now, seconds);
    return (0,differenceInDays/* default */.Z)(new Date(addedDate), now);
};
var weeksToSeconds = function(weeks) {
    return weeks * 7 * 24 * 60 * 60;
};
var formatSecondsToWeeks = function(secondDuration) {
    return (0,formatDuration/* default */.Z)({
        weeks: secondsToWeeks(secondDuration)
    });
};
/* harmony default export */ var utils_formatSecondsToWeeks = (formatSecondsToWeeks);

// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 2 modules
var pools_hooks = __webpack_require__(203);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/utils/getFullDecimalMultiplier.ts
var getFullDecimalMultiplier = __webpack_require__(27750);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useAvgLockDuration.tsx








function useAvgLockDuration() {
    var ref = (0,pools_hooks/* useCakeVault */.Xo)(), totalLockedAmount = ref.totalLockedAmount, totalShares = ref.totalShares, totalCakeInVault = ref.totalCakeInVault, pricePerFullShare = ref.pricePerFullShare;
    var avgLockDurationsInSeconds = (0,react.useMemo)(function() {
        var flexibleCakeAmount = totalCakeInVault.minus(totalLockedAmount);
        var flexibleCakeShares = flexibleCakeAmount.div(pricePerFullShare).times(config/* DEFAULT_TOKEN_DECIMAL */.o3);
        var lockedCakeBoostedShares = totalShares.minus(flexibleCakeShares);
        var lockedCakeOriginalShares = totalLockedAmount.div(pricePerFullShare).times(config/* DEFAULT_TOKEN_DECIMAL */.o3);
        var avgBoostRatio = lockedCakeBoostedShares.div(lockedCakeOriginalShares);
        return avgBoostRatio.minus(1).times(new bignumber/* default */.Z(pools/* DURATION_FACTOR.toString */.A0.toString())).div(new bignumber/* default */.Z(pools/* BOOST_WEIGHT.toString */.xt.toString()).div((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(12))).toFixed(0);
    }, [
        totalCakeInVault,
        totalLockedAmount,
        pricePerFullShare,
        totalShares
    ]);
    var avgLockDurationsInWeeks = (0,react.useMemo)(function() {
        return utils_formatSecondsToWeeks(avgLockDurationsInSeconds);
    }, [
        avgLockDurationsInSeconds
    ]);
    return {
        avgLockDurationsInWeeks: avgLockDurationsInWeeks,
        avgLockDurationsInSeconds: toNumber_default()(avgLockDurationsInSeconds)
    };
}

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useGetBoostedAPR.ts







var useGetBoostedMultiplier = function(userBalanceInFarm, lpTotalSupply) {
    (0,pools_hooks/* useCakeVaultPublicData */.uf)();
    (0,pools_hooks/* useCakeVaultUserData */.Es)();
    var avgLockDurationsInSeconds = useAvgLockDuration().avgLockDurationsInSeconds;
    var ref = (0,hooks_useUserLockedCakeStatus/* useUserLockedCakeStatus */.u)(), isLoading = ref.isLoading, lockedAmount = ref.lockedAmount, totalLockedAmount = ref.totalLockedAmount, lockedStart = ref.lockedStart, lockedEnd = ref.lockedEnd;
    var bCakeMultiplier = (0,react.useMemo)(function() {
        var result = getBCakeMultiplier(userBalanceInFarm, lockedAmount, secondsToDays(toNumber_default()(lockedEnd) - toNumber_default()(lockedStart)), totalLockedAmount, lpTotalSupply, avgLockDurationsInSeconds ? secondsToDays(avgLockDurationsInSeconds) : 280);
        return result.toString() === "NaN" || isLoading ? "1.000" : result.toFixed(3);
    }, [
        userBalanceInFarm,
        lpTotalSupply,
        totalLockedAmount,
        avgLockDurationsInSeconds,
        lockedAmount,
        lockedEnd,
        lockedStart,
        isLoading, 
    ]);
    return toNumber_default()(bCakeMultiplier);
};
var useGetCalculatorMultiplier = function(userBalanceInFarm, lpTotalSupply, lockedAmount, userLockDuration) {
    (0,pools_hooks/* useCakeVaultPublicData */.uf)();
    (0,pools_hooks/* useCakeVaultUserData */.Es)();
    var avgLockDurationsInSeconds = useAvgLockDuration().avgLockDurationsInSeconds;
    var ref = (0,hooks_useUserLockedCakeStatus/* useUserLockedCakeStatus */.u)(), isLoading = ref.isLoading, totalLockedAmount = ref.totalLockedAmount;
    var bCakeMultiplier = (0,react.useMemo)(function() {
        var result = getBCakeMultiplier(userBalanceInFarm, lockedAmount, secondsToDays(userLockDuration), totalLockedAmount, lpTotalSupply, avgLockDurationsInSeconds ? secondsToDays(avgLockDurationsInSeconds) : 280);
        return result.toString() === "NaN" || isLoading ? "1.000" : result.toFixed(3);
    }, [
        userBalanceInFarm,
        lpTotalSupply,
        totalLockedAmount,
        avgLockDurationsInSeconds,
        lockedAmount,
        isLoading,
        userLockDuration, 
    ]);
    return toNumber_default()(bCakeMultiplier);
};
var useGetBoostedAPR = function(userBalanceInFarm, lpTotalSupply, apr, lpRewardsApr) {
    var bCakeMultiplier = useGetBoostedMultiplier(userBalanceInFarm, lpTotalSupply);
    return (apr * bCakeMultiplier + lpRewardsApr).toFixed(2);
};
/* harmony default export */ var hooks_useGetBoostedAPR = (useGetBoostedAPR);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BCakeLockedDuration.tsx

function BCakeLockedDuration_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  box-sizing: border-box;\n  padding-right: 55px;\n"
    ]);
    BCakeLockedDuration_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DURATIONS = [
    1,
    5,
    10,
    25,
    52
];
var BCakeLockedDuration_StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-5fbc963e-0"
})(BCakeLockedDuration_templateObject());
var LockDurationField = function(param) {
    var duration = param.duration, setDuration = param.setDuration, isOverMax = param.isOverMax, currentDuration = param.currentDuration, currentDurationLeft = param.currentDurationLeft;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var maxAvailableDuration = currentDurationLeft ? pools/* MAX_LOCK_DURATION */.VO - currentDurationLeft : pools/* MAX_LOCK_DURATION */.VO;
    // When user extends the duration due to time passed when approving
    // transaction the extended duration will be a couple of seconds off to max duration,
    // therefore it is better to compare based on weeks
    var currentDurationInWeeks = (0,react.useMemo)(function() {
        return currentDuration && secondsToWeeks(currentDuration);
    }, [
        currentDuration
    ]);
    var maxDurationInWeeks = (0,react.useMemo)(function() {
        return secondsToWeeks(pools/* MAX_LOCK_DURATION */.VO);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                mb: "16px",
                mt: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        mb: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "12px",
                            color: "textSubtle",
                            bold: true,
                            textTransform: "uppercase",
                            children: t("locked for")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        children: DURATIONS.map(function(week) {
                            var weekSeconds = weeksToSeconds(week);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                onClick: function() {
                                    setDuration(weekSeconds);
                                },
                                pl: "12px",
                                pr: "12px",
                                scale: "sm",
                                disabled: weekSeconds > maxAvailableDuration,
                                variant: weekSeconds === duration ? "subtle" : "light",
                                children: [
                                    week,
                                    "W"
                                ]
                            }, week);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        mr: "8px",
                        width: "50%",
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BCakeLockedDuration_StyledInput, {
                                value: secondsToWeeks(duration),
                                autoComplete: "off",
                                pattern: "^[0-9]+$",
                                inputMode: "numeric",
                                scale: "sm",
                                onChange: function(e) {
                                    var ref;
                                    var weeks = toNumber_default()(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                    if (e.currentTarget.validity.valid && weeks < 53) {
                                        var ref1;
                                        setDuration(weeksToSeconds(toNumber_default()(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value)));
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                position: "absolute",
                                width: "60px",
                                top: "8px",
                                right: "0px",
                                color: theme.colors.text,
                                style: {
                                    textAlign: "center"
                                },
                                children: t("Weeks")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: function() {
                            setDuration(currentDuration);
                        },
                        scale: "sm",
                        disabled: currentDuration === 0,
                        variant: "tertiary",
                        width: "50%",
                        children: t("My Duration")
                    }, "max")
                ]
            }),
            isOverMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                fontSize: "12px",
                textAlign: "right",
                color: "failure",
                children: t("Total lock duration exceeds 52 weeks")
            }),
            currentDurationLeft && currentDurationInWeeks === maxDurationInWeeks ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    maxWidth: "240px",
                    children: t('Recommend choosing "MAX" to renew your staking position in order to keep similar yield boost.')
                })
            }) : null
        ]
    });
};
/* harmony default export */ var BCakeLockedDuration = (LockDurationField);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BCakeCalculator.tsx

function BCakeCalculator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  border-radius: 16px;\n"
    ]);
    BCakeCalculator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var BCakeBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bce96a42-0"
})(BCakeCalculator_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var BCakeCalculator = function(param) {
    var targetInputBalance = param.targetInputBalance, earningTokenPrice = param.earningTokenPrice, initialState = param.initialState, _stakingTokenSymbol = param.stakingTokenSymbol, stakingTokenSymbol = _stakingTokenSymbol === void 0 ? "CAKE" : _stakingTokenSymbol, lpTotalSupply = param.lpTotalSupply, setBCakeMultiplier = param.setBCakeMultiplier;
    var ref = (0,react.useState)(true), isShow = ref[0], setIsShow = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(function() {
        return weeksToSeconds(1);
    }), duration = ref1[0], setDuration = ref1[1];
    var ref2 = (0,hooks_useUserLockedCakeStatus/* useUserLockedCakeStatus */.u)(), isLoading = ref2.isLoading, lockedAmount = ref2.lockedAmount, lockedStart = ref2.lockedStart, lockedEnd = ref2.lockedEnd;
    var ref3 = RoiCalculatorModal_useRoiCalculatorReducer({
        stakingTokenPrice: earningTokenPrice,
        earningTokenPrice: earningTokenPrice,
        autoCompoundFrequency: 0
    }, initialState), state = ref3.state, setPrincipalFromUSDValue = ref3.setPrincipalFromUSDValue, setPrincipalFromTokenValue = ref3.setPrincipalFromTokenValue, toggleEditingCurrency = ref3.toggleEditingCurrency, setCalculatorMode = ref3.setCalculatorMode;
    var editingCurrency = state.controls.editingCurrency;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, principalAsToken = _data.principalAsToken;
    var onBalanceFocus = function() {
        setCalculatorMode(CalculatorMode.ROI_BASED_ON_PRINCIPAL);
    };
    var userBalanceInFarm = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(targetInputBalance).multipliedBy(bigNumber/* BIG_TEN.pow */.xp.pow(18));
    }, [
        targetInputBalance
    ]);
    var userLockedAmount = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(principalAsToken).multipliedBy(bigNumber/* BIG_TEN.pow */.xp.pow(18));
    }, [
        principalAsToken
    ]);
    var bCakeMultiplier = useGetCalculatorMultiplier(userBalanceInFarm, lpTotalSupply, userLockedAmount, duration);
    (0,react.useEffect)(function() {
        setBCakeMultiplier(bCakeMultiplier);
    }, [
        bCakeMultiplier,
        setBCakeMultiplier
    ]);
    var editingUnit = editingCurrency === EditingCurrency.TOKEN ? stakingTokenSymbol : "USD";
    var editingValue = editingCurrency === EditingCurrency.TOKEN ? principalAsToken : principalAsUSD;
    var conversionUnit = editingCurrency === EditingCurrency.TOKEN ? "USD" : stakingTokenSymbol;
    var conversionValue = editingCurrency === EditingCurrency.TOKEN ? principalAsUSD : principalAsToken;
    var onUserInput = editingCurrency === EditingCurrency.TOKEN ? setPrincipalFromTokenValue : setPrincipalFromUSDValue;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var tooltipContent = useBCakeTooltipContent();
    var ref4 = (0,useTooltip_useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    var ref5 = (0,useTooltip_useTooltip/* default */.Z)(t("Boost multiplier calculation does not include profit from CAKE staking pool"), {
        placement: "bottom-start"
    }), myBalanceTargetRef = ref5.targetRef, myBalanceTooltip = ref5.tooltip, myBalanceTooltipVisible = ref5.tooltipVisible;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                color: "secondary",
                bold: true,
                fontSize: "12px",
                textTransform: "uppercase",
                mt: "24px",
                mb: "8px",
                children: t("Yield Booster")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                scale: "md",
                checked: isShow,
                onClick: function() {
                    return setIsShow(!isShow);
                }
            }),
            isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BCakeBlock, {
                        style: {
                            marginTop: 24
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: t("Cake locked")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                                inputProps: {
                                    scale: "sm"
                                },
                                currencyValue: "".concat(conversionValue, " ").concat(conversionUnit),
                                // innerRef={balanceInputRef}
                                placeholder: "0.00",
                                value: editingValue,
                                unit: editingUnit,
                                onUserInput: onUserInput,
                                switchEditingUnits: toggleEditingCurrency,
                                onFocus: onBalanceFocus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mt: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "tertiary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("100");
                                        },
                                        children: "$100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "tertiary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("1000");
                                        },
                                        children: "$1000"
                                    }),
                                    myBalanceTooltipVisible && myBalanceTooltip,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        ref: myBalanceTargetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            disabled: !account || isLoading || lockedAmount.eq(0),
                                            scale: "xs",
                                            p: "4px 16px",
                                            width: "128px",
                                            variant: "tertiary",
                                            style: {
                                                textTransform: "uppercase"
                                            },
                                            onClick: function() {
                                                return setPrincipalFromUSDValue((0,formatBalance/* getBalanceNumber */.mW)(lockedAmount.times(earningTokenPrice)).toFixed(2));
                                            },
                                            children: t("My Balance")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BCakeLockedDuration, {
                                duration: duration,
                                setDuration: setDuration,
                                currentDuration: toNumber_default()(lockedEnd) - toNumber_default()(lockedStart),
                                isOverMax: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BCakeBlock, {
                        style: {
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: t("Boost Multiplier")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                fontSize: "20px",
                                textTransform: "uppercase",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            bCakeMultiplier,
                                            "X"
                                        ]
                                    }),
                                    tooltipVisible && tooltip,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        ref: targetRef,
                                        marginLeft: "3px",
                                        display: "inline-block",
                                        position: "relative",
                                        top: "3px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                            color: theme.colors.textSubtle
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: 12,
                                children: t("The estimated boost multiplier is calculated using live data. The actual boost multiplier may change upon activation.")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BCakeCalculator = (BCakeCalculator);
var CA = 0.5;
var CB = 5;
var getBCakeMultiplier = function(userBalanceInFarm, userLockAmount, userLockDuration, totalLockAmount, lpBalanceOfFarm, averageLockDuration) {
    var dB = userBalanceInFarm.times(CA);
    var aBPart1 = lpBalanceOfFarm.times(userLockAmount).times(userLockDuration);
    var aBPart3 = totalLockAmount.times(averageLockDuration);
    var aB = aBPart1.dividedBy(CB).dividedBy(aBPart3);
    var bigNumberResult = dB.plus(aB).gt(userBalanceInFarm) ? userBalanceInFarm.dividedBy(dB) : dB.plus(aB).dividedBy(dB);
    return bigNumberResult;
};

;// CONCATENATED MODULE: ./src/views/Farms/components/DepositModal.tsx



function DepositModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    DepositModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DepositModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  @media screen and (max-width:600px) {\n      width: auto;\n      max-width: 150px;\n  }\n"
    ]);
    DepositModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DepositModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    color: ",
        ";\n    border: 2px solid #E6E8EC;\n    border-radius: 90px;\n"
    ]);
    DepositModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DepositModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top:15px;\n"
    ]);
    DepositModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DepositModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-end;\n   @media screen and (max-width:600px) {\n      width: 50%;\n    }\n"
    ]);
    DepositModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var AnnualRoiContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-e8fa33dc-0"
})(DepositModal_templateObject());
var AnnualRoiDisplay = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-e8fa33dc-1"
})(DepositModal_templateObject1());
var DepositModal_DepositModal = function(param) {
    var max = param.max, stakedBalance = param.stakedBalance, onConfirm = param.onConfirm, onDismiss = param.onDismiss, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName, multiplier = param.multiplier, displayApr = param.displayApr, lpPrice = param.lpPrice, _lpLabel = param.lpLabel, lpLabel = _lpLabel === void 0 ? "" : _lpLabel, apr = param.apr, addLiquidityUrl = param.addLiquidityUrl, cakePrice = param.cakePrice, showActiveBooster = param.showActiveBooster, lpTotalSupply = param.lpTotalSupply, pid = param.pid, pibTokenPrice = param.pibTokenPrice;
    var renderCurenccySymbol = // const handleChange = useCallback(
    //   (e: React.FormEvent<HTMLInputElement>) => {
    //     if (e.currentTarget.validity.valid) {
    //       setVal(e.currentTarget.value.replace(/,/g, '.'))
    //     }
    //   },
    //   [setVal],
    // )
    function renderCurenccySymbol() {
        if (chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS) {
            return "".concat(formattedAnnualRoi, " VNDC");
        }
        return "$ ".concat(formattedAnnualRoi);
    };
    var ref = (0,react.useState)(""), val = ref[0], setVal = ref[1];
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var ref1 = (0,react.useState)(function() {
        return null;
    }), bCakeMultiplier = ref1[0], setBCakeMultiplier = ref1[1];
    var ref2 = (0,react.useState)(false), pendingTx = ref2[0], setPendingTx = ref2[1];
    var ref3 = (0,react.useState)(false), showRoiCalculator = ref3[0], setShowRoiCalculator = ref3[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var fullBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getFullDisplayBalance */.NJ)(max);
    }, [
        max
    ]);
    var lpTokensToStake = new bignumber/* default */.Z(val);
    var fullBalanceNumber = new bignumber/* default */.Z(fullBalance);
    var usdToStake = lpTokensToStake.times(lpPrice);
    var interestBreakdown = getInterestBreakdown({
        principalInUSD: !lpTokensToStake.isNaN() ? usdToStake.toNumber() : 0,
        apr: apr,
        earningTokenPrice: cakePrice.toNumber()
    });
    // console.log('interestBreakdown', interestBreakdown)
    var annualRoi = cakePrice.times(interestBreakdown[3]);
    var annualRoiAsNumber = annualRoi.toNumber();
    var formattedAnnualRoi = (0,formatBalance/* formatNumber */.uf)(annualRoiAsNumber, annualRoi.gt(10000) ? 0 : 2, annualRoi.gt(10000) ? 0 : 2);
    var renderStakingTokenPrice = pid === 0 ? pibTokenPrice.toNumber() : lpPrice.toNumber();
    var handleSelectMax = (0,react.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalV2/* ModalV2 */.k, {
            isOpen: showRoiCalculator,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoiCalculatorModal, {
                linkLabel: t("Get %symbol%", {
                    symbol: lpLabel
                }),
                stakingTokenBalance: stakedBalance.plus(max),
                stakingTokenSymbol: tokenName,
                stakingTokenPrice: renderStakingTokenPrice,
                earningTokenPrice: cakePrice.toNumber(),
                apr: bCakeMultiplier ? apr * bCakeMultiplier : apr,
                multiplier: multiplier,
                displayApr: bCakeMultiplier ? (toNumber_default()(displayApr) - apr + apr * bCakeMultiplier).toFixed(2) : displayApr,
                linkHref: addLiquidityUrl,
                isFarm: true,
                initialValue: val,
                onBack: function() {
                    return setShowRoiCalculator(false);
                },
                bCakeCalculatorSlot: function(calculatorBalance) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BCakeCalculator, {
                        targetInputBalance: calculatorBalance,
                        earningTokenPrice: cakePrice.toNumber(),
                        lpTotalSupply: lpTotalSupply,
                        setBCakeMultiplier: setBCakeMultiplier
                    });
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsModal, {
        title: t("Stake"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalInput, {
                value: val,
                onSelectMax: handleSelectMax,
                // onChange={handleChange}
                onChange: function(newValue) {
                    return setVal(newValue);
                },
                max: fullBalance,
                symbol: tokenName,
                addLiquidityUrl: addLiquidityUrl,
                inputTitle: t("Stake")
            }),
            showActiveBooster ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                    width: "24px",
                    color: "warning"
                }),
                mt: "32px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    children: t("The yield booster multiplier will be updated based on the latest staking conditions.")
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                        children: Number.isFinite(annualRoiAsNumber) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiContainer, {
                            alignItems: "center",
                            onClick: function() {
                                setShowRoiCalculator(true);
                            },
                            children: [
                                chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiDisplay, {
                                    children: [
                                        formattedAnnualRoi,
                                        " VNDC"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiDisplay, {
                                    children: [
                                        "$",
                                        formattedAnnualRoi
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    variant: "text",
                                    scale: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                        color: "textSubtle",
                                        width: "18px"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            width: 60
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_ModalActions, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "primary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        width: "100%",
                        disabled: !lpTokensToStake.isFinite() || lpTokensToStake.eq(0) || lpTokensToStake.gt(fullBalanceNumber),
                        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setPendingTx(true);
                                        return [
                                            4,
                                            onConfirm(val)
                                        ];
                                    case 1:
                                        _state.sent();
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: t("Confirm")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DepositModal = (DepositModal_DepositModal);
var ButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    componentId: "sc-e8fa33dc-2"
})(DepositModal_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-e8fa33dc-3"
})(DepositModal_templateObject3());
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-e8fa33dc-4"
})(DepositModal_templateObject4());

// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading_Heading = __webpack_require__(55421);
;// CONCATENATED MODULE: ./src/views/Farms/components/StakedLP.tsx







var StakedLP_StakedLP = function(param) {
    var stakedBalance = param.stakedBalance, lpSymbol = param.lpSymbol, quoteTokenSymbol = param.quoteTokenSymbol, tokenSymbol = param.tokenSymbol, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal, percentUserStaked = param.percentUserStaked;
    var renderCurenccySymbol = function renderCurenccySymbol() {
        if (chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS) {
            return " VNDC";
        }
        return " USD";
    };
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var displayBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* formatLpBalance */.O$)(stakedBalance);
    }, [
        stakedBalance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
            style: {
                gap: "6px"
            },
            flexWrap: "wrap",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                color: stakedBalance.eq(0) ? "textDisabled" : "text",
                children: displayBalance
            })
        })
    });
};
/* harmony default export */ var components_StakedLP = (StakedLP_StakedLP);

;// CONCATENATED MODULE: ./src/views/Farms/components/WithdrawModal.tsx



function WithdrawModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top:15px;\n"
    ]);
    WithdrawModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var WithdrawModal_WithdrawModal = function(param) {
    var onConfirm = param.onConfirm, onDismiss = param.onDismiss, max = param.max, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName, showActiveBooster = param.showActiveBooster;
    var ref = (0,react.useState)(""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var fullBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getFullDisplayBalance */.NJ)(max);
    }, [
        max
    ]);
    var valNumber = new bignumber/* default */.Z(val);
    var fullBalanceNumber = new bignumber/* default */.Z(fullBalance);
    // const handleChange = useCallback(
    //   (e: React.FormEvent<HTMLInputElement>) => {
    //     if (e.currentTarget.validity.valid) {
    //       setVal(e.currentTarget.value.replace(/,/g, '.'))
    //     }
    //   },
    //   [setVal],
    // )
    var handleSelectMax = (0,react.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WithdrawModal_CsModal, {
        title: t("Unstake"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalInput, {
                onSelectMax: handleSelectMax,
                onChange: function(newValue) {
                    return setVal(newValue);
                },
                value: val,
                max: fullBalance,
                symbol: tokenName,
                inputTitle: t("Unstake")
            }),
            showActiveBooster ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mt: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    children: t("The yield booster multiplier will be updated based on the latest staking conditions.")
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_ModalActions, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "primary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        width: "100%",
                        disabled: !valNumber.isFinite() || valNumber.eq(0) || valNumber.gt(fullBalanceNumber),
                        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setPendingTx(true);
                                        return [
                                            4,
                                            onConfirm(val)
                                        ];
                                    case 1:
                                        _state.sent();
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: t("Confirm")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_WithdrawModal = (WithdrawModal_WithdrawModal);
var WithdrawModal_CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-8a92a48d-0"
})(WithdrawModal_templateObject());

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/ProxyFarmContainer.tsx
var ProxyFarmContainer = __webpack_require__(28696);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useYieldBoosterState.ts
var useYieldBoosterState = __webpack_require__(90872);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/StakedAction.tsx







function StakedAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    StakedAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StakedAction_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:nth-child(3) {\n    flex-basis: 100%;\n  }\n  min-height: 124.5px;\n  @media screen and (max-width:600px) {\n    min-height: 144.5px !important;\n  }\n  ",
        " {\n    &:nth-child(3) {\n      margin-top: 16px;\n    }\n  }\n"
    ]);
    StakedAction_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StakedAction_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:nth-child(3) {\n    flex-basis: 100%;\n  }\n  min-height: 124.5px;\n  @media screen and (max-width:600px) {\n    min-height: 90px;\n  }\n  ",
        " {\n    border: 2px solid var(--colors-input);\n    &:nth-child(3) {\n      margin-top: 16px;\n    }\n  }\n"
    ]);
    StakedAction_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

























var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1ef620d-0"
})(StakedAction_templateObject());
var StyledActionContainer = (0,styled_components_browser_esm/* default */.ZP)(styles_ActionContainer).withConfig({
    componentId: "sc-d1ef620d-1"
})(StakedAction_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledActionContainer2 = (0,styled_components_browser_esm/* default */.ZP)(ActionContainer2).withConfig({
    componentId: "sc-d1ef620d-2"
})(StakedAction_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
function useStakedActions(pid, lpContract) {
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var onStake = hooks_useStakeFarms(pid).onStake;
    var onUnstake = hooks_useUnstakeFarms(pid).onUnstake;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onApprove = hooks_useApproveFarm(lpContract, chainId).onApprove;
    var onDone = (0,react.useCallback)(function() {
        return dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                pid
            ],
            chainId: chainId
        }));
    }, [
        account,
        pid,
        chainId,
        dispatch
    ]);
    return {
        onStake: onStake,
        onUnstake: onUnstake,
        onApprove: onApprove,
        onDone: onDone
    };
}
var ProxyStakedContainer = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var account = (0,hooks_useActiveWeb3React/* default */.Z)().account;
    var lpAddress = props.lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = useProxyStakedActions(props.pid, lpContract), onStake = ref.onStake, onUnstake = ref.onUnstake, onApprove = ref.onApprove, onDone = ref.onDone;
    var allowance = (props.userData || {}).allowance;
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    return children((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onStake: onStake,
        onDone: onDone,
        onUnstake: onUnstake,
        onApprove: onApprove,
        isApproved: isApproved
    }));
};
var StakedContainer = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var account = (0,hooks_useActiveWeb3React/* default */.Z)().account;
    var lpAddress = props.lpAddress, liquidity = props.liquidity;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = useStakedActions(props.pid, lpContract), onStake = ref.onStake, onUnstake = ref.onUnstake, onApprove = ref.onApprove, onDone = ref.onDone;
    var allowance = (props.userData || {}).allowance;
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    return children((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onStake: onStake,
        onDone: onDone,
        onUnstake: onUnstake,
        onApprove: onApprove,
        isApproved: isApproved
    }));
};
var Staked = function(param) {
    var pid = param.pid, apr = param.apr, multiplier = param.multiplier, lpSymbol = param.lpSymbol, lpLabel = param.lpLabel, quoteToken = param.quoteToken, token = param.token, userDataReady = param.userDataReady, displayApr = param.displayApr, lpTotalSupply = param.lpTotalSupply, liquidity = param.liquidity, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal, userData = param.userData, onDone = param.onDone, onStake = param.onStake, onUnstake = param.onUnstake, onApprove = param.onApprove, isApproved = param.isApproved;
    var boosterState = useContext(YieldBoosterStateContext).boosterState;
    var t = useTranslation().t;
    var toastSuccess = useToast().toastSuccess;
    var ref = useCatchTxError(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var account = useActiveWeb3React().account;
    var ref1 = userData || {}, tokenBalance = ref1.tokenBalance, stakedBalance = ref1.stakedBalance;
    var router = useRouter();
    var lpPrice = useLpTokenPrice(lpSymbol);
    // const cakePrice = usePriceRunBusd()
    var cakePrice = useTokenPriceWPi();
    var convertStakedBalance = Number(stakedBalance.dividedBy(1E18).toString()) * Number(lpPrice.toString());
    var convertLiquidity = Number(liquidity === null || liquidity === void 0 ? void 0 : liquidity.toString()) > 0;
    var percentUserStaked = convertLiquidity ? "".concat((convertStakedBalance / Number(liquidity === null || liquidity === void 0 ? void 0 : liquidity.toString()) * 100).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }), "%") : "0.00%";
    var liquidityUrlPathParts = getLiquidityUrlPathParts({
        quoteTokenAddress: quoteToken.address,
        tokenAddress: token.address
    });
    var addLiquidityUrl = "/add/".concat(liquidityUrlPathParts);
    var handleStake = function() {
        var _ref = _async_to_generator(function(amount) {
            var receipt;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onStake(amount);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked successfully"), "!"), /*#__PURE__*/ _jsx(ToastDescriptionWithTx, {
                                txHash: receipt.transactionHash
                            }));
                            onDone();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = _async_to_generator(function(amount) {
            var receipt;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onUnstake(amount);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked successfully"), "!"), /*#__PURE__*/ _jsx(ToastDescriptionWithTx, {
                                txHash: receipt.transactionHash
                            }));
                            onDone();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(DepositModal, {
        pid: pid,
        lpTotalSupply: lpTotalSupply,
        max: tokenBalance,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        addLiquidityUrl: addLiquidityUrl,
        cakePrice: cakePrice,
        showActiveBooster: boosterState === YieldBoosterState.ACTIVE
    })), 1), onPresentDeposit = ref2[0];
    var ref3 = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(WithdrawModal, {
        showActiveBooster: boosterState === YieldBoosterState.ACTIVE,
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref3[0];
    var handleApprove = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var receipt;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return onApprove();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract enabled"), /*#__PURE__*/ _jsx(ToastDescriptionWithTx, {
                            txHash: receipt.transactionHash
                        }));
                        onDone();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        onApprove,
        t,
        toastSuccess,
        fetchWithCatchTxError,
        onDone
    ]);
    if (!account) {
        return /*#__PURE__*/ _jsxs(StyledActionContainer, {
            children: [
                /*#__PURE__*/ _jsx(ActionTitles, {
                    children: /*#__PURE__*/ _jsx(Text, {
                        bold: true,
                        color: "text",
                        children: t("Start farming")
                    })
                }),
                /*#__PURE__*/ _jsx(ActionContent, {
                    children: /*#__PURE__*/ _jsx(ConnectWalletButton, {
                        width: "100%"
                    })
                })
            ]
        });
    }
    if (isApproved) {
        if (stakedBalance.gt(0)) {
            return /*#__PURE__*/ _jsxs(StyledActionContainer, {
                children: [
                    /*#__PURE__*/ _jsxs(ActionTitles, {
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                color: "text",
                                pr: "4px",
                                children: lpSymbol
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                color: "text",
                                children: t("Staked")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(ActionContent, {
                        children: [
                            /*#__PURE__*/ _jsx(StakedLP, {
                                stakedBalance: stakedBalance,
                                lpSymbol: lpSymbol,
                                quoteTokenSymbol: quoteToken.symbol,
                                tokenSymbol: token.symbol,
                                lpTotalSupply: lpTotalSupply,
                                tokenAmountTotal: tokenAmountTotal,
                                quoteTokenAmountTotal: quoteTokenAmountTotal,
                                percentUserStaked: percentUserStaked
                            }),
                            /*#__PURE__*/ _jsxs(IconButtonWrapper, {
                                children: [
                                    /*#__PURE__*/ _jsx(IconButtonV2, {
                                        onClick: onPresentWithdraw,
                                        mr: "6px",
                                        children: /*#__PURE__*/ _jsx(MinusIcon, {
                                            color: "black",
                                            width: "14px"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(IconButtonV2, {
                                        onClick: onPresentDeposit,
                                        disabled: [
                                            "history",
                                            "archived"
                                        ].some(function(item) {
                                            return router.pathname.includes(item);
                                        }),
                                        children: /*#__PURE__*/ _jsx(AddIcon, {
                                            color: "black",
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsxs(StyledActionContainer, {
            children: [
                /*#__PURE__*/ _jsxs(ActionTitles, {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            bold: true,
                            color: "text",
                            pr: "4px",
                            children: t("Stake")
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            bold: true,
                            color: "text",
                            children: lpSymbol
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ActionContent, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        width: "100%",
                        onClick: onPresentDeposit,
                        variant: "primary",
                        disabled: [
                            "history",
                            "archived"
                        ].some(function(item) {
                            return router.pathname.includes(item);
                        }),
                        children: t("stake LP")
                    })
                })
            ]
        });
    }
    if (!userDataReady) {
        return /*#__PURE__*/ _jsxs(StyledActionContainer, {
            children: [
                /*#__PURE__*/ _jsx(ActionTitles, {
                    children: /*#__PURE__*/ _jsx(Text, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "text",
                        children: t("Start Farming")
                    })
                }),
                /*#__PURE__*/ _jsx(ActionContent, {
                    children: /*#__PURE__*/ _jsx(Skeleton, {
                        width: 180,
                        marginBottom: 28,
                        marginTop: 14
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(StyledActionContainer2, {
        children: [
            /*#__PURE__*/ _jsx(ActionTitles, {
                children: /*#__PURE__*/ _jsx(Text, {
                    bold: true,
                    textTransform: "uppercase",
                    children: t("Enable farm")
                })
            }),
            /*#__PURE__*/ _jsx(ActionContent, {
                children: /*#__PURE__*/ _jsx(Button, {
                    width: "100%",
                    disabled: pendingTx,
                    onClick: handleApprove,
                    children: t("Enable")
                })
            })
        ]
    });
};
/* harmony default export */ var StakedAction = ((/* unused pure expression or super */ null && (Staked)));

// EXTERNAL MODULE: ./src/components/NextLink.tsx
var components_NextLink = __webpack_require__(12966);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useBoosterFarmHandlers.ts






var useBoosterFarmHandlers = function(farmPid, onDone) {
    var farmBoosterContract = (0,useContract/* useBCakeFarmBoosterContract */.gh)();
    var ref = useCatchTxError_useCatchTxError(), fetchWithCatchTxError = ref.fetchWithCatchTxError, isConfirming = ref.loading;
    var callWithGasPrice = useCallWithGasPrice().callWithGasPrice;
    var activate = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return callWithGasPrice(farmBoosterContract, "activate", [
                                farmPid
                            ]);
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if ((receipt === null || receipt === void 0 ? void 0 : receipt.status) && onDone) {
                        onDone();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        farmPid,
        farmBoosterContract,
        callWithGasPrice,
        fetchWithCatchTxError,
        onDone
    ]);
    var deactivate = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return callWithGasPrice(farmBoosterContract, "deactive", [
                                farmPid
                            ]);
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if ((receipt === null || receipt === void 0 ? void 0 : receipt.status) && onDone) {
                        onDone();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        farmPid,
        farmBoosterContract,
        callWithGasPrice,
        fetchWithCatchTxError,
        onDone
    ]);
    return {
        activate: activate,
        deactivate: deactivate,
        isConfirming: isConfirming
    };
};
/* harmony default export */ var hooks_useBoosterFarmHandlers = (useBoosterFarmHandlers);

// EXTERNAL MODULE: ./src/config/abi/farmBooster.json
var farmBooster = __webpack_require__(74551);
// EXTERNAL MODULE: ./src/config/abi/masterchef.json
var masterchef = __webpack_require__(84951);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__(20335);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useBoostMultiplier.ts













var PRECISION_FACTOR = fixednumber/* FixedNumber.from */.xs.from("1000000000000") // 1e12
;
function getPublicMultiplier(_) {
    return _getPublicMultiplier.apply(this, arguments);
}
function _getPublicMultiplier() {
    _getPublicMultiplier = (0,src_async_to_generator/* default */.Z)(function(param) {
        var farmBoosterContract, calls, data, _data, ref, cA, ref1, CA_PRECISION, ref2, BOOST_PRECISION, MAX_BOOST_PRECISION, boostPercent;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    farmBoosterContract = param.farmBoosterContract;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "cA"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "CA_PRECISION"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* multicallv2 */.v)({
                            abi: farmBooster,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) return [
                        2,
                        0
                    ];
                    _data = (0,src_sliced_to_array/* default */.Z)(data, 3), ref = (0,src_sliced_to_array/* default */.Z)(_data[0], 1), cA = ref[0], ref1 = (0,src_sliced_to_array/* default */.Z)(_data[1], 1), CA_PRECISION = ref1[0], ref2 = (0,src_sliced_to_array/* default */.Z)(_data[2], 1), BOOST_PRECISION = ref2[0];
                    MAX_BOOST_PRECISION = fixednumber/* FixedNumber.from */.xs.from(CA_PRECISION).divUnsafe(fixednumber/* FixedNumber.from */.xs.from(cA)).mulUnsafe(PRECISION_FACTOR).subUnsafe(fixednumber/* FixedNumber.from */.xs.from(BOOST_PRECISION));
                    boostPercent = PRECISION_FACTOR.addUnsafe(MAX_BOOST_PRECISION).divUnsafe(PRECISION_FACTOR);
                    return [
                        2,
                        toNumber_default()(boostPercent.round(3).toString())
                    ];
            }
        });
    });
    return _getPublicMultiplier.apply(this, arguments);
}
function getUserMultiplier(_) {
    return _getUserMultiplier.apply(this, arguments);
}
function _getUserMultiplier() {
    _getUserMultiplier = (0,src_async_to_generator/* default */.Z)(function(param) {
        var farmBoosterContract, account, pid, calls, data, _data, ref, multiplier, ref1, BOOST_PRECISION;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    farmBoosterContract = param.farmBoosterContract, account = param.account, pid = param.pid;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "getUserMultiplier",
                            params: [
                                account,
                                pid
                            ]
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* multicallv2 */.v)({
                            abi: farmBooster,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) return [
                        2,
                        0
                    ];
                    _data = (0,src_sliced_to_array/* default */.Z)(data, 2), ref = (0,src_sliced_to_array/* default */.Z)(_data[0], 1), multiplier = ref[0], ref1 = (0,src_sliced_to_array/* default */.Z)(_data[1], 1), BOOST_PRECISION = ref1[0];
                    return [
                        2,
                        toNumber_default()(PRECISION_FACTOR.addUnsafe(fixednumber/* FixedNumber.from */.xs.from(multiplier)).subUnsafe(fixednumber/* FixedNumber.from */.xs.from(BOOST_PRECISION)).divUnsafe(PRECISION_FACTOR).round(3).toString())
                    ];
            }
        });
    });
    return _getUserMultiplier.apply(this, arguments);
}
function getMultiplierFromMC(_) {
    return _getMultiplierFromMC.apply(this, arguments);
}
function _getMultiplierFromMC() {
    _getMultiplierFromMC = (0,src_async_to_generator/* default */.Z)(function(param) {
        var pid, proxyAddress, masterChefContract, calls, data, _data, ref, boostMultiplier;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pid = param.pid, proxyAddress = param.proxyAddress, masterChefContract = param.masterChefContract;
                    calls = [
                        {
                            address: masterChefContract.address,
                            name: "getBoostMultiplier",
                            params: [
                                proxyAddress,
                                pid
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* multicallv2 */.v)({
                            abi: masterchef,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!(data === null || data === void 0 ? void 0 : data.length)) return [
                        2,
                        0
                    ];
                    _data = (0,src_sliced_to_array/* default */.Z)(data, 1), ref = (0,src_sliced_to_array/* default */.Z)(_data[0], 1), boostMultiplier = ref[0];
                    return [
                        2,
                        toNumber_default()(fixednumber/* FixedNumber.from */.xs.from(boostMultiplier).divUnsafe(PRECISION_FACTOR).round(3).toString())
                    ];
            }
        });
    });
    return _getMultiplierFromMC.apply(this, arguments);
}
function useBoostMultiplier(param) {
    var pid = param.pid, boosterState = param.boosterState, proxyAddress = param.proxyAddress;
    var farmBoosterContract = (0,useContract/* useBCakeFarmBoosterContract */.gh)();
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var account = (0,hooks_useActiveWeb3React/* default */.Z)().account;
    var shouldGetFromSC = [
        useYieldBoosterState/* YieldBoosterState.DEACTIVE */.M.DEACTIVE,
        useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE,
        useYieldBoosterState/* YieldBoosterState.MAX */.M.MAX
    ].includes(boosterState);
    var should1X = [
        useYieldBoosterState/* YieldBoosterState.LOCKED_END */.M.LOCKED_END
    ].includes(boosterState);
    var getMultiplier = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (shouldGetFromSC) {
                return [
                    2,
                    getMultiplierFromMC({
                        pid: pid,
                        masterChefContract: masterChefContract,
                        proxyAddress: proxyAddress
                    })
                ];
            }
            return [
                2,
                should1X ? getUserMultiplier({
                    farmBoosterContract: farmBoosterContract,
                    pid: pid,
                    account: account
                }) : getPublicMultiplier({
                    farmBoosterContract: farmBoosterContract
                })
            ];
        });
    }), [
        farmBoosterContract,
        masterChefContract,
        should1X,
        shouldGetFromSC,
        pid,
        account,
        proxyAddress
    ]);
    var cacheName = shouldGetFromSC ? "proxy".concat(pid) : should1X ? "user".concat(pid) : "public".concat(pid);
    var data = (0,dist/* default */.ZP)([
        "boostMultiplier",
        cacheName
    ], getMultiplier).data;
    return data || 0;
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(68304);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var MatchBreakpoints_useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var Text_TooltipText = __webpack_require__(13947);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/ActionButton.tsx



function ActionButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 4px;\n"
    ]);
    ActionButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33d0425a-0"
})(ActionButton_templateObject());
var BoosterTooltip = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            t("Boost multiplier is calculated based on the staking conditions from both Farms and fixed-term CAKE syrup pool and will be automatically updated upon user actions."),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: "https://docs.pancakeswap.finance/products/yield-farming/bcake/faq#how-are-the-bcake-multipliers-calculated",
                external: true,
                children: t("Learn More")
            })
        ]
    });
};
var ActionButton = function(_param) {
    var title = _param.title, description = _param.description, button = _param.button, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "button"
    ]);
    var isMobile = (0,MatchBreakpoints_useMatchBreakpoints/* default */.Z)().isMobile;
    var btn = null;
    var ref = (0,useTooltip_useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BoosterTooltip, {}), (0,src_object_spread/* default */.Z)({
        placement: "top"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    if (button) {
        btn = button;
    } else if (!isEmpty_default()(props)) {
        btn = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, (0,src_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                                mr: "4px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_TooltipText/* default */.Z, {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    width: "20px",
                                    height: "20px"
                                })
                            }),
                            tooltipVisible && tooltip
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        color: "textSubtle",
                        fontSize: "12px",
                        children: description
                    })
                ]
            }),
            btn
        ]
    });
};
/* harmony default export */ var components_ActionButton = (ActionButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Logo.tsx
var Logo = __webpack_require__(92505);
;// CONCATENATED MODULE: ./src/views/Farms/components/BCakeMigrateModal.tsx




function BCakeMigrateModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  color: white;\n  text-align: center;\n  line-height: 20px;\n  padding: 2px;\n  box-sizing: border-box;\n  font-size: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n"
    ]);
    BCakeMigrateModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  transition: 0.3s color ease-in-out;\n  will-change: color;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n"
    ]);
    BCakeMigrateModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: top;\n  &:not(:last-child) {\n    margin-right: calc((100% - 60px) / 2);\n    &::before {\n      position: absolute;\n      content: '';\n      width: calc(((100vw / 2) - 108px));\n      height: 2px;\n      top: 9px;\n      left: 30px;\n      transition: 0.3s background-color ease-in-out;\n      will-change: background-color;\n      background-color: ",
        ";\n    }\n    ",
        " {\n      &::before {\n        width: 104px;\n      }\n    }\n  }\n  ",
        " {\n    background: ",
        ";\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    BCakeMigrateModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding-top: 24px;\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    background-color: ",
        ";\n  }\n"
    ]);
    BCakeMigrateModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  font-size: 12px;\n  color: ",
        ";\n  line-height: 120%;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        " {\n    width: 372px;\n  }\n"
    ]);
    BCakeMigrateModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BCakeMigrateModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BCakeMigrateModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    BCakeMigrateModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}












var StepperCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-0"
})(BCakeMigrateModal_templateObject());
var StepperText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-1"
})(BCakeMigrateModal_templateObject1());
var StepperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-2"
})(BCakeMigrateModal_templateObject2(), function(param) {
    var theme = param.theme, finished = param.finished;
    return finished ? theme.colors.textSubtle : theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, StepperCircle, function(param) {
    var theme = param.theme, finished = param.finished;
    return finished ? theme.colors.textSubtle : theme.colors.disabled;
}, StepperText, function(param) {
    var theme = param.theme, active = param.active, finished = param.finished;
    return active ? theme.colors.primary : finished ? theme.colors.textSubtle : theme.colors.disabled;
});
var FooterBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-3"
})(BCakeMigrateModal_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var InfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-4"
})(BCakeMigrateModal_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var InfoText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-5"
})(BCakeMigrateModal_templateObject5());
var InfoIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df0fb999-6"
})(BCakeMigrateModal_templateObject6());
var Steps;
(function(Steps) {
    Steps[Steps["UnStake"] = 0] = "UnStake";
    Steps[Steps["Enable"] = 1] = "Enable";
    Steps[Steps["Stake"] = 2] = "Stake";
})(Steps || (Steps = {}));
var _obj;
var migrationSteps = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Steps.UnStake, "Unstake LP tokens from the farm"), (0,_define_property/* default */.Z)(_obj, Steps.Enable, "Enable staking with yield booster"), (0,_define_property/* default */.Z)(_obj, Steps.Stake, "Stake LP tokens back to the farm"), _obj);
var migrationStepsKeys = Object.keys(migrationSteps);
var BCakeMigrateModal = function(param) {
    var lpContract = param.lpContract, stakedBalance = param.stakedBalance, onDismiss = param.onDismiss, onUnStack = param.onUnStack, pid = param.pid;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,react.useState)(Steps.UnStake), activatedState = ref1[0], setActivatedState = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isApproved = ref3[0], setIsApproved = ref3[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var fullBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getFullDisplayBalance */.NJ)(stakedBalance);
    }, [
        stakedBalance
    ]);
    var proxyAddress = (0,hooks_useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId).proxyAddress;
    var ref4 = useProxyStakedActions(pid, lpContract), onApprove = ref4.onApprove, onDone = ref4.onDone, onStake = ref4.onStake;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var ref5 = useCatchTxError_useCatchTxError(), fetchWithCatchTxError = ref5.fetchWithCatchTxError, loading = ref5.loading;
    var toastSuccess = (0,ToastsContext_useToast/* useToast */.p)().toastSuccess;
    var ref6 = (0,useTooltip_useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        children: t("To enable farm yield boosters, you must follow the guide and migrate your current farming positions. However, for each farm, you will only need to migrate once.")
    }), {
        placement: "right"
    }), targetRef = ref6.targetRef, tooltip = ref6.tooltip, tooltipVisible = ref6.tooltipVisible;
    (0,react.useEffect)(function() {
        if (!bCakeProxy) return;
        bCakeProxy.lpApproved(lpContract.address).then(function(enabled) {
            setIsApproved(enabled);
        });
    }, [
        lpContract,
        bCakeProxy
    ]);
    var onStepChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var receipt, receipt1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(activatedState === Steps.UnStake)) return [
                            3,
                            1
                        ];
                        setIsLoading(true);
                        onUnStack(fullBalance, function() {
                            if (isApproved) setActivatedState(Steps.Stake);
                            else setActivatedState(Steps.Enable);
                            setIsLoading(false);
                        });
                        return [
                            3,
                            8
                        ];
                    case 1:
                        if (!(activatedState === Steps.Enable)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            fetchWithCatchTxError(onApprove)
                        ];
                    case 2:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                            setActivatedState(Steps.Stake);
                            onDone();
                        }
                        return [
                            3,
                            8
                        ];
                    case 3:
                        setIsLoading(true);
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onStake(fullBalance);
                            })
                        ];
                    case 5:
                        receipt1 = _state.sent();
                        if (receipt1 === null || receipt1 === void 0 ? void 0 : receipt1.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt1.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            onDone();
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        return [
                            3,
                            8
                        ];
                    case 6:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function onStepChange() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.ZP, {
        title: t("Migrate your stakings"),
        width: "420px",
        onDismiss: onDismiss,
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                ref: targetRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                        children: t("You will need to migrate your stakings before activating yield booster for a farm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                pb: 20,
                pl: 38,
                pr: 30,
                children: migrationStepsKeys.map(function(step, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperWrapper, {
                        active: step === activatedState.toString(),
                        finished: parseInt(step) < parseInt(activatedState.toString()),
                        children: [
                            step === activatedState.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                width: 22
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperCircle, {
                                children: parseInt(step) < parseInt(activatedState.toString()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                    color: "white",
                                    width: 16
                                }) : index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperText, {
                                children: Steps[step]
                            })
                        ]
                    }, step);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        mb: "16px",
                        textAlign: "center",
                        children: [
                            activatedState + 1,
                            ". ",
                            t(migrationSteps[activatedState])
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: onStepChange,
                        isLoading: isLoading || loading,
                        width: "100%",
                        endIcon: isLoading || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : undefined,
                        children: isLoading || loading ? t("Confirming...") : t(Steps[activatedState])
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/MigrateActionButton.tsx















var MigrateActionButton = function(param) {
    var pid = param.pid;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,ToastsContext_useToast/* useToast */.p)().toastSuccess;
    var fetchWithCatchTxError = useCatchTxError_useCatchTxError().fetchWithCatchTxError;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var onUnstake = hooks_useUnstakeFarms(pid).onUnstake;
    var stakedBalance = (0,hooks/* useFarmUser */.Dx)(pid).stakedBalance;
    var lpAddress = (0,hooks/* useFarmFromPid */.f6)(pid).lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var handleUnstakeWithCallback = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount, callback) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onUnstake(amount);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            callback();
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ],
                                chainId: chainId
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUnstakeWithCallback(amount, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BCakeMigrateModal, {
        pid: pid,
        stakedBalance: stakedBalance,
        lpContract: lpContract,
        onUnStack: handleUnstakeWithCallback
    })), 1), onPresentMigrate = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        onClick: onPresentMigrate,
        children: t("Migrate")
    });
};
/* harmony default export */ var components_MigrateActionButton = (MigrateActionButton);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedAction.tsx














var BoostedAction = function(param) {
    var farmPid = param.farmPid, title = param.title, desc = param.desc, userBalanceInFarm = param.userBalanceInFarm, lpTotalSupply = param.lpTotalSupply;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._), boosterState = ref.boosterState, refreshActivePool = ref.refreshActivePool, refreshProxyAddress = ref.refreshProxyAddress, proxyAddress = ref.proxyAddress;
    var _ref = hooks_useBoosterFarmHandlers(farmPid, refreshActivePool), isConfirming = _ref.isConfirming, handlers = (0,src_object_without_properties/* default */.Z)(_ref, [
        "isConfirming"
    ]);
    var boostMultiplierFromSC = useBoostMultiplier({
        pid: farmPid,
        boosterState: boosterState,
        proxyAddress: proxyAddress
    });
    var boostedMultiplierFromFE = useGetBoostedMultiplier(userBalanceInFarm, lpTotalSupply);
    var boostMultiplier = userBalanceInFarm.eq(0) ? boostMultiplierFromSC : boostedMultiplierFromFE;
    var boostMultiplierDisplay = boostMultiplier.toLocaleString(undefined, {
        maximumFractionDigits: 3
    });
    var renderBtn = (0,react.useCallback)(function() {
        switch(boosterState){
            case useYieldBoosterState/* YieldBoosterState.UNCONNECTED */.M.UNCONNECTED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Connect wallet to activate yield booster")
                });
            case useYieldBoosterState/* YieldBoosterState.NO_LOCKED */.M.NO_LOCKED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Lock CAKE to activate yield booster"),
                    style: {
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NextLink/* NextLinkFromReactRouter */.a, {
                        to: "/pools",
                        children: t("Go to Pool")
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.LOCKED_END */.M.LOCKED_END:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Lock CAKE is ended. Re-lock CAKE to activate yield booster"),
                    style: {
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NextLink/* NextLinkFromReactRouter */.a, {
                        to: "/pools",
                        children: t("Go to Pool")
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_PROXY_CREATED */.M.NO_PROXY_CREATED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("One-time setup is required for activating farm yield boosters"),
                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateProxyButton, {
                        onDone: refreshProxyAddress,
                        width: "auto"
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_MIGRATE */.M.NO_MIGRATE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Migration required to activate boost"),
                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MigrateActionButton, {
                        pid: farmPid
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_LP */.M.NO_LP:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Stake LP tokens to start boosting"),
                    disabled: true,
                    children: t("Boost")
                });
            case useYieldBoosterState/* YieldBoosterState.DEACTIVE */.M.DEACTIVE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    disabled: isConfirming,
                    onClick: handlers.activate,
                    title: "".concat(boostMultiplierDisplay, "x"),
                    isLoading: isConfirming,
                    description: t("Yield booster available"),
                    endIcon: isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }),
                    children: t("Boost")
                });
            case useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    disabled: isConfirming,
                    onClick: handlers.deactivate,
                    title: "".concat(boostMultiplierDisplay, "x"),
                    isLoading: isConfirming,
                    description: t("Active"),
                    endIcon: isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }),
                    children: t("Unset")
                });
            case useYieldBoosterState/* YieldBoosterState.MAX */.M.MAX:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Unset other boosters to activate"),
                    disabled: true,
                    children: t("Boost")
                });
            default:
                return null;
        }
    }, [
        boosterState,
        t,
        handlers.activate,
        handlers.deactivate,
        isConfirming,
        farmPid,
        refreshProxyAddress,
        boostMultiplierDisplay, 
    ]);
    var status = null;
    if ([
        useYieldBoosterState/* YieldBoosterState.NO_MIGRATE */.M.NO_MIGRATE,
        useYieldBoosterState/* YieldBoosterState.DEACTIVE */.M.DEACTIVE
    ].includes(boosterState)) {
        status = t("Ready");
    } else if (boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE) {
        status = t("Active");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title && title(status),
            desc && desc(renderBtn())
        ]
    });
};
/* harmony default export */ var components_BoostedAction = (BoostedAction);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/HarvestAction.tsx















var HarvestAction_HarvestAction = function(param) {
    var earnings = param.earnings, onReward = param.onReward, proxyCakeBalance = param.proxyCakeBalance, onDone = param.onDone;
    var renderCurenccySymbol = function renderCurenccySymbol() {
        if (chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS) {
            return " VNDC";
        }
        return " USD";
    };
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var toastSuccess = (0,ToastsContext_useToast/* useToast */.p)().toastSuccess;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var ref = useCatchTxError_useCatchTxError(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var t = (0,src/* useTranslation */.$G)().t;
    // const cakePrice = usePriceRunBusd()
    var cakePrice = (0,hooks/* useTokenPriceWPi */.mf)();
    var rawEarningsBalance = account ? (0,formatBalance/* getBalanceAmount */.U4)(earnings) : bigNumber/* BIG_ZERO */.HW;
    var displayBalance = rawEarningsBalance.toFixed(5, bignumber/* default.ROUND_DOWN */.Z.ROUND_DOWN);
    var earningsBusd = rawEarningsBalance ? rawEarningsBalance.multipliedBy(cakePrice).toNumber() : 0;
    var tooltipBalance = rawEarningsBalance.isGreaterThan(new bignumber/* default */.Z(0.00001)) ? displayBalance : "< 0.00001";
    var ref1 = (0,useTooltip_useTooltip/* default */.Z)("".concat(tooltipBalance, " ").concat(t("CAKE has been harvested to the farm booster contract and will be automatically sent to your wallet upon the next harvest.")), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        mb: "8px",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-start",
                children: [
                    proxyCakeBalance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_TooltipText/* default */.Z, {
                                ref: targetRef,
                                decorationColor: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                                    color: rawEarningsBalance.eq(0) ? "text" : "text",
                                    children: displayBalance
                                })
                            }),
                            tooltipVisible && tooltip
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        bold: true,
                        color: rawEarningsBalance.eq(0) ? "text" : "text",
                        children: displayBalance
                    }),
                    earningsBusd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Balance, {
                        fontSize: "12px",
                        color: "text",
                        decimals: 2,
                        value: earningsBusd,
                        unit: renderCurenccySymbol(),
                        prefix: "~"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                minWidth: "115px",
                disabled: rawEarningsBalance.eq(0) || pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "textDisabled",
                    opacity: "0.5"
                }) : null,
                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    var receipt;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchWithCatchTxError(function() {
                                        return onReward();
                                    })
                                ];
                            case 1:
                                receipt = _state.sent();
                                if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                    toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                        txHash: receipt.transactionHash,
                                        children: t("Harvested successfully")
                                    }));
                                    onDone === null || onDone === void 0 ? void 0 : onDone();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }),
                children: pendingTx ? t("Harvesting") : t("Harvest")
            })
        ]
    });
};
/* harmony default export */ var FarmCard_HarvestAction = (HarvestAction_HarvestAction);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButtonV2.tsx
var Button_IconButtonV2 = __webpack_require__(82274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(91375);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(85448);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/StakeAction.tsx




function StakeAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  svg {\n    width: 20px;\n  }\n"
    ]);
    StakeAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var StakeAction_IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cfe224a-0"
})(StakeAction_templateObject());
var StakeAction = function(param) {
    var pid = param.pid, quoteToken = param.quoteToken, token = param.token, lpSymbol = param.lpSymbol, multiplier = param.multiplier, apr = param.apr, displayApr = param.displayApr, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal, userData = param.userData, onStake = param.onStake, onUnstake = param.onUnstake, onDone = param.onDone, onApprove = param.onApprove, isApproved = param.isApproved, percentUserStaked = param.percentUserStaked;
    var t = (0,src/* useTranslation */.$G)().t;
    var tokenBalance = userData.tokenBalance, stakedBalance = userData.stakedBalance;
    // const cakePrice = usePriceRunBusd()
    var cakePrice = (0,hooks/* useTokenPriceWPi */.mf)();
    var pibPrice = (0,hooks/* useTokenPrice */.pQ)(tokens_src/* bscTokens.pib.address */.ds.pib.address);
    var router = (0,next_router.useRouter)();
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var toastSuccess = (0,ToastsContext_useToast/* useToast */.p)().toastSuccess;
    var ref = useCatchTxError_useCatchTxError(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var boosterState = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._).boosterState;
    var handleStake = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onStake(amount);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            onDone();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return onUnstake(amount);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            onDone();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return onApprove();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        onDone();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        onApprove,
        t,
        toastSuccess,
        fetchWithCatchTxError,
        onDone
    ]);
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_DepositModal, {
        pid: pid,
        lpTotalSupply: lpTotalSupply,
        max: tokenBalance,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        addLiquidityUrl: addLiquidityUrl,
        cakePrice: cakePrice,
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE,
        pibTokenPrice: pibPrice
    })), 1), onPresentDeposit = ref1[0];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_WithdrawModal, {
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE,
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref2[0];
    var renderStakingButtons = function() {
        return stakedBalance.eq(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            minWidth: "115px",
            onClick: onPresentDeposit,
            disabled: [
                "history",
                "archived"
            ].some(function(item) {
                return router.pathname.includes(item);
            }),
            children: pid === 0 ? t("Stake") : t("Stake LP")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StakeAction_IconButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_IconButtonV2/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentWithdraw,
                    mr: "6px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                        color: "black",
                        width: "14px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_IconButtonV2/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentDeposit,
                    disabled: [
                        "history",
                        "archived"
                    ].some(function(item) {
                        return router.pathname.includes(item);
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                        color: "black",
                        width: "14px"
                    })
                })
            ]
        });
    };
    // TODO: Move this out to prevent unnecessary re-rendered
    if (!isApproved) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            mt: "8px",
            width: "100%",
            disabled: pendingTx,
            onClick: handleApprove,
            children: t("Enable Contract")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StakedLP, {
                stakedBalance: stakedBalance,
                lpSymbol: lpSymbol,
                quoteTokenSymbol: quoteToken.symbol,
                tokenSymbol: token.symbol,
                lpTotalSupply: lpTotalSupply,
                tokenAmountTotal: tokenAmountTotal,
                quoteTokenAmountTotal: quoteTokenAmountTotal,
                percentUserStaked: percentUserStaked
            }),
            renderStakingButtons()
        ]
    });
};
/* harmony default export */ var FarmCard_StakeAction = (StakeAction);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardActionsContainer.tsx



function CardActionsContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n"
    ]);
    CardActionsContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardActionsContainer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    CardActionsContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var Action = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82f7847f-0"
})(CardActionsContainer_templateObject());
var CardActionsContainer_ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82f7847f-1"
})(CardActionsContainer_templateObject1());
var CardActions = function(param) {
    var farm = param.farm, account = param.account, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, displayApr = param.displayApr, percentUserStaked = param.percentUserStaked;
    var t = (0,src/* useTranslation */.$G)().t;
    var pid = farm.pid, lpAddress = farm.lpAddress;
    var earnings = (farm.userData || {}).earnings;
    var shouldUseProxyFarm = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._).shouldUseProxyFarm;
    var isReady = farm.multiplier !== undefined;
    var _userData = farm.userData, stakedBalance = _userData.stakedBalance, tokenBalance = _userData.tokenBalance, proxy = _userData.proxy;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Action, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        bold: true,
                        fontSize: "12px",
                        pr: "4px",
                        children: "Pi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        fontSize: "12px",
                        children: t("Earned")
                    })
                ]
            }),
            shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProxyHarvestActionContainer, {
                earnings: earnings,
                pid: pid,
                lpAddress: lpAddress,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_HarvestAction, (0,src_object_spread/* default */.Z)({}, props));
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestActionContainer, {
                earnings: earnings,
                pid: pid,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_HarvestAction, (0,src_object_spread/* default */.Z)({}, props));
                }
            }),
            farm.boosted && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoostedAction, {
                title: function(status) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "textSubtle",
                                fontSize: "12px",
                                pr: "4px",
                                children: t("Yield Booster")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "secondary",
                                fontSize: "12px",
                                children: status
                            })
                        ]
                    });
                },
                desc: function(actionBtn) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionsContainer_ActionContainer, {
                        children: actionBtn
                    });
                },
                farmPid: farm.pid,
                lpTotalSupply: farm.lpTotalSupply,
                userBalanceInFarm: (ref = stakedBalance.plus(tokenBalance).gt(0) ? stakedBalance.plus(tokenBalance) : proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.plus(proxy === null || proxy === void 0 ? void 0 : proxy.tokenBalance)) !== null && ref !== void 0 ? ref : new bignumber/* default */.Z(0)
            }),
            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        fontSize: "14px",
                        pr: "4px",
                        children: farm.lpSymbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        textTransform: "uppercase",
                        fontSize: "14px",
                        children: t("Staked")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: 80,
                height: 18,
                mb: "4px"
            }),
            !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConnectWalletButton/* default */.Z, {
                mt: "8px",
                width: "100%"
            }) : shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProxyStakedContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                lpLabel: lpLabel,
                addLiquidityUrl: addLiquidityUrl,
                displayApr: displayApr,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StakeAction, (0,src_object_spread/* default */.Z)({
                        percentUserStaked: percentUserStaked
                    }, props));
                }
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                lpLabel: lpLabel,
                addLiquidityUrl: addLiquidityUrl,
                displayApr: displayApr,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StakeAction, (0,src_object_spread/* default */.Z)({
                        percentUserStaked: percentUserStaked
                    }, props));
                }
            }))
        ]
    });
};
/* harmony default export */ var CardActionsContainer = (CardActions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenPairV2.tsx
var TokenPairV2 = __webpack_require__(95042);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenPairImage.tsx + 1 modules
var TokenPairImage = __webpack_require__(59011);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CoreTagIcon.tsx
var CoreTagIcon = __webpack_require__(95541);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag_Tag = __webpack_require__(25945);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Community.tsx
var Community = __webpack_require__(25715);
;// CONCATENATED MODULE: ./src/components/Tags.tsx






var CoreTag = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreTagIcon/* default */.Z, {});
};
var FarmAuctionTagToolTipContent = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Text, {
        color: "text",
        children: t("Farm Auction Winner, add liquidity at your own risk.")
    });
})));
var FarmAuctionTag = function(props) {
    var t = useTranslation().t;
    var ref = useTooltip(/*#__PURE__*/ _jsx(FarmAuctionTagToolTipContent, {}), {
        placement: "right"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ _jsx(TooltipText, {
                ref: targetRef,
                style: {
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
                    variant: "failure",
                    outline: true,
                    startIcon: /*#__PURE__*/ _jsx(CommunityIcon, {
                        width: "18px",
                        color: "failure",
                        mr: "4px"
                    })
                }, props), {
                    children: t("Farm Auction")
                }))
            })
        ]
    });
};
var StableFarmTag = function(props) {
    var t = useTranslation().t;
    var ref = useTooltip("Fees are lower for stable LP", {
        placement: "right"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ _jsx(TooltipText, {
                ref: targetRef,
                style: {
                    textDecoration: "none",
                    alignSelf: "center"
                },
                children: /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
                    variant: "failure",
                    outline: true
                }, props), {
                    children: t("Stable LP")
                }))
            })
        ]
    });
};
var CommunityTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        variant: "failure",
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
            width: "18px",
            color: "failure",
            mr: "4px"
        })
    }, props), {
        children: t("Community")
    }));
};
var DualTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "textSubtle",
        outline: true
    }, props), {
        children: t("Dual")
    }));
};
var ManualPoolTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "secondary",
        outline: true,
        startIcon: /*#__PURE__*/ _jsx(RefreshIcon, {
            width: "18px",
            color: "secondary",
            mr: "4px"
        })
    }, props), {
        children: t("Manual")
    }));
};
var CompoundingPoolTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "success",
        outline: true,
        startIcon: /*#__PURE__*/ _jsx(AutoRenewIcon, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Auto")
    }));
};
var VoteNowTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "success",
        startIcon: /*#__PURE__*/ _jsx(VoteIcon, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Vote Now")
    }));
};
var SoonTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "binance",
        startIcon: /*#__PURE__*/ _jsx(TimerIcon, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Soon")
    }));
};
var ClosedTag = function(props) {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({
        variant: "textDisabled",
        startIcon: /*#__PURE__*/ _jsx(BlockIcon, {
            width: "18px",
            color: "textDisabled",
            mr: "4px"
        })
    }, props), {
        children: t("Closed")
    }));
};


;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardHeading.tsx

function CardHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 80px;\n  background-size: 100% 100%;\n    svg {\n    margin-right: 4px;\n  }\n"
    ]);
    CardHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardHeading_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size:14px;\n  font-weight: bold;\n"
    ]);
    CardHeading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var CardHeading_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-9e809eb4-0"
})(CardHeading_templateObject());
var CustomHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading_Heading/* default */.Z).withConfig({
    componentId: "sc-9e809eb4-1"
})(CardHeading_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var getImageUrlFromToken = function(token) {
    return "/images/coins/".concat(token.toLowerCase(), ".png");
};
var CardHeading = function(param) {
    var lpLabel = param.lpLabel, multiplier = param.multiplier, isCommunityFarm = param.isCommunityFarm, token = param.token, quoteToken = param.quoteToken, tokenSymbol = param.tokenSymbol, quoteTokenSymbol = param.quoteTokenSymbol, poolId = param.poolId;
    var isXl = (0,MatchBreakpoints_useMatchBreakpoints/* default */.Z)().isXl;
    var isMobile = isXl === false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeading_Wrapper, {
        justifyContent: "space-between",
        alignItems: "start",
        children: [
            poolId === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairV2/* default */.Z, {
                variant: "default",
                secondarySrc: getImageUrlFromToken(quoteTokenSymbol),
                thirdSrc: "https://s2.coinmarketcap.com/static/img/coins/64x64/16193.png",
                width: 100,
                height: 100
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairImage/* default */.Z, {
                variant: "default",
                primarySrc: getImageUrlFromToken(tokenSymbol),
                secondarySrc: getImageUrlFromToken(quoteTokenSymbol),
                thirdSrc: "https://s2.coinmarketcap.com/static/img/coins/64x64/16193.png",
                width: 100,
                height: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                ml: "20px",
                width: "60%",
                flexDirection: "column",
                alignItems: "start",
                style: {
                    marginTop: isMobile ? "5px" : "0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "flex-start",
                        children: isCommunityFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityTag, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreTag, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                        mt: "4px",
                        color: "text",
                        children: lpLabel.split(" ")[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeading, {
                        mt: "5px",
                        children: "Earn Pi"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmCard_CardHeading = (CardHeading);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/DetailsSection.tsx

function DetailsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n"
    ]);
    DetailsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    DetailsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DetailsSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76582c9b-0"
})(DetailsSection_templateObject());
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-76582c9b-1"
})(DetailsSection_templateObject1());
var DetailsSection = function(param) {
    var bscScanAddress = param.bscScanAddress, infoAddress = param.infoAddress, removed = param.removed, totalValueFormatted = param.totalValueFormatted, lpLabel = param.lpLabel, addLiquidityUrl = param.addLiquidityUrl, isCommunity = param.isCommunity, auctionHostingEndDate = param.auctionHostingEndDate;
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsSection_Wrapper, {
        children: [
            isCommunity && auctionHostingEndDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        children: [
                            t("Auction Hosting Ends"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        children: new Date(auctionHostingEndDate).toLocaleString(locale, {
                            month: "short",
                            day: "numeric",
                            year: "numeric"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                    href: bscScanAddress,
                    children: t("View contract")
                })
            })
        ]
    });
};
/* harmony default export */ var FarmCard_DetailsSection = (DetailsSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/RocketIcon.tsx
var Icons_RocketIcon = __webpack_require__(57655);
// EXTERNAL MODULE: ./packages/utils/isUndefinedOrNull.ts
var utils_isUndefinedOrNull = __webpack_require__(95923);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedApr.tsx














function BoostedApr(props) {
    var lpRewardsApr = props.lpRewardsApr, apr = props.apr, pid = props.pid, userBalanceInFarm = props.userBalanceInFarm, lpTotalSupply = props.lpTotalSupply, rest = (0,src_object_without_properties/* default */.Z)(props, [
        "lpRewardsApr",
        "apr",
        "pid",
        "userBalanceInFarm",
        "lpTotalSupply"
    ]);
    var ref = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._), boosterState = ref.boosterState, proxyAddress = ref.proxyAddress;
    var t = (0,src/* useTranslation */.$G)().t;
    var boostedAprFromFE = hooks_useGetBoostedAPR(userBalanceInFarm, lpTotalSupply, apr, lpRewardsApr);
    var multiplier = useBoostMultiplier({
        pid: pid,
        boosterState: boosterState,
        proxyAddress: proxyAddress
    });
    var boostedAprFromSC = !(0,utils_isUndefinedOrNull/* default */.Z)(multiplier) && !(0,utils_isUndefinedOrNull/* default */.Z)(apr) && (0,formatBalance/* formatNumber */.uf)(toNumber_default()(apr) * Number(multiplier) + (!(0,utils_isUndefinedOrNull/* default */.Z)(lpRewardsApr) ? toNumber_default()(lpRewardsApr) : 0)) || "0";
    var msg = boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE ? "".concat(boostedAprFromSC, "%") : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                bold: true,
                color: "success"
            }, rest), {
                fontSize: 14,
                display: "inline-block",
                mr: "3px",
                children: t("Up to")
            })),
            "".concat(userBalanceInFarm.eq(0) ? boostedAprFromSC : boostedAprFromFE, "%")
        ]
    });
    // if (boostedAPR === '0') {
    //   return null
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RocketIcon/* default */.Z, {
                m: "4px",
                color: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                bold: true,
                color: "success"
            }, rest), {
                fontSize: 16,
                children: msg
            }))
        ]
    });
}
/* harmony default export */ var components_BoostedApr = (/*#__PURE__*/(0,react.memo)(BoostedApr));

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/FarmCard.tsx

function FarmCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: baseline;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  position: relative;\n  text-align: center;\n  max-width: 400px;\n  width: 100%;\n  min-width: 300px;\n  overflow: hidden;\n"
    ]);
    FarmCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 10px;\n  border-radius: 20px;\n  background:url('/images/pibridge/bg-card.png') 100% 100%;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center top;\n  @media screen and (max-width: 600px) {\n    padding: 10px 25px;\n  }\n"
    ]);
    FarmCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FarmCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 24px;\n  @media screen and (max-width: 600px) {\n    padding: 24px 0px 0px 0px;\n  }\n"
    ]);
    FarmCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FarmCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 261px;\n    display: flex;\n    margin: 0 auto;\n    justify-content: center;\n"
    ]);
    FarmCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FarmCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  overflow: hidden;\n"
    ]);
    FarmCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FarmCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    FarmCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





















var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ca72e5e-0"
})(FarmCard_templateObject());
var FarmCard_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ca72e5e-1"
})(FarmCard_templateObject1());
var FarmCardInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-1ca72e5e-2"
})(FarmCard_templateObject2());
var CsImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1ca72e5e-3"
})(FarmCard_templateObject3());
var ExpandingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ca72e5e-4"
})(FarmCard_templateObject4());
var FarmCard_StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-1ca72e5e-5"
})(FarmCard_templateObject5());
var FarmCard = function(param) {
    var farm = param.farm, displayApr = param.displayApr, removed = param.removed, cakePrice = param.cakePrice, account = param.account, originalLiquidity = param.originalLiquidity, pibPrice = param.pibPrice;
    var convertTvn = function convertTvn(liquidityData) {
        if (chainId === swap_sdk_src/* ChainId.ONUS */.a_.ONUS) {
            return "".concat(liquidityData.toLocaleString("en", {
                maximumFractionDigits: 0
            }), " VNDC");
        }
        return "$".concat(liquidity.toNumber().toLocaleString("en", {
            maximumFractionDigits: 0
        }));
    };
    var converTvl = function converTvl() {
        if (farm.pid === 0) {
            return "$".concat(Number(new bignumber/* default */.Z(balance).multipliedBy(pibPrice).toString()).toLocaleString("en", {
                maximumFractionDigits: 0
            }));
        }
        return "$".concat(liquidity.toNumber().toLocaleString("en", {
            maximumFractionDigits: 0
        }));
    };
    var t = (0,src/* useTranslation */.$G)().t;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,react.useState)(false), showExpandableSection = ref[0], setShowExpandableSection = ref[1];
    var address = (0,addressHelpers/* getAddress */.Kn)(contracts/* default.masterChef */.Z.masterChef, chainId);
    var balance = (0,getTokenBalance/* GetTokenBalance */.f)(farm === null || farm === void 0 ? void 0 : farm.lpAddress, address, chainId).balance;
    var liquidity = (farm === null || farm === void 0 ? void 0 : farm.liquidity) && (originalLiquidity === null || originalLiquidity === void 0 ? void 0 : originalLiquidity.gt(0)) ? farm.liquidity.plus(originalLiquidity) : farm.liquidity;
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(farm === null || farm === void 0 ? void 0 : farm.lpSymbol);
    var totalValueFormatted = liquidity && liquidity.gt(0) ? convertTvn(liquidity.toNumber()) : "";
    var lpLabel = farm.lpSymbol && farm.lpSymbol.replace("PANCAKE", "");
    var earnLabel = farm.dual ? farm.dual.earnLabel : t("Pi + Fee");
    var liquidityUrlPathParts = utils_getLiquidityUrlPathParts({
        quoteTokenAddress: farm.quoteToken.address,
        tokenAddress: farm.token.address
    });
    var addLiquidityUrl = "/add/".concat(liquidityUrlPathParts);
    var lpAddress = farm.lpAddress;
    var _userData = farm.userData, stakedBalance = _userData.stakedBalance, proxy = _userData.proxy, tokenBalance = _userData.tokenBalance;
    var convertStakedBalance = Number(stakedBalance.dividedBy(1E18).toString()) * Number(lpPrice.toString());
    var percentUserStaked = liquidity && liquidity.gt(0) ? "".concat((convertStakedBalance / Number(liquidity.toString()) * 100).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }), "%") : "0.00%";
    var toggleExpandableSection = (0,react.useCallback)(function() {
        setShowExpandableSection(function(prev) {
            return !prev;
        });
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmCard_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmCardInnerContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_CardHeading, {
                            lpLabel: lpLabel,
                            multiplier: farm.multiplier,
                            isCommunityFarm: farm.isCommunity,
                            token: farm.token.address,
                            quoteToken: farm.quoteToken.address,
                            tokenSymbol: farm.token.symbol,
                            quoteTokenSymbol: farm.quoteToken.symbol,
                            poolId: farm === null || farm === void 0 ? void 0 : farm.pid
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImg, {
                            src: "/images/pibridge/fringe.png",
                            alt: ""
                        }),
                        !removed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    children: [
                                        t("APR"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    bold: true,
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: farm.apr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            farm.boosted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoostedApr, {
                                                mr: "4px",
                                                lpRewardsApr: farm.lpRewardsApr,
                                                apr: farm.apr,
                                                pid: farm === null || farm === void 0 ? void 0 : farm.pid,
                                                lpTotalSupply: farm.lpTotalSupply,
                                                userBalanceInFarm: (ref1 = stakedBalance.plus(tokenBalance).gt(0) ? stakedBalance === null || stakedBalance === void 0 ? void 0 : stakedBalance.plus(tokenBalance) : proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.plus(proxy === null || proxy === void 0 ? void 0 : proxy.tokenBalance)) !== null && ref1 !== void 0 ? ref1 : new bignumber/* default */.Z(0)
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_ApyButton, {
                                                variant: "text-and-button",
                                                pid: farm.pid,
                                                lpSymbol: farm.lpSymbol,
                                                multiplier: farm.multiplier,
                                                lpLabel: lpLabel,
                                                addLiquidityUrl: addLiquidityUrl,
                                                cakePrice: cakePrice,
                                                apr: farm.apr,
                                                displayApr: displayApr,
                                                pibTokenPrice: pibPrice
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        height: 24,
                                        width: 80
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    color: "text",
                                    children: [
                                        t("TVL"),
                                        ":"
                                    ]
                                }),
                                totalValueFormatted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    children: converTvl()
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    width: 75,
                                    height: 25
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    children: [
                                        t("Earn"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    children: earnLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionsContainer, {
                            farm: farm,
                            lpLabel: lpLabel,
                            account: account,
                            addLiquidityUrl: addLiquidityUrl,
                            displayApr: displayApr,
                            percentUserStaked: percentUserStaked
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandingWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StyledLinkExternal, {
                            external: true,
                            href: "https://coinmarketcap.com/currencies/pinetwork",
                            children: t("* Pi price reference at CoinMarketCap")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StyledLinkExternal, {
                            external: true,
                            href: "https://pibridge.org/apps",
                            children: t("** You will get wrapped Pi (BEP-20) and convert to Pi Network via PiBridge App")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableSectionButton_ExpandableSectionButton, {
                            onClick: toggleExpandableSection,
                            expanded: showExpandableSection
                        }),
                        showExpandableSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_DetailsSection, {
                            removed: removed,
                            bscScanAddress: (0,utils/* getBlockExploreLink */.C)(lpAddress, "address", chainId),
                            infoAddress: "/info".concat(constant/* multiChainPaths */.Dw[chainId], "/pools/").concat(lpAddress),
                            totalValueFormatted: totalValueFormatted,
                            lpLabel: lpLabel,
                            addLiquidityUrl: addLiquidityUrl,
                            isCommunity: farm.isCommunity,
                            auctionHostingEndDate: farm.auctionHostingEndDate
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FarmCard_FarmCard = (FarmCard);


/***/ }),

/***/ 28696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ YieldBoosterStateContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90872);






var YieldBoosterStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    boosterState: _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* .YieldBoosterState.UNCONNECTED */ .M.UNCONNECTED,
    refreshActivePool: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyFarm: {},
    shouldUseProxyFarm: false,
    refreshProxyAddress: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyAddress: ""
});
var ProxyFarmContainer = function(param) {
    var children = param.children, farm = param.farm;
    var ref = (0,_hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        farmPid: farm.pid
    }), boosterState = ref.state, refreshActivePool = ref.refreshActivePool, shouldUseProxyFarm = ref.shouldUseProxyFarm, refreshProxyAddress = ref.refreshProxyAddress, proxyAddress = ref.proxyAddress;
    var proxyFarm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, farm), {
            userData: farm.userData.proxy
        });
    }, [
        farm
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YieldBoosterStateContext.Provider, {
        value: {
            proxyAddress: proxyAddress,
            boosterState: boosterState,
            refreshActivePool: refreshActivePool,
            refreshProxyAddress: refreshProxyAddress,
            proxyFarm: proxyFarm,
            shouldUseProxyFarm: shouldUseProxyFarm
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ProxyFarmContainer));


/***/ }),

/***/ 90872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ YieldBoosterState; },
/* harmony export */   "Z": function() { return /* binding */ useYieldBoosterState; }
/* harmony export */ });
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97477);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44329);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80070);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22408);
/* harmony import */ var config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74551);
/* harmony import */ var _pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95923);
/* harmony import */ var views_Farms_hooks_useUserBoosterStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5862);
/* harmony import */ var views_Farms_hooks_useBCakeProxyContractAddress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80922);
/* harmony import */ var views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36668);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);










var YieldBoosterState;
(function(YieldBoosterState) {
    YieldBoosterState[YieldBoosterState["UNCONNECTED"] = 0] = "UNCONNECTED";
    YieldBoosterState[YieldBoosterState["NO_LOCKED"] = 1] = "NO_LOCKED";
    YieldBoosterState[YieldBoosterState["LOCKED_END"] = 2] = "LOCKED_END";
    YieldBoosterState[YieldBoosterState["NO_PROXY_CREATED"] = 3] = "NO_PROXY_CREATED";
    YieldBoosterState[YieldBoosterState["NO_MIGRATE"] = 4] = "NO_MIGRATE";
    YieldBoosterState[YieldBoosterState["NO_LP"] = 5] = "NO_LP";
    YieldBoosterState[YieldBoosterState["DEACTIVE"] = 6] = "DEACTIVE";
    YieldBoosterState[YieldBoosterState["ACTIVE"] = 7] = "ACTIVE";
    YieldBoosterState[YieldBoosterState["MAX"] = 8] = "MAX";
})(YieldBoosterState || (YieldBoosterState = {}));
function useIsPoolActive(pid) {
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useBCakeFarmBoosterContract */ .gh)();
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().account;
    var ref = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__/* .useSWRMulticall */ .d5)(config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_4__, [
        {
            address: farmBoosterContract.address,
            name: "isBoostedPool",
            params: [
                account,
                pid
            ]
        }
    ], {
        isPaused: function() {
            return !account;
        }
    }), data = ref.data, mutate = ref.mutate;
    return {
        isActivePool: Array.isArray(data) ? data[0][0] : false,
        refreshIsPoolActive: mutate
    };
}
function useYieldBoosterState(yieldBoosterStateArgs) {
    var farmPid = yieldBoosterStateArgs.farmPid;
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,views_Farms_hooks_useUserBoosterStatus__WEBPACK_IMPORTED_MODULE_5__/* .useUserBoosterStatus */ .p)(account), remainingCounts = ref1.remainingCounts, refreshActivePools = ref1.refreshActivePools;
    var ref2 = (0,views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_7__/* .useUserLockedCakeStatus */ .u)(), locked = ref2.locked, lockedEnd = ref2.lockedEnd;
    var ref3 = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useFarmUser */ .Dx)(farmPid), stakedBalance = ref3.stakedBalance, proxy = ref3.proxy;
    var ref4 = useIsPoolActive(farmPid), isActivePool = ref4.isActivePool, refreshIsPoolActive = ref4.refreshIsPoolActive;
    var ref5 = (0,views_Farms_hooks_useBCakeProxyContractAddress__WEBPACK_IMPORTED_MODULE_6__/* .useBCakeProxyContractAddress */ .A)(account, chainId), proxyCreated = ref5.proxyCreated, refreshProxyAddress = ref5.refreshProxyAddress, proxyAddress = ref5.proxyAddress;
    var refreshActivePool = (0,react__WEBPACK_IMPORTED_MODULE_8__.useCallback)(function() {
        refreshActivePools();
        refreshIsPoolActive();
    }, [
        refreshActivePools,
        refreshIsPoolActive
    ]);
    var state = null;
    if (!account || (0,_pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(locked)) {
        state = YieldBoosterState.UNCONNECTED;
    } else if (!locked && stakedBalance.eq(0)) {
        // NOTE: depend on useCakeVaultUserData in Farm Component to check state
        state = YieldBoosterState.NO_LOCKED;
    } else if (!proxyCreated) {
        state = YieldBoosterState.NO_PROXY_CREATED;
    } else if (stakedBalance.gt(0)) {
        state = YieldBoosterState.NO_MIGRATE;
    } else if (lockedEnd === "0" || new Date() > new Date(parseInt(lockedEnd) * 1000)) {
        // NOTE: duplicate logic in BCakeBoosterCard
        state = YieldBoosterState.LOCKED_END;
    } else if (proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.eq(0)) {
        state = YieldBoosterState.NO_LP;
    } else if (!isActivePool && remainingCounts === 0) {
        state = YieldBoosterState.MAX;
    } else if (isActivePool) {
        state = YieldBoosterState.ACTIVE;
    } else {
        state = YieldBoosterState.DEACTIVE;
    }
    return {
        state: state,
        shouldUseProxyFarm: proxyCreated && stakedBalance.eq(0),
        refreshActivePool: refreshActivePool,
        refreshProxyAddress: refreshProxyAddress,
        proxyAddress: proxyAddress
    };
}


/***/ }),

/***/ 17170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDisplayApr; }
/* harmony export */ });
var getDisplayApr = function(cakeRewardsApr, lpRewardsApr) {
    if (cakeRewardsApr && lpRewardsApr) {
        return (cakeRewardsApr + lpRewardsApr).toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    if (cakeRewardsApr) {
        return cakeRewardsApr.toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    return null;
};


/***/ }),

/***/ 5862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useUserBoosterStatus; }
/* harmony export */ });
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75759);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80070);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49770);




var useUserBoosterStatus = function(account) {
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_1__/* .useBCakeFarmBoosterContract */ .gh)();
    var ref = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("maxBoostFarm", function() {
        return farmBoosterContract.MAX_BOOST_POOL();
    }), MAX_BOOST_POOL = ref.data, maxBoostStatus = ref.status;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(account && [
        "activatedBoostFarm",
        [
            account
        ]
    ], function() {
        return farmBoosterContract.activedPools(account);
    }), activatedPools = ref1.data, status = ref1.status, mutate = ref1.mutate;
    var ref2, ref3, ref4, ref5;
    return {
        maxBoostCounts: (ref2 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref2 !== void 0 ? ref2 : 0,
        activatedPoolsCounts: (ref3 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref3 !== void 0 ? ref3 : 0,
        remainingCounts: ((ref4 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref4 !== void 0 ? ref4 : 0) - ((ref5 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref5 !== void 0 ? ref5 : 0),
        isLoading: maxBoostStatus !== config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .FetchStatus.Fetched */ .iF.Fetched || status !== config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .FetchStatus.Fetched */ .iF.Fetched,
        refreshActivePools: mutate
    };
};


/***/ }),

/***/ 36668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useUserLockedCakeStatus; }
/* harmony export */ });
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(203);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96470);


var useUserLockedCakeStatus = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var vaultPool = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useVaultPoolByKey */ .eB)(state_types__WEBPACK_IMPORTED_MODULE_1__/* .VaultKey.CakeVault */ .om.CakeVault);
    return {
        totalCakeInVault: vaultPool === null || vaultPool === void 0 ? void 0 : vaultPool.totalCakeInVault,
        totalLockedAmount: vaultPool === null || vaultPool === void 0 ? void 0 : vaultPool.totalLockedAmount,
        isLoading: vaultPool === null || vaultPool === void 0 ? void 0 : (ref = vaultPool.userData) === null || ref === void 0 ? void 0 : ref.isLoading,
        locked: Boolean(vaultPool === null || vaultPool === void 0 ? void 0 : (ref1 = vaultPool.userData) === null || ref1 === void 0 ? void 0 : ref1.locked),
        lockedEnd: vaultPool === null || vaultPool === void 0 ? void 0 : (ref2 = vaultPool.userData) === null || ref2 === void 0 ? void 0 : ref2.lockEndTime,
        lockedAmount: vaultPool === null || vaultPool === void 0 ? void 0 : (ref3 = vaultPool.userData) === null || ref3 === void 0 ? void 0 : ref3.lockedAmount,
        lockBalance: vaultPool === null || vaultPool === void 0 ? void 0 : (ref4 = vaultPool.userData) === null || ref4 === void 0 ? void 0 : ref4.balance,
        lockedStart: vaultPool === null || vaultPool === void 0 ? void 0 : (ref5 = vaultPool.userData) === null || ref5 === void 0 ? void 0 : ref5.lockStartTime
    };
};


/***/ }),

/***/ 93814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ FarmsContext; },
  "S": function() { return /* binding */ FarmsPageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(51998);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(76376);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(57714);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Search.tsx
var Search = __webpack_require__(19881);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(44142);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
;// CONCATENATED MODULE: ./src/components/Loading.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 8px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #ddd;\n  border-bottom: 8px solid #ddd;\n  width: 20px;\n  height: 20px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Loading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57089fde-0"
})(_templateObject());
/* harmony default export */ var components_Loading = (Loading);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(31282);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/components/ScrollToTopButton/ScrollToTopButtonV2.tsx

function ScrollToTopButtonV2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: 5%;\n  bottom: calc(110px + env(safe-area-inset-bottom));\n"
    ]);
    ScrollToTopButtonV2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FixedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-73995cbb-0"
})(ScrollToTopButtonV2_templateObject());
var ScrollToTopButton = function() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var scrollToTop = (0,react.useCallback)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(function() {
        var toggleVisible = function() {
            var scrolled = document.documentElement.scrollTop;
            if (scrolled > 500) {
                setVisible(true);
            } else if (scrolled <= 500) {
                setVisible(false);
            }
        };
        var throttledToggleVisible = throttle_default()(toggleVisible, 200);
        window.addEventListener("scroll", throttledToggleVisible);
        return function() {
            return window.removeEventListener("scroll", throttledToggleVisible);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContainer, {
        style: {
            display: visible ? "inline" : "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: 48,
            height: 48,
            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                color: "background",
                style: {
                    marginLeft: 0
                }
            }),
            onClick: scrollToTop,
            style: {
                background: "#494949"
            }
        })
    });
};
/* harmony default export */ var ScrollToTopButtonV2 = (ScrollToTopButton);

// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(23970);
;// CONCATENATED MODULE: ./src/hooks/useIntersectionObserver.ts



var useIntersectionObserver = function() {
    var ref = (0,react.useState)(null), observerRefElement = ref[0], setObserverRefElement = ref[1];
    var intersectionObserverRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isIntersecting = ref1[0], setIsIntersecting = ref1[1];
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var isSupported =  true && window.IntersectionObserver;
        if (isSupported) {
            if (!intersectionObserverRef.current && observerRefElement) {
                var checkObserverIsIntersecting = function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                    setIsIntersecting(entry.isIntersecting);
                };
                intersectionObserverRef.current = new window.IntersectionObserver(checkObserverIsIntersecting, {
                    rootMargin: "0px",
                    threshold: 1
                });
                intersectionObserverRef.current.observe(observerRefElement);
            }
            if (intersectionObserverRef.current && !observerRefElement) {
                intersectionObserverRef.current.disconnect();
                setIsIntersecting(false);
            }
        } else {
            // If client doesnt support IntersectionObserver, set Intersecting to be true
            setIsIntersecting(true);
        }
        return function() {
            if (intersectionObserverRef.current) {
                intersectionObserverRef.current.disconnect();
            }
        };
    }, [
        observerRefElement
    ]);
    return {
        observerRef: setObserverRefElement,
        isIntersecting: isIntersecting
    };
};
/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 3 modules
var hooks = __webpack_require__(44329);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 2 modules
var pools_hooks = __webpack_require__(203);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
;// CONCATENATED MODULE: ./src/config/constants/lpAprs/56.json
var _56_namespaceObject = JSON.parse('{"0xd33e50e444ec22998365aa443d1998e851fc5594":2.15,"0x6D810eB08FC6852b4a0e524944149154DAdba2b6":2.15,"0x0648ff5de80adf54aac07ece2490f50a418dde23":4.69,"0x0ed7e52944161450477ee417de9cd3a859b14fd0":2.15,"0x1472976e0b97f5b2fc93f1fff14e2b5c4447b64f":20.55,"0x1cc18962b919ef90085a8b21f8ddc95824fbad9e":6.93,"0x28ea5894d4dbbe90bb58ee3bab2869387d711c87":3.68,"0x2e28b9b74d6d99d4697e913b82b41ef1cac51c6c":0.98,"0x37ff7d4459ad96e0b01275e5efffe091f33c2cad":47.69,"0x3c2b7b578dd2175a1c3524aa0d515106282bf108":28.15,"0x3cd338c3bb249b6b3c55799f85a589febbbff9dd":3.36,"0x46c6ba71af7648cd7f67d0ad4d16f75be251ed12":7.21,"0x58f876857a02d6762e0101bb5c46a8c1ed44dc16":10.99,"0x6a445ceb72c8b1751755386c3990055ff92e14a0":22.32,"0x7b4682d2b3f8670b125af6aea8d7ed2daa43bdc1":22.31,"0x894bd57afd8efc93d9171cb585d11d0977557425":56.2,"0x89ebf9cd99864f6e51bd7a578965922029cab977":4.23,"0x92247860a03f48d5c6425c7ca35cdcfcb1013aa1":18.67,"0x9392a1f471d9aa14c0b8eb28bd7a3f4a814727be":12.05,"0x946696344e7d4346b223e1cf77035a76690d6a73":26.88,"0x9d2296e2fe3cdbf2eb3e3e2ca8811bafa42eedff":3.33,"0xb5d108578be3750209d1b3a8f45ffee8c5a75146":4.59,"0xb5e33fe13a821e55ed33c884589a804b1b4f6fd8":16.85,"0xc19dfd34d3ba5816df9cbdaa02d32a9f8dc6f6fc":83.74,"0xc2d00de94795e60fb76bc37d899170996cbda436":15.88,"0xcdb0016d97fd0e7ec2c3b78aa4786cbd8e19c14c":14.12,"0xdcfbb12ded3fea12d2a078bc6324131cd14bf835":6.78,"0xe267018c943e77992e7e515724b07b9ce7938124":2.13,"0xe834bf723f5bdff34a5d1129f3c31ea4787bc76a":10.73,"0xe8d5d81dac092ae61d097f84efe230759bf2e522":17.09,"0xf90baa331cfd40f094476e752bf272892170d399":47.98,"0xfdfde3af740a22648b9dd66d05698e5095940850":25.08,"0x04b56a5b3f45cfeafbfdcfc999c14be5434f2146":12.62,"0x222f93187f15f354d41ff6a7703ef7e18cdd5103":4.46,"0x24d3b0ed4c444a4f6882d527cbf67adc8c026582":4.45,"0x289841bfb694767bcb56fbc7b741ab4b4d97d490":5.13,"0x2a995d355d5df641e878c0f366685741fd18d004":1.2,"0x2d5db889392bc3c8b023a8631ca230a033eea1b8":7.75,"0x3c2c77353e2f6ac1578807b6b2336bf3a3cbb014":8.01,"0x3e19c18fe3458a6065d8f0844cb7eae52c9dae07":4.47,"0x3e4370204f598205998143f07ebcc486e441b456":4.17,"0x41f049d990d38305504631c9835f6f856bf1ba67":5.57,"0x48028de4a9b0d3d91180333d796021ec7757ba1b":14.8,"0x4dca4d427511bc327639b222da18fa5e334f686f":25.49,"0x547a355e70cd1f8caf531b950905af751dbef5e6":9.46,"0x6e98beb694ff1cdb1ee130edd2b21b0298683d58":8.75,"0x7275278c94b5e20708380561c4af98f38ddc6374":7.48,"0x7759283571da8c0928786a96ae601944e10461ff":33.32,"0x8853e3309a31583ea438f7704681f46f0d4d909b":2.15,"0x89ee0491ce55d2f7472a97602a95426216167189":3.08,"0x8b2824d57eebf07f5aff5c91fa67ed7c501a9f43":7.45,"0x8fa59693458289914db0097f5f366d771b7a7c3f":5.78,"0xa0387ebea6be90849c2261b911fbbd52b4c9eac4":11.17,"0xa39af17ce4a8eb807e076805da1e2b8ea7d0755b":15.23,"0xb87b857670a44356f2b70337e0f218713d2378e8":1.86,"0xb8b4383b49d451bbea63bc4421466e1086da6f18":30.55,"0xba01662e978de7d67f8ffc937726215eb8995d17":12.25,"0xd171b26e4484402de70e3ea256be5a2630d7e88d":1.37,"0xdfa808da5cfb9aba5fb3748ff85888f79174f378":9.79,"0xea26b78255df2bbc31c1ebf60010d78670185bd0":5.26,"0xec6557348085aa57c72514d67070dc863c0a5a8c":1.05,"0xef7767677867552cfa699148b96a03358a9be779":12.85,"0x0716725d78081a9e0e1ff81516f5415b399e274d":1.88,"0x1090c996fd1490d15dd7906322ee676a5cc3cf82":0.56,"0x1d94cb25895abd6ccfef863c53372bb462aa6b86":0.97,"0x2030845ce7d4224523fd2f03ca20afe4aad1d890":2.73,"0x226af4e918fcf3e62e5eeec867a3e78aaa7bb01d":42.8,"0x4d057f769d930eafd597b49d6fb2e1009a73a702":0.3,"0x4eafbf68a2d50291ffd163d4e00ad0f040aae707":0,"0x51bf99bbae59b67e5ce2fa9c17b683384773f8b3":113.75,"0x6045931e511ef7e53a4a817f971e0ca28c758809":12.37,"0x6a00e41561ac36a78dba1d09091b0f00c4e53724":3.47,"0x804678fa97d91b974ec2af3c843270886528a9e6":21.78,"0x8d3ff27d2ad6a9556b7c4f82f4d602d20114bc90":7.49,"0x8e04b3972b5c25766c681dfd30a8a1cbf6dcc8c1":8.39,"0xa4963b38b271c0d714593063497fc786fa4029ce":6.2,"0xac109c8025f272414fd9e2faa805a583708a017f":10.17,"0xb7cada0f120ca46745a024e6b9fe907b2fe10cf3":1.79,"0xbc7ac609fa730239190a70952e64ee1dfc2530ac":3.66,"0xbcf01a42f6bc42f3cfe81b05519565044d65d22a":1.58,"0xc20a92a1424b29b78dfaf92fd35d4cf8a06419b4":18.13,"0xc309a6d2f1537922e06f15aa2eb21caa1b2eedb6":7.69,"0xc74f7243766269dec5b85b0ef4af186e909c1b06":3.69,"0xcecfc2789af72ed151589a96a59f3a1abc65c3b5":5.5,"0xdaa89d335926628367b47852989bb22ee62ca5de":0,"0xdc7188ac11e124b1fa650b73ba88bf615ef15256":6.46,"0xea61020e5a128d2bec67d48f7cfbe3408db7e391":1.24,"0xec95ff6281c3ad8e27372fa6675eb337640b8e5e":0.56,"0xecf30fbecfa642012f54212a3be92eef1e48edac":14.52,"0xef5212ada83ec2cc105c409df10b8806d20e3b35":9.18,"0xf23bad605e94de0e3b60c9718a43a94a5af43915":1.46,"0xf74ee1e10e097dc326a2ad004f9cc95cb71088d3":2.19,"0x029d66f9c0469450b7b4834b8ddc6a1118cec3e1":16.63,"0x0362ba706dfe8ed12ec1470ab171d8dcb1c72b8d":1.37,"0x0604471c532f9febad3e37190b667f44bd0894b3":12,"0x123d475e13aa54a43a7421d94caa4459da021c77":4.83,"0x20c6de8983fb2d641c55004646aef40b4ea66e18":0.03,"0x2c624c9ecf16cb81ab85cc2c0b0c5e12a09afda6":1.16,"0x3e42c1f7239231e3752b507764445dd8e6a570d5":5.36,"0x4cc442220be1ce560c1f2573f8ca8f460b3e4172":10.19,"0x4fd6d315bef387fad2322fbc64368fc443f0886d":2.91,"0x510b29a93ebf098f3fc24a16541aaa0114d07056":5.86,"0x5a58609da96469e9def3fe344bc39b00d18eb9a5":6.26,"0x61010e6cba3b56ba47e9dfd56da682dacfe76131":18.25,"0x6615ce60d71513aa4849269dd63821d324a23f8c":4.86,"0x6a97867a4b7eb7646ffb1f359ad582e9903aa1c2":3.78,"0x7752e1fa9f3a2e860856458517008558deb989e3":28.26,"0x8046fa66753928f35f7db23ae0188ee6743c2fba":3.45,"0x81d776c90c89b8d51e9497d58338933127e2fa80":2.52,"0x8271d7eafeeb8f24d7c9fe1acce2ae20611972e5":9.16,"0x950fd020f8e4b8c57285ec7020b7a204348dadfa":6.11,"0x9730c791743300e9f984c9264395ce705a55da7c":13.91,"0xa7a0b605343df36b748ff4b5f7578b3f2d0651ce":11.79,"0xaa40f1ac20aafcfee8595da606d78c503c7e70a3":10.69,"0xd02da76c813b9cd4516ed50442923e625f90228f":35.58,"0xdc9a574b9b341d4a98ce29005b614e1e27430e74":2.82,"0xdde420cbb3794ebd8ffc3ac69f9c78e5d1411870":17.33,"0xe482249cd295c0d1e9d2baaee71e66de21024c68":4.68,"0xe6b421a4408c82381b226ab5b6f8c4b639044359":13.1,"0xf1ec67fa1881796bff63db3e1a301ce9cb787fad":5.04,"0xf45cd219aef8618a92baa7ad848364a158a24f33":4.67,"0xffd4b200d3c77a0b691b5562d804b3bd54294e6e":5.92,"0x13321acff4a27f3d2bca64b8beac6e5fdaaaf12c":4.43,"0x1434bb50196a0c7ea825940b1dfd8aad25d79817":12.08,"0x153ad7d25b0b810497483d0cee8af42fc533fec8":1,"0x16afc4f2ad82986bbe2a4525601f8199ab9c832d":4.82,"0x1f37d4226d23d09044b8005c127c0517bd7e94fd":5.73,"0x21dd71ab78ede3033c976948f769d506e4f489ee":10.49,"0x222c3cbb89647bf77822435bd4c234a04272a77a":11.28,"0x3578b1f9bce98d2f4d293b422d8850fdf48b1f21":13.67,"0x37908620def1491dd591b5a2d16022a33cdda415":2.68,"0x3f1a9f3d9aad8bd339ed4853f345d2ef89fbfe0c":11.18,"0x5afef8567414f29f0f927a0f2787b188624c10e2":19.09,"0x678edb8b268e73db57b7694c163e1dc296b6e219":4.51,"0x69dee989c30b5ffe40867f5fc14f00e4bce7b681":5.1,"0x6d0c831254221ba121fb53fb44df289a6558867d":5.45,"0x853784b7bde87d858555715c0123374242db7943":9.73,"0x856f9ad94ca8680b899214bb1eb3d235a3c33afe":17.67,"0x89666d026696660e93bf6edf57b71a68615768b7":7.15,"0x8e799cb0737525ceb8a6c6ad07f748535ff6377b":12.62,"0x8f6baf368e7a4f6e2c9c995f22702d5e654a0237":2.76,"0x942b294e59a8c47a0f7f20df105b082710f7c305":3.8,"0xa5bb44c6f5fd9b836e5a654c8abbccc96a15dee5":18,"0xa9986fcbdb23c2e8b11ab40102990a08f8e58f06":7.03,"0xc13aa76aac067c86ae38028019f414d731b3d86a":87.78,"0xc5768c5371568cf1114cddd52caed163a42626ed":14.62,"0xc7a9c2af263ebb86139cca9349e49b17129ba033":2.83,"0xcad7019d6d84a3294b0494aef02e73bd0f2572eb":11.66,"0xe094c686ad6cdda57b9564457f541fbf099b948a":10.73,"0xe60b4e87645093a42fa9dcc5d0c8df6e67f1f9d2":34.21,"0xe98585bbb2dc81854ff100a3d9d7b0f53e0dafed":5.21,"0xf3bc6fc080ffcc30d93df48bfa2aa14b869554bb":1.17,"0x014608e87af97a054c9a49f81e1473076d51d9a3":2.39,"0x05faf555522fa3f93959f86b41a3808666093210":2.57,"0x133ee93fe93320e1182923e1a640912ede17c90c":2.55,"0x1b415c3ec8095afbf9d78882b3a6263c4ad141b5":6.21,"0x1bdcebca3b93af70b58c41272aea2231754b23ca":4.97,"0x2354ef4df11afacb85a5c7f98b624072eccddbb1":1.74,"0x24eb18ba412701f278b172ef96697c4622b19da6":14.03,"0x356dd24bff8e23bde0430f00ad0c290e33438bd7":105.49,"0x4288706624e3dd839b069216eb03b8b9819c10d2":4.99,"0x44ea47f2765fd5d26b7ef0222736ad6fd6f61950":21.51,"0x460b4193ec4c1a17372aa5fdcd44c520ba658646":13.74,"0x468b2dc8dc75990ee3e9dc0648965ad6294e7914":4.08,"0x47c42b0a056a9c6e9c65b9ef79020af518e767a5":13.04,"0x66fdb2eccfb58cf098eaa419e5efde841368e489":1.08,"0x71b01ebddd797c8e9e0b003ea2f4fd207fbf46cc":4.53,"0x73566ca86248bd12f0979793e4671e99a40299a7":13.27,"0x7653d2c31440f04d2c6520d482dc5dbd7650f70a":14.86,"0x8645148de4e339964ba480ae3478653b5bc6e211":4.79,"0x91417426c3feaa3ca795921eb9fdd9715ad92537":1.85,"0xa3bfbbad526c6b856b1fdf73f99bcd894761fbf3":11.58,"0xb2678c414ebc63c9cc6d1a0fc45f43e249b50fde":7.66,"0xc05654c66756ebb82c518598c5f1ea1a0199a563":2.99,"0xc6b668548aa4a56792e8002a920d3159728121d5":13.83,"0xc869a9943b702b03770b6a92d2b2d25cf3a3f571":5.54,"0xcd68856b6e72e99b5eeaae7d41bb4a3b484c700d":25.46,"0xce383277847f8217392eea98c5a8b4a7d27811b0":7.74,"0xd63b5cecb1f40d626307b92706df357709d05827":8.55,"0xd8e2f8b6db204c405543953ef6359912fe3a88d6":5.47,"0xd9bccbbbdfd9d67beb5d2273102ce0762421d1e3":37.87,"0xec6b56a736859ae8ea4beda16279ecd8c60da7ea":1.91,"0x03f18135c44c64ebfdcbad8297fe5bdafdbbdd86":12.21,"0x168b273278f3a8d302de5e879aa30690b7e6c28f":3.36,"0x16b9a82891338f9ba80e2d6970fdda79d1eb0dae":14.51,"0x28415ff2c35b65b9e5c7de82126b4015ab9d031f":9.37,"0x3dcb1787a95d2ea0eb7d00887704eebf0d79bb13":10.75,"0x61eb789d75a95caa3ff50ed7e47b96c132fec082":3.26,"0x74e4716e431f45807dcf19f284c7aa99f18a4fbc":4.1,"0x7eb5d86fd78f3852a3e0e064f2842d45a3db6ea2":9.38,"0x7efaef62fddcca950418312c6c91aef321375a00":2.92,"0x824eb9fadfb377394430d2744fa7c42916de3ece":2.86,"0xacf47cbeaab5c8a6ee99263cfe43995f89fb3206":5.72,"0xb6e34b5c65eda51bb1bd4ea5f79d385fb94b9504":8.85,"0xdd5bad8f8b360d76d12fda230f8baf42fe0022cf":2.72,"0xB3C793C1470d49569A8d189a946dB5bdB7BB6E4B":0,"0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7":0,"0xB0225953a7de4384c28AdAb25Ba6A160D208Bd65":0}');
;// CONCATENATED MODULE: ./src/utils/apr.ts



var getLpApr = function(chainId) {
    switch(chainId){
        case 56:
            return _56_namespaceObject;
        default:
            return {};
    }
};
/**
 * Get the APR value in %
 * @param stakingTokenPrice Token price in the same quote currency
 * @param rewardTokenPrice Token price in the same quote currency
 * @param totalStaked Total amount of stakingToken in the pool
 * @param tokenPerBlock Amount of new cake allocated to the pool for each new block
 * @returns Null if the APR is NaN or infinite.
 */ var getPoolApr = function(stakingTokenPrice, rewardTokenPrice, totalStaked, tokenPerBlock) {
    var totalRewardPricePerYear = new BigNumber(rewardTokenPrice).times(tokenPerBlock).times(BLOCKS_PER_YEAR);
    var totalStakingTokenInPool = new BigNumber(stakingTokenPrice).times(totalStaked);
    var apr = totalRewardPricePerYear.div(totalStakingTokenInPool).times(100);
    return apr.isNaN() || !apr.isFinite() ? null : apr.toNumber();
};
/**
 * Get farm APR value in %
 * @param poolWeight allocationPoint / totalAllocationPoint
 * @param cakePriceUsd Cake price in USD
 * @param poolLiquidityUsd Total pool liquidity in USD
 * @param farmAddress Farm Address
 * @returns Farm Apr
 */ var getFarmApr = function(chainId, poolWeight, cakePriceUsd, poolLiquidityUsd, farmAddress, regularCakePerBlock) {
    // console.log(`poolWeight`, poolWeight.toNumber() , `cakePriceUsd`, cakePriceUsd.toNumber(), `poolLiquidityUsd`, poolLiquidityUsd.toNumber());
    var yearlyCakeRewardAllocation = config/* CAKE_PER_YEARV2.times */.Vd.times(poolWeight);
    var cakeRewardsApr = yearlyCakeRewardAllocation.times(cakePriceUsd).div(poolLiquidityUsd).times(100);
    var cakeRewardsAprAsNumber = null;
    if (!cakeRewardsApr.isNaN() && cakeRewardsApr.isFinite()) {
        cakeRewardsAprAsNumber = cakeRewardsApr.toNumber();
    }
    var ref;
    var lpRewardsApr = (ref = getLpApr(chainId)[farmAddress === null || farmAddress === void 0 ? void 0 : farmAddress.toLowerCase()]) !== null && ref !== void 0 ? ref : 0;
    return {
        cakeRewardsApr: cakeRewardsAprAsNumber,
        lpRewardsApr: lpRewardsApr
    };
};
/* harmony default export */ var apr = (null);

;// CONCATENATED MODULE: ./src/utils/latinise.ts
var Latinise = {
    latin_map: {
        τ: "t",
        Τ: "T"
    }
};
var latinise = function(input) {
    return input.replace(/[^A-Za-z0-9[\] ]/g, function(x) {
        return Latinise.latin_map[x] || x;
    });
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ListView.tsx
var ListView = __webpack_require__(93196);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CardView.tsx
var CardView = __webpack_require__(26154);
;// CONCATENATED MODULE: ./src/views/Farms/components/ToggleView.tsx

function ToggleView_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:120px;\n    justify-content: space-between;\n    align-items: center;\n"
    ]);
    ToggleView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 50px;\n    width: 50px;\n    border-radius: 0px;\n    background: ",
        ";\n    box-shadow:none;\n    border:none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ViewMode;
(function(ViewMode) {
    ViewMode["TABLE"] = "TABLE";
    ViewMode["CARD"] = "CARD";
})(ViewMode || (ViewMode = {}));
var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1eee6d56-0"
})(ToggleView_templateObject());
var ToggleView = function(param) {
    var viewMode = param.viewMode, onToggle = param.onToggle;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var handleToggle = function(mode) {
        if (viewMode !== mode) {
            onToggle(mode);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                isActive: viewMode === "TABLE" ? !false : false,
                scale: "sm",
                onClick: function() {
                    return handleToggle(ViewMode.TABLE);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListView/* default */.Z, {
                    color: viewMode === "TABLE" ? theme.colors.background : theme.colors.text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                isActive: viewMode === "CARD" ? !false : false,
                scale: "sm",
                onClick: function() {
                    return handleToggle(ViewMode.CARD);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardView/* default */.Z, {
                    color: viewMode === "CARD" ? theme.colors.background : theme.colors.text
                })
            })
        ]
    });
};
/* harmony default export */ var components_ToggleView = (ToggleView);
var IconButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1eee6d56-1"
})(_templateObject1(), function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.colors.text : "transparent";
});

// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTabButtons/index.tsx

function FarmTabButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200px;\n  @media only screen and (max-width: 600px){\n      width:100%;\n      margin-top:1.5rem;\n  }\n"
    ]);
    FarmTabButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmTabButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    align-items:center;\n    justify-content: center;\n    text-align: center;\n    height: 32px;\n    cursor: pointer;\n    font-size:18px;\n    background-color: transparent;\n    font-family: 'Marcellus', serif;\n    color: ",
        ";\n    border-bottom: 2px solid ",
        ";\n    @media screen and (max-width: 600px) {\n        width: 50%;\n    }\n"
    ]);
    FarmTabButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var FarmTabButtons = function(param) {
    var hasStakeInFinishedFarms = param.hasStakeInFinishedFarms;
    var handleClick = function handleClick(url) {
        window.location.href = url;
    };
    var router = (0,next_router.useRouter)();
    var t = (0,src/* useTranslation */.$G)().t;
    var handleStakeInFinishedOptionChange = function(option) {
        if (option.value === false) {
            router.push("/farms");
        }
        if (option.value) {
            router.push("/farms/history");
        }
    };
    var activeIndex;
    switch(router.pathname){
        case "/farms":
            activeIndex = 0;
            break;
        case "/farms/history":
            activeIndex = 1;
            break;
        case "/_mp/farms/history":
            activeIndex = 1;
            break;
        case "/farms/archived":
            activeIndex = 2;
            break;
        default:
            activeIndex = 0;
            break;
    }
    return(// <Wrapper>
    //   <Select
    //       options={[
    //           {
    //               label: t('Live'),
    //               value: false,
    //           },
    //           {
    //               label: t('Finished'),
    //               value: true,
    //           }
    //       ]}
    //       onChange={handleStakeInFinishedOptionChange}
    //         />
    // </Wrapper>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyTab, {
                isActive: activeIndex === 0 ? !false : false,
                as: NextLink/* NextLinkFromReactRouter */.a,
                to: "/farms",
                children: t("Live")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyTab, {
                isActive: activeIndex === 1,
                as: NextLink/* NextLinkFromReactRouter */.a,
                to: "/farms/history",
                children: t("Finished")
            })
        ]
    }));
};
/* harmony default export */ var components_FarmTabButtons = (FarmTabButtons);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ded8f5c-0"
})(FarmTabButtons_templateObject());
var StyTab = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-6ded8f5c-1"
})(FarmTabButtons_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.text : "none";
});

;// CONCATENATED MODULE: ./src/views/Farms/Farms.tsx




function Farms_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   display: flex;\n  width: 100%;\n  align-items: center;\n  position: relative;\n  box-sizing: border-box;\n  border-radius: 10px;\n  background:transparent;\n  justify-content: space-between;\n  flex-direction: column;\n  padding: 10px 20px;\n  ",
        " {\n    flex-direction: row;\n  }\n  \n  @media only screen and (max-width: 480px){\n    width: 100%;\n    padding-left:2px;\n    padding-right:2px;\n    justify-content: center;\n  }\n  @media only screen and (max-width: 768px){\n    justify-content: center;\n  }\n\n  @media only screen and (min-width: 481px) and (max-width: 1269px){\n    justify-content: center;\n    \n  }\n"
    ]);
    Farms_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Farms_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    height: 70px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap:wrap;\n    @media screen and (min-width: 600px) and (max-width: 1080px) {\n        width: 30%;\n        height: auto;\n    }\n    @media screen and (max-width: 600px) {\n        width: 100%;\n        height: auto;\n        margin-top:1rem;\n        justify-content: flex-start;\n    }\n"
    ]);
    Farms_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    height: 70px;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap:wrap;\n    @media screen and (min-width: 600px) and (max-width: 1080px) {\n        width: 70%;\n        height: auto;\n    }\n    @media screen and (max-width: 600px) {\n        width: 100%;\n        height: auto;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 58px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 32px;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  white-space: nowrap;\n  text-decoration: underline;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 305px;\n    border-radius:0px;\n    background: transparent !important;\n    border: 1px solid ",
        ";\n    > input {\n        background: transparent !important;\n        border: none;\n        height: 48px;\n    }\n    @media screen and (max-width: 600px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (max-width: 1280px) and (min-width: 600px) {\n       margin-bottom:60px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
























var ControlContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfc1a0aa-0"
})(Farms_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfc1a0aa-1"
})(Farms_templateObject1());
var ViewControls = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-2"
})(_templateObject2());
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-3"
})(_templateObject3());
var FinishedTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FinishedTextLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-5"
})(_templateObject5());
var CustomInputGroup = (0,styled_components_browser_esm/* default */.ZP)(InputGroup/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsFlexLayout = (0,styled_components_browser_esm/* default */.ZP)(Layout_Flex/* default */.Z).withConfig({
    componentId: "sc-dfc1a0aa-7"
})(_templateObject7());
var NUMBER_OF_FARMS_VISIBLE = 12;
var Farms = function(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, urlQuery = ref.query;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref1 = (0,hooks/* useFarms */.E2)(), farmsLP = ref1.data, userDataLoaded = ref1.userDataLoaded, poolLength = ref1.poolLength, regularCakePerBlock = ref1.regularCakePerBlock;
    // const cakePrice = usePriceRunBusd()
    var cakePrice = (0,hooks/* useTokenPriceWPi */.mf)();
    // const tmp = useTokenPriceWPi()
    // console.log("getTokenPriceWPi", tmp.toString())
    var ref2 = (0,react.useState)(""), _query = ref2[0], setQuery = ref2[1];
    var normalizedUrlSearch = (0,react.useMemo)(function() {
        return typeof (urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.search) === "string" ? urlQuery.search : "";
    }, [
        urlQuery
    ]);
    var query = normalizedUrlSearch && !_query ? normalizedUrlSearch : _query;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmsViewMode */.y9)(), 2), viewMode = ref3[0], setViewMode = ref3[1];
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref4 = (0,react.useState)("hot"), sortOption = ref4[0], setSortOption = ref4[1];
    var ref5 = hooks_useIntersectionObserver(), observerRef = ref5.observerRef, isIntersecting = ref5.isIntersecting;
    var chosenFarmsLength = (0,react.useRef)(0);
    var isArchived = pathname.includes("archived");
    var isInactive = pathname.includes("history");
    var isActive = !isInactive && !isArchived;
    (0,pools_hooks/* useCakeVaultUserData */.Es)();
    (0,hooks/* usePollFarmsWithUserData */.Cs)();
    // Users with no wallet connected should see 0 as Earned amount
    // Connected users should see loading indicator until first userData has loaded
    var userDataReady = !account || !!account && userDataLoaded;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmStakedOnly */.XD)(isActive), 2), stakedOnly = ref6[0], setStakedOnly = ref6[1];
    var ref7 = (0,react.useState)(false), boostedOnly = ref7[0], setBoostedOnly = ref7[1];
    var activeFarms = farmsLP.filter(function(farm) {
        return farm.multiplier !== "0X" && (!poolLength || poolLength > farm.pid);
    });
    var inactiveFarms = farmsLP.filter(function(farm) {
        return farm.multiplier === "0X";
    });
    var archivedFarms = farmsLP;
    var stakedOnlyFarms = activeFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0) || new bignumber/* default */.Z((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var stakedInactiveFarms = inactiveFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0) || new bignumber/* default */.Z((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var stakedArchivedFarms = archivedFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0) || new bignumber/* default */.Z((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var farmsList = (0,react.useCallback)(function(farmsToDisplay) {
        var farmsToDisplayWithAPR = farmsToDisplay.map(function(farm) {
            if (!farm.lpTotalInQuoteToken || !farm.quoteTokenPriceBusd) {
                return farm;
            }
            var totalLiquidity = new bignumber/* default */.Z(farm.lpTotalInQuoteToken).times(farm.quoteTokenPriceBusd);
            if (farm.pid === 0) {
                totalLiquidity = new bignumber/* default */.Z(farm.lpTotalInQuoteToken).times(184).times(farm.quoteTokenPriceBusd);
            }
            // console.log(`farm`, farm.lpTotalInQuoteToken.toNumber(),
            //  `price`, farm.quoteTokenPriceBusd
            //  , `totalLP`, totalLiquidity.toNumber() );
            var ref = isActive ? getFarmApr(chainId, new bignumber/* default */.Z(farm.poolWeight), cakePrice, totalLiquidity, farm.lpAddress, regularCakePerBlock) : {
                cakeRewardsApr: 0,
                lpRewardsApr: 0
            }, cakeRewardsApr = ref.cakeRewardsApr, lpRewardsApr = ref.lpRewardsApr;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                apr: cakeRewardsApr,
                lpRewardsApr: lpRewardsApr,
                liquidity: totalLiquidity
            });
        });
        if (query) {
            var lowercaseQuery = latinise(query.toLowerCase());
            farmsToDisplayWithAPR = farmsToDisplayWithAPR.filter(function(farm) {
                return latinise(farm.lpSymbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return farmsToDisplayWithAPR;
    }, [
        query,
        isActive,
        chainId,
        cakePrice,
        regularCakePerBlock
    ]);
    var handleChangeQuery = function(event) {
        setQuery(event.target.value);
    };
    var ref8 = (0,react.useState)(NUMBER_OF_FARMS_VISIBLE), numberOfFarmsVisible = ref8[0], setNumberOfFarmsVisible = ref8[1];
    var chosenFarms = (0,react.useMemo)(function() {
        var chosenFs = [];
        if (isActive) {
            chosenFs = stakedOnly ? farmsList(stakedOnlyFarms) : farmsList(activeFarms);
        }
        if (isInactive) {
            chosenFs = stakedOnly ? farmsList(stakedInactiveFarms) : farmsList(inactiveFarms);
        }
        if (isArchived) {
            chosenFs = stakedOnly ? farmsList(stakedArchivedFarms) : farmsList(archivedFarms);
        }
        if (boostedOnly) {
            chosenFs = chosenFs.filter(function(f) {
                return f.boosted;
            });
        }
        return chosenFs;
    }, [
        activeFarms,
        farmsList,
        inactiveFarms,
        archivedFarms,
        isActive,
        isInactive,
        isArchived,
        stakedArchivedFarms,
        stakedInactiveFarms,
        stakedOnly,
        stakedOnlyFarms,
        boostedOnly, 
    ]);
    var chosenFarmsMemoized = (0,react.useMemo)(function() {
        var sortFarms = function(farms) {
            switch(sortOption){
                case "apr":
                    return orderBy_default()(farms, function(farm) {
                        return farm.apr + farm.lpRewardsApr;
                    }, "desc");
                case "multiplier":
                    return orderBy_default()(farms, function(farm) {
                        return farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0;
                    }, "desc");
                case "earned":
                    return orderBy_default()(farms, function(farm) {
                        return farm.userData ? Number(farm.userData.earnings) : 0;
                    }, "desc");
                case "liquidity":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.liquidity);
                    }, "desc");
                case "latest":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.pid);
                    }, "desc");
                default:
                    return farms;
            }
        };
        return sortFarms(chosenFarms).slice(0, numberOfFarmsVisible);
    }, [
        chosenFarms,
        sortOption,
        numberOfFarmsVisible
    ]);
    chosenFarmsLength.current = chosenFarmsMemoized.length;
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setNumberOfFarmsVisible(function(farmsCurrentlyVisible) {
                if (farmsCurrentlyVisible <= chosenFarmsLength.current) {
                    return farmsCurrentlyVisible + NUMBER_OF_FARMS_VISIBLE;
                }
                return farmsCurrentlyVisible;
            });
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmsContext.Provider, {
        value: {
            chosenFarmsMemoized: chosenFarmsMemoized
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageFullWidth/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            mt: "1rem",
                            width: "100%",
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewControls, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ToggleView, {
                                            viewMode: viewMode,
                                            onToggle: function(mode) {
                                                return setViewMode(mode);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: "auto",
                                            style: {
                                                gap: "7px"
                                            },
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                    checked: stakedOnly,
                                                    onChange: function() {
                                                        return setStakedOnly(!stakedOnly);
                                                    },
                                                    scale: "lg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontSize: "18px",
                                                    children: "Staked only"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FarmTabButtons, {
                                            hasStakeInFinishedFarms: stakedInactiveFarms.length > 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputGroup, {
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                            width: "24px"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            placeholder: t("Search Farms"),
                                            onChange: handleChangeQuery
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    isInactive && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishedTextContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    " ",
                                    t("No Data"),
                                    " "
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexLayout, {
                        children: children
                    }),
                    account && !userDataLoaded && stakedOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loading, {})
                    }),
                    poolLength && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: observerRef
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButtonV2, {}), document.body)
        ]
    });
};
var FarmsContext = /*#__PURE__*/ (0,react.createContext)({
    chosenFarmsMemoized: []
});
/* harmony default export */ var Farms_Farms = (Farms);

;// CONCATENATED MODULE: ./src/views/Farms/index.tsx


var FarmsPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Farms_Farms, {
        children: children
    });
};



/***/ }),

/***/ 74551:
/***/ (function(module) {

module.exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"_cake","type":"address"},{"internalType":"address","name":"_cakePool","type":"address"},{"internalType":"address","name":"_v2","type":"address"},{"internalType":"uint256","name":"_max","type":"uint256"},{"internalType":"uint256","name":"_cA","type":"uint256"},{"internalType":"uint256","name":"_cB","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"ActiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"DeactiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"Refresh","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"factory","type":"address"}],"name":"UpdateBoostFactory","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"bool","name":"status","type":"bool"}],"name":"UpdateBoostFarms","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"}],"name":"UpdateBoostProxy","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCA","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCA","type":"uint256"}],"name":"UpdateCA","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCB","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCB","type":"uint256"}],"name":"UpdateCB","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"lockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockedDuration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalLockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxLockDuration","type":"uint256"}],"name":"UpdateCakePool","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"factory","type":"uint256"}],"name":"UpdateMaxBoostPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"oldMultiplier","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newMultiplier","type":"uint256"}],"name":"UpdatePoolBoostMultiplier","type":"event"},{"inputs":[],"name":"BOOSTER_FACTORY","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_RATIO_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_WEIGHT_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE_POOL","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CA_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MASTER_CHEF","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_POOL","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"activate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"activedPools","outputs":[{"internalType":"uint256[]","name":"pools","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"avgLockDuration","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"deactive","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"getUserMultiplier","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"isBoostedPool","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_lockedAmount","type":"uint256"},{"internalType":"uint256","name":"_lockedDuration","type":"uint256"},{"internalType":"uint256","name":"_totalLockedAmount","type":"uint256"},{"internalType":"uint256","name":"_maxLockDuration","type":"uint256"}],"name":"onCakePoolUpdate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"proxyContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"refresh","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_factory","type":"address"}],"name":"setBoostFactory","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"bool","name":"_status","type":"bool"}],"name":"setBoosterFarms","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cA","type":"uint256"}],"name":"setCA","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cB","type":"uint256"}],"name":"setCB","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_max","type":"uint256"}],"name":"setMaxBoostPool","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_proxy","type":"address"}],"name":"setProxy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"updatePoolBoostMultiplier","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userInfo","outputs":[{"internalType":"uint256","name":"size","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"whiteList","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}]');

/***/ })

}]);